import { Download, DownloadType, Platform } from '../../../common';
import { AdTypes, PlatformTypes } from 'UI-Dash-Commons-UI';
import { ApiManifest, ApiType } from '../types/Api';
import { ManifestItem } from "../components/common/ManifestBasedSelectorComponent";

export const STATE_MEDIATION_DOCS = 'mediation_docs';

export const ACTION_ON_UPDATE_ACTIVE_LANGUAGE = '@MediationDocs/ON_UPDATE_ACTIVE_LANGUAGE';
export const ACTION_ON_TOGGLE_CODE_SNIPPET_BACKGROUND_STYLE = '@MediationDocs/ON_TOGGLE_CODE_SNIPPET_BACKGROUND_STYLE';

export const MEDIATION_DOCS_CLIENT_BASE_URL = '/documentation/mediation';

export const ALL_PLATFORMS = ':platform(adobe-air|android|cordova|defold|flutter|godot|ios|react-native|unity|unreal)';

export const DOCS_LANDING_PAGE_PLATFORMS: Array<Platform> = [
    {
        alt: 'Android logo',
        displayName: 'Android',
        imageSrc: require( '../images/android.svg' ),
        url: '/documentation/mediation/android/getting-started'
    },
    {
        alt: 'iOS logo',
        displayName: 'iOS',
        imageSrc: require( '../images/ios.svg' ),
        url: '/documentation/mediation/ios/getting-started'
    },
    {
        alt: 'Adobe Air logo',
        displayName: 'Adobe AIR',
        imageSrc: require( '../images/adobe_air.svg' ),
        url: '/documentation/mediation/adobe-air/getting-started'
    },
    {
        alt: 'Cordova logo',
        displayName: 'Cordova',
        imageSrc: require( '../images/cordova.svg' ),
        url: '/documentation/mediation/cordova/getting-started'
    },
    {
        alt: 'Defold logo',
        displayName: 'Defold',
        imageSrc: require( '../images/defold.svg' ),
        url: '/documentation/mediation/defold/getting-started'
    },
    {
        alt: 'Flutter logo',
        displayName: 'Flutter',
        imageSrc: require( '../images/flutter.svg' ),
        url: '/documentation/mediation/flutter/getting-started'
    },
    {
        alt: 'Godot logo',
        displayName: 'Godot',
        imageSrc: require( '../images/godot.svg' ),
        url: '/documentation/mediation/godot/getting-started'
    },
    {
        alt: 'React Native logo',
        displayName: 'React Native',
        imageSrc: require( '../images/react_native.svg' ),
        url: '/documentation/mediation/react-native/getting-started'
    },
//    {
//        alt: 'Titanium logo',
//        displayName: 'Titanium',
//        imageSrc: require( '../images/titanium.svg' ),
//        url: 'https://github.com/AppLovin/AppLovin-MAX-Titanium/issues/2'
//    },
    {
        alt: 'Unity logo',
        displayName: 'Unity',
        imageSrc: require( '../images/unity.svg' ),
        url: '/documentation/mediation/unity/getting-started'
    },
    {
        alt: 'Unreal logo',
        displayName: 'Unreal',
        imageSrc: require( '../images/unreal.svg' ),
        url: '/documentation/mediation/unreal/getting-started'
    }
];

export const SDK_KEY_FALLBACK_COPY = 'YOUR_SDK_KEY_HERE';
export const SAFEDK_KEY_FALLBACK_COPY = 'YOUR_AD_REVIEW_KEY_HERE';
export const REDIRECT_TO_LOGIN_URL = "/docs/v1/login_redirect?redirectUrl=";

/*
 * Download.name values
 */
export enum MediatedNetworks
{
    ADMOB = 'ADMOB_NETWORK',
    AMAZON = 'AMAZON_MARKETPLACE_NETWORK',
    APPLOVIN = 'APPLOVIN_NETWORK',
    BIDMACHINE = 'BIDMACHINE_NETWORK',
    CHARTBOOST = 'CHARTBOOST_NETWORK',
    CSJ = 'CSJ_NETWORK',
    FACEBOOK = 'FACEBOOK_MEDIATE',
    FYBER = 'FYBER_NETWORK',
    GOOGLE = 'GOOGLE',
    GOOGLE_AD_MANAGER = 'GOOGLE_AD_MANAGER_NETWORK',
    HYPRMX = 'HYPRMX_NETWORK',
    INMOBI = 'INMOBI_NETWORK',
    IRONSOURCE = 'IRONSOURCE_NETWORK',
    JSTAG = 'JS_TAG_NETWORK',
    VUNGLE = 'VUNGLE_NETWORK',
    LINE = 'LINE_NETWORK',
    MAIO = 'MAIO_NETWORK',
    MINTEGRAL = 'MINTEGRAL_NETWORK',
    MOBILEFUSE = 'MOBILEFUSE_NETWORK',
    MOPUB = 'MOPUB_NETWORK',
    MYTARGET = 'MYTARGET_NETWORK',
    OGURY = 'OGURY_V2_NETWORK',
    OGURY_PRESAGE = 'OGURY_PRESAGE_NETWORK',
    SMAATO = 'SMAATO_NETWORK',
    TENCENT = 'TENCENT_NETWORK',
    TIKTOK = 'TIKTOK_NETWORK',
    UNITY = 'UNITY_NETWORK',
    VERVE = 'VERVE_NETWORK',
    YANDEX = 'YANDEX_NETWORK',
}

export const DEFAULT_APPLOVIN_DEFINITION: ManifestItem = {
    displayName: 'AppLovin',
    name: MediatedNetworks.APPLOVIN,
    isDisabled: true,
    isChecked: true,
    extras: {
        iOSRequireSKAdnetwork: true
    }
}

export type NetworkMinimumVersion = {
    networkName: string,
    version: string
}

export const MINIMUM_ADAPTER_VERSIONS: Array<NetworkMinimumVersion> = [
    {
        networkName: MediatedNetworks.AMAZON,
        version: '6.0.0.0',
    },
    {
        networkName: MediatedNetworks.BIDMACHINE,
        version: '1.9.4.1.1',
    },
    {
        networkName: MediatedNetworks.CHARTBOOST,
        version: '8.3.1.1',
    },
    {
        networkName: MediatedNetworks.FACEBOOK,
        version: '6.2.1.0',
    },
    {
        networkName: MediatedNetworks.FYBER,
        version: '7.7.1.0',
    },
    {
        networkName: MediatedNetworks.GOOGLE_AD_MANAGER,
        version: '7.65.0.0',
    },
    {
        networkName: MediatedNetworks.ADMOB,
        version: '7.65.0.0',
    },
    {
        networkName: MediatedNetworks.HYPRMX,
        version: '5.4.3.2',
    },
    {
        networkName: MediatedNetworks.INMOBI,
        version: '9.1.0.1',
    },
    {
        networkName: MediatedNetworks.IRONSOURCE,
        version: '7.0.1.0.1',
    },
    {
        networkName: MediatedNetworks.VUNGLE,
        version: '6.8.1.2',
    },
    {
        networkName: MediatedNetworks.MAIO,
        version: '1.5.5.0',
    },
    {
        networkName: MediatedNetworks.MINTEGRAL,
        version: '6.6.6.0.0',
    },
    {
        networkName: MediatedNetworks.MOBILEFUSE,
        version: '1.3.0.0',
    },
    {
        networkName: MediatedNetworks.MYTARGET,
        version: '5.9.4.1',
    },
    {
        networkName: MediatedNetworks.TIKTOK,
        version: '3.3.6.2.0',
    },
    {
        networkName: MediatedNetworks.SMAATO,
        version: '21.6.6.0',
    },
    {
        networkName: MediatedNetworks.TENCENT,
        version: '4.11.12.0',
    },
    {
        networkName: MediatedNetworks.UNITY,
        version: '3.5.1.1',
    },
    {
        networkName: MediatedNetworks.YANDEX,
        version: '2.20.0.0',
    },
]

/*
 * For "Download" structuree, see .../src/common/types/Download.ts
 */
export const DOCS_LANDING_PAGE_DOWNLOADS: Array<Download> = [
/** Adobe AIR Extension **/
    { // Adobe AIR Extension / Adobe AIR
        displayName: 'Adobe AIR Extension',
        name: 'sdk-adobe-air',
        platform: PlatformTypes.ADOBE_AIR,
        type: DownloadType.SDK,
    },
/** Amazon **/
    { // Amazon / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/AmazonAdMarketplace/CHANGELOG.md',
        displayName: 'Amazon *',
        extras: {
            androidAmazonInitialize: true,
        },
        guideUrl: '/documentation/mediation/android/mediation-setup/amazon',
        name: MediatedNetworks.AMAZON,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Amazon / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/AmazonAdMarketplace/CHANGELOG.md',
        displayName: 'Amazon',
        extras: {
            iOSAmazonInitialize: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/amazon',
        name: MediatedNetworks.AMAZON,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Amazon / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/AmazonAdMarketplace/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/AmazonAdMarketplace/CHANGELOG.md',
        displayName: 'Amazon',
        guideUrl: '/documentation/mediation/unity/mediation-setup/amazon',
        name: MediatedNetworks.AMAZON,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Android SDK **/
    { // Android SDK / Android
        displayName: 'Android SDK',
        name: 'sdk-android',
        platform: PlatformTypes.ANDROID,
        type: DownloadType.SDK,
    },
/** BidMachine **/
    { // BidMachine / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/BidMachine/CHANGELOG.md',
        displayName: 'BidMachine',
        guideUrl: '/documentation/mediation/android/mediation-setup/bidmachine',
        headerCode: `    maven { url "https://artifactory.bidmachine.io/bidmachine" }`,
        name: MediatedNetworks.BIDMACHINE,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // BidMachine / Cordova
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/BidMachine/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/BidMachine/CHANGELOG.md',
        displayName: 'BidMachine',
        guideUrl: '/documentation/mediation/cordova/mediation-setup/bidmachine',
        headerCode: `    maven { url "https://artifactory.bidmachine.io/bidmachine" }`,
        name: MediatedNetworks.BIDMACHINE,
        platform: PlatformTypes.CORDOVA,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // BidMachine / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/BidMachine/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/BidMachine/CHANGELOG.md',
        manifestCode: `            maven { url "https://artifactory.bidmachine.io/bidmachine" }`,
        displayName: 'BidMachine',
        guideUrl: '/documentation/mediation/defold/mediation-setup/bidmachine',
        headerCode: `    <insertValue value="com.applovin.mediation,bidmachine-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.BIDMACHINE,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // BidMachine / Flutter
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/BidMachine/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/BidMachine/CHANGELOG.md',
        displayName: 'BidMachine',
        guideUrl: '/documentation/mediation/flutter/mediation-setup/bidmachine',
        headerCode: `    maven { url "https://artifactory.bidmachine.io/bidmachine" }`,
        name: MediatedNetworks.BIDMACHINE,
        platform: PlatformTypes.FLUTTER,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // BidMachine / Godot
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/BidMachine/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/BidMachine/CHANGELOG.md',
        displayName: 'BidMachine',
        guideUrl: '/documentation/mediation/godot/mediation-setup/bidmachine',
        headerCode: `    maven { url "https://artifactory.bidmachine.io/bidmachine" }`,
        name: MediatedNetworks.BIDMACHINE,
        platform: PlatformTypes.GODOT,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // BidMachine / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/BidMachine/CHANGELOG.md',
        displayName: 'BidMachine',
        guideUrl: '/documentation/mediation/ios/mediation-setup/bidmachine',
        name: MediatedNetworks.BIDMACHINE,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // BidMachine / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/BidMachine/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/BidMachine/CHANGELOG.md',
        displayName: 'BidMachine',
        guideUrl: '/documentation/mediation/unity/mediation-setup/bidmachine',
        headerCode: `    maven { url "https://artifactory.bidmachine.io/bidmachine" }`,
        name: MediatedNetworks.BIDMACHINE,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // BidMachine / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/BidMachine/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/BidMachine/CHANGELOG.md',
        manifestCode: `            maven { url "https://artifactory.bidmachine.io/bidmachine" }`,
        displayName: 'BidMachine',
        guideUrl: '/documentation/mediation/unreal/mediation-setup/bidmachine',
        headerCode: `    <insertValue value="com.applovin.mediation,bidmachine-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.BIDMACHINE,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Chartboost **/
    { // Chartboost / iOS
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Chartboost/CHANGELOG.md',
        displayName: 'Chartboost',
        extras: {
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/chartboost',
        name: MediatedNetworks.CHARTBOOST,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Chartboost / Android
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Chartboost/CHANGELOG.md',
        displayName: 'Chartboost *',
        guideUrl: '/documentation/mediation/android/mediation-setup/chartboost',
        headerCode: `    maven { url "https://cboost.jfrog.io/artifactory/chartboost-ads/" }`,
        name: MediatedNetworks.CHARTBOOST,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Chartboost / Defold
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Chartboost/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Chartboost/CHANGELOG.md',
        displayName: 'Chartboost',
        extras: { },
        guideUrl: '/documentation/mediation/defold/mediation-setup/chartboost',
        headerCode: `    <insertValue value="com.applovin.mediation,chartboost-adapter,+" /> <insertNewline/>`,
        manifestCode: `            maven { url "https://cboost.jfrog.io/artifactory/chartboost-ads/" }`,
        name: MediatedNetworks.CHARTBOOST,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Chartboost / Unity
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Chartboost/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Chartboost/CHANGELOG.md',
        displayName: 'Chartboost',
        guideUrl: '/documentation/mediation/unity/mediation-setup/chartboost',
        name: MediatedNetworks.CHARTBOOST,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Chartboost / Unreal
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Chartboost/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Chartboost/CHANGELOG.md',
        displayName: 'Chartboost',
        extras: {
            // unrealAarImports: true,
        },
        guideUrl: '/documentation/mediation/unreal/mediation-setup/chartboost',
        headerCode: `    <insertValue value="com.applovin.mediation,chartboost-adapter,+" /> <insertNewline/>`,
        manifestCode: `            maven { url "https://cboost.jfrog.io/artifactory/chartboost-ads/" }`,
        name: MediatedNetworks.CHARTBOOST,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** CSJ **/
    { // CSJ / iOS
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/CSJ/CHANGELOG.md',
        displayName: 'CSJ',
        guideUrl: '/documentation/mediation/ios/mediation-setup/csj',
        name: MediatedNetworks.CSJ,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // CSJ / Unity
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/CSJ/CHANGELOG.md',
        displayName: 'CSJ',
        guideUrl: '/documentation/mediation/unity/mediation-setup/csj',
        name: MediatedNetworks.CSJ,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Defold Plugin **/
    { // Defold Plugin / Defold
        displayName: 'Defold Plugin',
        name: 'sdk-defold',
        platform: PlatformTypes.DEFOLD,
        type: DownloadType.SDK,
    },
/** DT Exchange **/
    { // DT Exchange / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Fyber/CHANGELOG.md',
        displayName: 'DT Exchange',
        guideUrl: '/documentation/mediation/android/mediation-setup/fyber-marketplace',
        name: MediatedNetworks.FYBER,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // DT Exchange / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Fyber/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Fyber/CHANGELOG.md',
        displayName: 'DT Exchange',
        guideUrl: '/documentation/mediation/defold/mediation-setup/fyber-marketplace',
        headerCode: `    <insertValue value="com.applovin.mediation,fyber-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.FYBER,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // DT Exchange / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Fyber/CHANGELOG.md',
        displayName: 'DT Exchange',
        extras: {
            iOSRequiresNoAts: false,
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/fyber-marketplace',
        name: MediatedNetworks.FYBER,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // DT Exchange / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Fyber/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Fyber/CHANGELOG.md',
        displayName: 'DT Exchange',
        guideUrl: '/documentation/mediation/unity/mediation-setup/fyber-marketplace',
        name: MediatedNetworks.FYBER,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // DT Exchange / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Fyber/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Fyber/CHANGELOG.md',
        displayName: 'DT Exchange',
        guideUrl: '/documentation/mediation/unreal/mediation-setup/fyber-marketplace',
        headerCode: `    <insertValue value="com.applovin.mediation,fyber-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.FYBER,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Google AdMob **/
    { // Google AdMob / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Google/CHANGELOG.md',
        displayName: 'Google bidding and Google AdMob *†',
        extras: {
            androidMigrateToAndroidX: true,
            androidAdmobRequireAppId: true,
            androidManifestMergingError: true,
            androidTargetVersion31: true
        },
        guideUrl: '/documentation/mediation/android/mediation-setup/admob',
        name: MediatedNetworks.ADMOB,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Google AdMob / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Google/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Google/CHANGELOG.md',
        displayName: 'Google bidding and Google AdMob',
        extras: {
            unrealAndroidAdmobRequireAppId: true,
            unrealAndroidManifestMergingError: true
        },
        guideUrl: '/documentation/mediation/defold/mediation-setup/admob',
        headerCode: `    <insertValue value="com.applovin.mediation,google-adapter,+@aar" /> <insertNewline/>
    <insertValue value="com.google.android.gms,play-services-ads,22.3.0" /> <insertNewline/>`,
        name: MediatedNetworks.ADMOB,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Google AdMob / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Google/CHANGELOG.md',
        displayName: 'Google bidding and Google AdMob *',
        extras: {
            iOSRequiresNoAts: true,
            iOSAdmobRequireAppId: true,
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/admob',
        name: MediatedNetworks.ADMOB,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Google AdMob / Unity
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Google/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Google/CHANGELOG.md',
        displayName: 'Google bidding and Google AdMob',
        extras: {
            [ PlatformTypes.IOS ]: {
                unityIOSAdmobRequireAppId: true,
            },
            [ PlatformTypes.ANDROID ]: {
                unityAndroidAdmobRequireAppId: true,
                unityAndroidManifestMergingError: true,
                androidTargetVersion31: true
            }
        },
        guideUrl: '/documentation/mediation/unity/mediation-setup/admob',
        name: MediatedNetworks.ADMOB,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Google AdMob / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Google/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Google/CHANGELOG.md',
        displayName: 'Google bidding and Google AdMob',
        extras: {
            // unrealAarImports: true,
            unrealAndroidAdmobRequireAppId: true,
            unrealAndroidManifestMergingError: true
        },
        guideUrl: '/documentation/mediation/unreal/mediation-setup/admob',
        headerCode: `    <insertValue value="com.applovin.mediation,google-adapter,+@aar" /> <insertNewline/>
    <insertValue value="com.google.android.gms,play-services-ads,22.3.0" /> <insertNewline/>`,
        name: MediatedNetworks.ADMOB,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Google Ad Manager **/
    { // Google Ad Manager / Android
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/GoogleAdManager/CHANGELOG.md',
        displayName: 'Google Ad Manager',
        extras: {
            androidMigrateToAndroidX: true,
            androidAdmobRequireAppId: true,
            androidGoogleAdManagerEnableSnippet: true,
            androidTargetVersion31: true
        },
        guideUrl: '',
        name: MediatedNetworks.GOOGLE_AD_MANAGER,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // Google Ad Manager / Defold
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/GoogleAdManager/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/GoogleAdManager/CHANGELOG.md',
        displayName: 'Google Ad Manager',
        extras: {
            unrealGoogleAdManager: true,
        },
        guideUrl: '',
        headerCode: `    <insertValue value="com.applovin.mediation,google-ad-manager-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.GOOGLE_AD_MANAGER,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Google Ad Manager / iOS
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/GoogleAdManager/CHANGELOG.md',
        displayName: 'Google Ad Manager',
        extras: {
            iOSRequiresNoAts: true,
            iOSAdmobRequireAppId: true,
            iOSGoogleAdManagerEnableSnippet: true,
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '',
        name: MediatedNetworks.GOOGLE_AD_MANAGER,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // Google Ad Manager / Unity
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/GoogleAdManager/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/GoogleAdManager/CHANGELOG.md',
        displayName: 'Google Ad Manager',
        extras: {
            [ PlatformTypes.ANDROID ]: {
                androidTargetVersion31: true
            }
        },
        guideUrl: '',
        name: MediatedNetworks.GOOGLE_AD_MANAGER,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Google Ad Manager / Unreal
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/GoogleAdManager/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/GoogleAdManager/CHANGELOG.md',
        displayName: 'Google Ad Manager',
        extras: {
            // unrealAarImports: true,
            unrealGoogleAdManager: true,
        },
        guideUrl: '',
        headerCode: `    <insertValue value="com.applovin.mediation,google-ad-manager-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.GOOGLE_AD_MANAGER,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** HyprMX **/
    { // HyprMX / Android
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/HyprMX/CHANGELOG.md',
        displayName: 'HyprMX',
        guideUrl: '/documentation/mediation/android/mediation-setup/hyprmx',
        name: MediatedNetworks.HYPRMX,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // HyprMX / Defold
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/HyprMX/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/HyprMX/CHANGELOG.md',
        displayName: 'HyprMX',
        guideUrl: '/documentation/mediation/defold/mediation-setup/hyprmx',
        headerCode: `    <insertValue value="com.applovin.mediation,hyprmx-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.HYPRMX,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // HyprMX / iOS
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/HyprMX/CHANGELOG.md',
        displayName: 'HyprMX',
        extras: {
            iOSRequiresNoAts: true,
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/hyprmx',
        name: MediatedNetworks.HYPRMX,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // HyprMX / Unity
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/HyprMX/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/HyprMX/CHANGELOG.md',
        displayName: 'HyprMX',
        guideUrl: '/documentation/mediation/unity/mediation-setup/hyprmx',
        name: MediatedNetworks.HYPRMX,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // HyprMX / Unreal
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/HyprMX/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/HyprMX/CHANGELOG.md',
        displayName: 'HyprMX',
        guideUrl: '/documentation/mediation/unreal/mediation-setup/hyprmx',
        headerCode: `    <insertValue value="com.applovin.mediation,hyprmx-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.HYPRMX,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** InMobi **/
    { // InMobi / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/InMobi/CHANGELOG.md',
        displayName: 'InMobi',
        extras: {
            androidManifestMergingError: true,
        },
        guideUrl: '/documentation/mediation/android/mediation-setup/inmobi',
        name: MediatedNetworks.INMOBI,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // InMobi / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/InMobi/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/InMobi/CHANGELOG.md',
        displayName: 'InMobi',
        extras: {
            unrealAndroidManifestMergingError: true,
        },
        guideUrl: '/documentation/mediation/defold/mediation-setup/inmobi',
        headerCode: `    <insertValue value="com.applovin.mediation,inmobi-adapter,+" /> <insertNewline/>
    <insertValue value="androidx.recyclerview,recyclerview,1.1.0" /> <insertNewline/>
    <insertValue value="com.squareup.picasso,picasso,2.71828" /> <insertNewline/>`,
        name: MediatedNetworks.INMOBI,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // InMobi / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/InMobi/CHANGELOG.md',
        displayName: 'InMobi',
        extras: {
            iOSRequiresNoAts: true,
            iOSRequiresAppDelegateWindow: true,
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/inmobi',
        name: MediatedNetworks.INMOBI,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // InMobi / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/InMobi/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/InMobi/CHANGELOG.md',
        displayName: 'InMobi',
        extras: {
            [ PlatformTypes.ANDROID ]: {
                unityAndroidManifestMergingError: true,
            },
        },
        guideUrl: '/documentation/mediation/unity/mediation-setup/inmobi',
        name: MediatedNetworks.INMOBI,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // InMobi / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/InMobi/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/InMobi/CHANGELOG.md',
        displayName: 'InMobi',
        extras: {
            unrealAndroidManifestMergingError: true,
        },
        guideUrl: '/documentation/mediation/unreal/mediation-setup/inmobi',
        headerCode: `    <insertValue value="com.applovin.mediation,inmobi-adapter,+" /> <insertNewline/>
    <insertValue value="androidx.recyclerview,recyclerview,1.1.0" /> <insertNewline/>
    <insertValue value="com.squareup.picasso,picasso,2.71828" /> <insertNewline/>`,
        name: MediatedNetworks.INMOBI,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
/** iOS SDK **/
    { // iOS SDK / iOS
        name: 'sdk-ios',
        displayName: 'iOS SDK',
        type: DownloadType.SDK,
        platform: PlatformTypes.IOS,
    },
/** IronSource **/
    { // IronSource / Android
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/IronSource/CHANGELOG.md',
        displayName: 'IronSource',
        guideUrl: '/documentation/mediation/android/mediation-setup/ironsource',
        headerCode: `    maven { url "https://android-sdk.is.com" }`,
        name: MediatedNetworks.IRONSOURCE,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // IronSource / Defold
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/IronSource/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/IronSource/CHANGELOG.md',
        manifestCode: `            maven { url "https://android-sdk.is.com" }`,
        displayName: 'IronSource',
        guideUrl: '/documentation/mediation/defold/mediation-setup/ironsource',
        headerCode: `    <insertValue value="com.applovin.mediation,ironsource-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.IRONSOURCE,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // IronSource / iOS
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/IronSource/CHANGELOG.md',
        bidding: false,
        displayName: 'IronSource',
        extras: {
            iOSRequiresNoAts: true,
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/ironsource',
        name: MediatedNetworks.IRONSOURCE,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // IronSource / Unity
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/IronSource/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/IronSource/CHANGELOG.md',
        displayName: 'IronSource',
        guideUrl: '/documentation/mediation/unity/mediation-setup/ironsource',
        name: MediatedNetworks.IRONSOURCE,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // IronSource / Unreal
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/IronSource/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/IronSource/CHANGELOG.md',
        manifestCode: `            maven { url "https://android-sdk.is.com" }`,
        displayName: 'IronSource',
        guideUrl: '/documentation/mediation/unreal/mediation-setup/ironsource',
        headerCode: `    <insertValue value="com.applovin.mediation,ironsource-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.IRONSOURCE,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** LINE **/
    { // LINE / Android
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Line/CHANGELOG.md',
        displayName: 'LINE',
        guideUrl: '/documentation/mediation/android/mediation-setup/line',
        name: MediatedNetworks.LINE,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // LINE / Cordova
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Line/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Line/CHANGELOG.md',
        displayName: 'LINE',
        guideUrl: '/documentation/mediation/cordova/mediation-setup/line',
        name: MediatedNetworks.LINE,
        platform: PlatformTypes.CORDOVA,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // LINE / Defold
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Line/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Line/CHANGELOG.md',
        displayName: 'LINE',
        extras: { },
        name: MediatedNetworks.LINE,
        guideUrl: '/documentation/mediation/defold/mediation-setup/line',
        headerCode: `    <insertValue value="com.applovin.mediation,line-adapter,+" /> <insertNewline/>`,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // LINE / Flutter
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Line/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Line/CHANGELOG.md',
        displayName: 'LINE',
        guideUrl: '/documentation/mediation/flutter/mediation-setup/line',
        name: MediatedNetworks.LINE,
        type: DownloadType.ADAPTER,
        platform: PlatformTypes.FLUTTER,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
    },
    { // LINE / Godot
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Line/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Line/CHANGELOG.md',
        displayName: 'LINE',
        guideUrl: '/documentation/mediation/godot/mediation-setup/line',
        name: MediatedNetworks.LINE,
        type: DownloadType.ADAPTER,
        platform: PlatformTypes.GODOT,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
    },
    { // LINE  / iOS
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Line/CHANGELOG.md',
        displayName: 'LINE',
        guideUrl: '/documentation/mediation/ios/mediation-setup/line',
        name: MediatedNetworks.LINE,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // LINE / React Native
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Line/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Line/CHANGELOG.md',
        displayName: 'LINE',
        guideUrl: '/documentation/mediation/react-native/mediation-setup/line',
        name: MediatedNetworks.LINE,
        platform: PlatformTypes.REACT_NATIVE,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // LINE / Unity
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Line/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Line/CHANGELOG.md',
        displayName: 'LINE',
        guideUrl: '/documentation/mediation/unity/mediation-setup/line',
        name: MediatedNetworks.LINE,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // LINE / Unreal
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Line/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Line/CHANGELOG.md',
        displayName: 'LINE',
        extras: {
            // unrealAarImports: true,
        },
        name: MediatedNetworks.LINE,
        guideUrl: '/documentation/mediation/unreal/mediation-setup/line',
        headerCode: `    <insertValue value="com.applovin.mediation,line-adapter,+" /> <insertNewline/>`,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Maio **/
    { // Maio / Android
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Maio/CHANGELOG.md',
        displayName: 'Maio',
        guideUrl: '/documentation/mediation/android/mediation-setup/maio',
        headerCode: `    maven { url "https://imobile-maio.github.io/maven" }`,
        name: MediatedNetworks.MAIO,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Maio / Defold
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Maio/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Maio/CHANGELOG.md',
        manifestCode: `            maven { url "https://imobile-maio.github.io/maven" }`,
        displayName: 'Maio',
        guideUrl: '/documentation/mediation/defold/mediation-setup/maio',
        headerCode: `    <insertValue value="com.applovin.mediation,maio-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.MAIO,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Maio / iOS
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Maio/CHANGELOG.md',
        displayName: 'Maio',
        extras: {
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/maio',
        name: MediatedNetworks.MAIO,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Maio / Unity
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Maio/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Maio/CHANGELOG.md',
        displayName: 'Maio',
        guideUrl: '/documentation/mediation/unity/mediation-setup/maio',
        name: MediatedNetworks.MAIO,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Maio / Unreal
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Maio/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Maio/CHANGELOG.md',
        manifestCode: `            maven { url "https://imobile-maio.github.io/maven" }`,
        displayName: 'Maio',
        guideUrl: '/documentation/mediation/unreal/mediation-setup/maio',
        headerCode: `    <insertValue value="com.applovin.mediation,maio-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.MAIO,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Meta **/
    { // Meta / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Facebook/CHANGELOG.md',
        displayName: 'Meta Audience Network',
        extras: {
            androidRequireCleartext: false,
            unityFacebookCCPA: true,
            androidFacebookCCPA: true,
        },
        guideUrl: '/documentation/mediation/android/mediation-setup/facebook',
        name: MediatedNetworks.FACEBOOK,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // Meta / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Facebook/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Facebook/CHANGELOG.md',
        displayName: 'Meta Audience Network',
        extras: {
            unrealFacebookCCPASnippet: true,
            unrealAndroidManifestMergingError: true
        },
        guideUrl: '/documentation/mediation/defold/mediation-setup/facebook',
        headerCode: `    <insertValue value="com.applovin.mediation,facebook-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.FACEBOOK,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Meta / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Facebook/CHANGELOG.md',
        displayName: 'Meta Audience Network',
        extras: {
            unityFacebookCCPA: true,
            iOSFacebookCCPA: true,
            iOSRequireSKAdnetwork: true,
            iOSSwiftRequirements: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/facebook',
        name: MediatedNetworks.FACEBOOK,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // Meta / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Facebook/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Facebook/CHANGELOG.md',
        displayName: 'Meta Audience Network',
        extras: {
            [ PlatformTypes.ANDROID ]: {
                androidRequireCleartext: false,
                unityFacebookSdkMigration: true,
                unityFacebookCCPA: true,
                unityFacebookCCPASnippet: true,
            },
            [ PlatformTypes.IOS ]: {
                unityFacebookSdkMigration: true,
                unityFacebookCCPA: true,
                unityFacebookCCPASnippet: true,
            }
        },
        guideUrl: '/documentation/mediation/unity/mediation-setup/facebook',
        name: MediatedNetworks.FACEBOOK,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Meta / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Facebook/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Facebook/CHANGELOG.md',
        displayName: 'Meta Audience Network',
        extras: {
            unrealFacebookCCPASnippet: true,
            unrealAndroidManifestMergingError: true
        },
        guideUrl: '/documentation/mediation/unreal/mediation-setup/facebook',
        headerCode: `    <insertValue value="com.applovin.mediation,facebook-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.FACEBOOK,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Mintegral **/
    { // Mintegral / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Mintegral/CHANGELOG.md',
        displayName: 'Mintegral',
        extras: {
            androidMigrateToAndroidX: true,
        },
        guideUrl: '/documentation/mediation/android/mediation-setup/mintegral',
        headerCode: `    maven { url "https://dl-maven-android.mintegral.com/repository/mbridge_android_sdk_oversea" }`,
        name: MediatedNetworks.MINTEGRAL,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // Mintegral / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Mintegral/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Mintegral/CHANGELOG.md',
        manifestCode: `            maven { url "https://dl-maven-android.mintegral.com/repository/mbridge_android_sdk_oversea" }`,
        displayName: 'Mintegral',
        extras: {
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/defold/mediation-setup/mintegral',
        headerCode: `    <insertValue value="com.applovin.mediation,mintegral-adapter,+" /> <insertNewline/>
    <insertValue value="androidx.recyclerview,recyclerview,1.1.0" /> <insertNewline/>`,
        name: MediatedNetworks.MINTEGRAL,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Mintegral / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Mintegral/CHANGELOG.md',
        displayName: 'Mintegral',
        extras: {
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/mintegral',
        name: MediatedNetworks.MINTEGRAL,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // Mintegral / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Mintegral/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Mintegral/CHANGELOG.md',
        displayName: 'Mintegral',
        extras: {
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/unity/mediation-setup/mintegral',
        name: MediatedNetworks.MINTEGRAL,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Mintegral / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Mintegral/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Mintegral/CHANGELOG.md',
        manifestCode: `            maven { url "https://dl-maven-android.mintegral.com/repository/mbridge_android_sdk_oversea" }`,
        displayName: 'Mintegral',
        extras: {
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/unreal/mediation-setup/mintegral',
        headerCode: `    <insertValue value="com.applovin.mediation,mintegral-adapter,+" /> <insertNewline/>
    <insertValue value="androidx.recyclerview,recyclerview,1.1.0" /> <insertNewline/>`,
        name: MediatedNetworks.MINTEGRAL,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** MobileFuse **/
    { // MobileFuse / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/MobileFuse/CHANGELOG.md',
        displayName: 'MobileFuse',
        guideUrl: '/documentation/mediation/android/mediation-setup/mobilefuse',
        name: MediatedNetworks.MOBILEFUSE,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // MobileFuse / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/MobileFuse/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-IOS/blob/master/MobileFuse/CHANGELOG.md',
        displayName: 'MobileFuse',
        extras: { },
        guideUrl: '/documentation/mediation/defold/mediation-setup/mobilefuse',
        headerCode: `    <insertValue value="com.applovin.mediation,mobilefuse-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.MOBILEFUSE,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // MobileFuse / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-IOS/blob/master/MobileFuse/CHANGELOG.md',
        displayName: 'MobileFuse',
        guideUrl: '/documentation/mediation/ios/mediation-setup/mobilefuse',
        name: MediatedNetworks.MOBILEFUSE,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // MobileFuse / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/MobileFuse/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-IOS/blob/master/MobileFuse/CHANGELOG.md',
        displayName: 'MobileFuse',
        guideUrl: '/documentation/mediation/unity/mediation-setup/mobilefuse',
        name: MediatedNetworks.MOBILEFUSE,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // MobileFuse / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/MobileFuse/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-IOS/blob/master/MobileFuse/CHANGELOG.md',
        displayName: 'MobileFuse',
        extras: {
            // unrealAarImports: true,
        },
        guideUrl: '/documentation/mediation/unreal/mediation-setup/mobilefuse',
        headerCode: `    <insertValue value="com.applovin.mediation,mobilefuse-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.MOBILEFUSE,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** VK Ad Network **/
    { // VK Ad Network / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/MyTarget/CHANGELOG.md',
        displayName: 'VK Ad Network',
        extras: {
            androidManifestMergingError: true,
        },
        guideUrl: '/documentation/mediation/android/mediation-setup/vkadnetwork',
        name: MediatedNetworks.MYTARGET,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // VK Ad Network / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/MyTarget/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/MyTarget/CHANGELOG.md',
        displayName: 'VK Ad Network',
        extras: {
            unrealAndroidManifestMergingError: true,
        },
        guideUrl: '/documentation/mediation/defold/mediation-setup/vkadnetwork',
        headerCode: `    <insertValue value="com.applovin.mediation,mytarget-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.MYTARGET,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // VK Ad Network / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/MyTarget/CHANGELOG.md',
        displayName: 'VK Ad Network',
        guideUrl: '/documentation/mediation/ios/mediation-setup/vkadnetwork',
        name: MediatedNetworks.MYTARGET,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD, AdTypes.NATIVE ],
        type: DownloadType.ADAPTER,
    },
    { // VK Ad Network / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/MyTarget/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/MyTarget/CHANGELOG.md',
        displayName: 'VK Ad Network',
        extras: {
            [ PlatformTypes.ANDROID ]: {
                unityAndroidManifestMergingError: true,
            },
        },
        guideUrl: '/documentation/mediation/unity/mediation-setup/vkadnetwork',
        name: MediatedNetworks.MYTARGET,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // VK Ad Network / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/MyTarget/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/MyTarget/CHANGELOG.md',
        displayName: 'VK Ad Network',
        extras: {
            unrealAndroidManifestMergingError: true,
        },
        guideUrl: '/documentation/mediation/unreal/mediation-setup/vkadnetwork',
        headerCode: `    <insertValue value="com.applovin.mediation,mytarget-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.MYTARGET,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Ogury **/
    { // Ogury / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/OguryPresage/CHANGELOG.md',
        displayName: 'Ogury',
        guideUrl: '/documentation/mediation/android/mediation-setup/ogury-presage',
        headerCode: `    maven { url "https://maven.ogury.co" }`,
        name: MediatedNetworks.OGURY_PRESAGE,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Ogury / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/OguryPresage/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/OguryPresage/CHANGELOG.md',
        manifestCode: `            maven { url "https://maven.ogury.co" }`,
        displayName: 'Ogury',
        guideUrl: '/documentation/mediation/defold/mediation-setup/ogury-presage',
        headerCode: `    <insertValue value="com.applovin.mediation,ogury-presage-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.OGURY_PRESAGE,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Ogury / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/OguryPresage/CHANGELOG.md',
        displayName: 'Ogury',
        guideUrl: '/documentation/mediation/ios/mediation-setup/ogury-presage',
        name: MediatedNetworks.OGURY_PRESAGE,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Ogury / Unity
        name: MediatedNetworks.OGURY_PRESAGE,
        displayName: 'Ogury',
        type: DownloadType.ADAPTER,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        bidding: true,
        guideUrl: '/documentation/mediation/unity/mediation-setup/ogury-presage',
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/OguryPresage/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/OguryPresage/CHANGELOG.md',
    },
    { // Ogury / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/OguryPresage/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/OguryPresage/CHANGELOG.md',
        manifestCode: `            maven { url "https://maven.ogury.co" }`,
        displayName: 'Ogury',
        guideUrl: '/documentation/mediation/unreal/mediation-setup/ogury-presage',
        headerCode: `    <insertValue value="com.applovin.mediation,ogury-presage-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.OGURY_PRESAGE,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Pangle **/
    { // Pangle / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/ByteDance/CHANGELOG.md',
        displayName: 'Pangle',
        extras: {
            androidPangleObfuscation: true,
            androidManifestMergingError: true,
        },
        guideUrl: '/documentation/mediation/android/mediation-setup/pangle',
        headerCode: `    maven { url "https://artifact.bytedance.com/repository/pangle" }`,
        name: MediatedNetworks.TIKTOK,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.INTER, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Pangle / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/ByteDance/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/ByteDance/CHANGELOG.md',
        manifestCode: `            maven { url "https://artifact.bytedance.com/repository/pangle" }`,
        displayName: 'Pangle',
        extras: {
            iOSPangleCaveat: true,
            iOSRequiredGitLFSSection: false,
            unrealAndroidManifestMergingError: true
        },
        guideUrl: '/documentation/mediation/defold/mediation-setup/pangle',
        headerCode: `    <insertValue value="com.applovin.mediation,bytedance-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.TIKTOK,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Pangle / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/ByteDance/CHANGELOG.md',
        displayName: 'Pangle',
        extras: {
            iOSPangleCaveat: true,
            iOSRequiresNoAts: false,
            iOSRequiredGitLFSSection: false,
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/pangle',
        name: MediatedNetworks.TIKTOK,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Pangle / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/ByteDance/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/ByteDance/CHANGELOG.md',
        displayName: 'Pangle',
        extras: {
            [ PlatformTypes.IOS ]: {
                iOSPangleCaveat: true,
                iOSRequiredGitLFSSection: false,
            },
            [ PlatformTypes.ANDROID ]: {
                unityAndroidManifestMergingError: true
            }
        },
        guideUrl: '/documentation/mediation/unity/mediation-setup/pangle',
        name: MediatedNetworks.TIKTOK,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Pangle / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/ByteDance/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/ByteDance/CHANGELOG.md',
        manifestCode: `            maven { url "https://artifact.bytedance.com/repository/pangle" }`,
        displayName: 'Pangle',
        extras: {
            iOSPangleCaveat: true,
            iOSRequiredGitLFSSection: false,
            unrealAndroidManifestMergingError: true
        },
        guideUrl: '/documentation/mediation/unreal/mediation-setup/pangle',
        headerCode: `    <insertValue value="com.applovin.mediation,bytedance-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.TIKTOK,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Smaato **/
    { // Smaato / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Smaato/CHANGELOG.md',
        displayName: 'Smaato',
        guideUrl: '/documentation/mediation/android/mediation-setup/smaato',
        headerCode: `    maven { url "https://s3.amazonaws.com/smaato-sdk-releases/" }`,
        name: MediatedNetworks.SMAATO,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Smaato / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Smaato/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Smaato/CHANGELOG.md',
        manifestCode: `            maven { url "https://s3.amazonaws.com/smaato-sdk-releases/" }`,
        displayName: 'Smaato',
        guideUrl: '/documentation/mediation/defold/mediation-setup/smaato',
        headerCode: `    <insertValue value="com.applovin.mediation,smaato-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.SMAATO,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Smaato / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Smaato/CHANGELOG.md',
        displayName: 'Smaato',
        extras: {
            iOSRequiresNoAts: false,
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/smaato',
        name: MediatedNetworks.SMAATO,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Smaato / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Smaato/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Smaato/CHANGELOG.md',
        displayName: 'Smaato',
        guideUrl: '/documentation/mediation/unity/mediation-setup/smaato',
        name: MediatedNetworks.SMAATO,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Smaato / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Smaato/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Smaato/CHANGELOG.md',
        manifestCode: `            maven { url "https://s3.amazonaws.com/smaato-sdk-releases/" }`,
        displayName: 'Smaato',
        guideUrl: '/documentation/mediation/unreal/mediation-setup/smaato',
        headerCode: `    <insertValue value="com.applovin.mediation,smaato-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.SMAATO,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Tencent **/
    { // Tencent / iOS
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/TencentGDT/CHANGELOG.md',
        displayName: 'Tencent',
        guideUrl: '/documentation/mediation/ios/mediation-setup/tencent',
        name: MediatedNetworks.TENCENT,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Tencent / Defold (iOS only)
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/TencentGDT/CHANGELOG.md',
        displayName: 'Tencent',
        extras: {
            unrealTencentAndroid: true,
        },
        guideUrl: '/documentation/mediation/defold/mediation-setup/tencent',
        name: MediatedNetworks.TENCENT,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Tencent / Unity (iOS only)
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/TencentGDT/CHANGELOG.md',
        displayName: 'Tencent',
        guideUrl: '/documentation/mediation/unity/mediation-setup/tencent',
        name: MediatedNetworks.TENCENT,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Tencent / Unreal (iOS only)
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/TencentGDT/CHANGELOG.md',
        displayName: 'Tencent',
        extras: {
            unrealTencentAndroid: true,
        },
        guideUrl: '/documentation/mediation/unreal/mediation-setup/tencent',
        name: MediatedNetworks.TENCENT,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Unity Ads **/
    { // Unity Ads / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/UnityAds/CHANGELOG.md',
        displayName: 'Unity Ads',
        guideUrl: '/documentation/mediation/android/mediation-setup/unityads',
        name: MediatedNetworks.UNITY,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Unity Ads / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/UnityAds/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/UnityAds/CHANGELOG.md',
        displayName: 'Unity Ads',
        guideUrl: '/documentation/mediation/defold/mediation-setup/unityads',
        headerCode: `    <insertValue value="com.applovin.mediation,unityads-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.UNITY,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Unity Ads / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/UnityAds/CHANGELOG.md',
        displayName: 'Unity Ads',
        extras: {
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/unityads',
        name: MediatedNetworks.UNITY,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Unity Ads / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/UnityAds/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/UnityAds/CHANGELOG.md',
        displayName: 'Unity Ads',
        guideUrl: '/documentation/mediation/unity/mediation-setup/unityads',
        name: MediatedNetworks.UNITY,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Unity Ads / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/UnityAds/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/UnityAds/CHANGELOG.md',
        displayName: 'Unity Ads',
        guideUrl: '/documentation/mediation/unreal/mediation-setup/unityads',
        headerCode: `    <insertValue value="com.applovin.mediation,unityads-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.UNITY,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Unity Plugin **/
    { // Unity Plugin / Unity
        displayName: 'Unity Plugin',
        name: 'sdk-unity',
        platform: PlatformTypes.UNITY,
        type: DownloadType.SDK,
    },
/** Unreal Plugin **/
    { // Unreal Plugin / Unreal
        displayName: 'Unreal Plugin',
        name: 'sdk-unreal',
        platform: PlatformTypes.UNREAL,
        type: DownloadType.SDK,
    },
/** Verve **/
    { // Verve / Android
        displayName: 'Verve',
        name: MediatedNetworks.VERVE,
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Verve/CHANGELOG.md',
        manifestCode: `    implementation 'com.applovin.mediation:verve-adapter:+'`,
        guideUrl: '/documentation/mediation/android/mediation-setup/verve',
        headerCode: `    maven { url "https://verve.jfrog.io/artifactory/verve-gradle-release" }`,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Verve / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Verve/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Verve/CHANGELOG.md',
        manifestCode: `            maven { url "https://verve.jfrog.io/artifactory/verve-gradle-release" }`,
        displayName: 'Verve',
        guideUrl: '/documentation/mediation/defold/mediation-setup/verve',
        headerCode: `    <insertValue value="com.applovin.mediation,verve-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.VERVE,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Verve / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Verve/CHANGELOG.md',
        displayName: 'Verve',
        guideUrl: '/documentation/mediation/ios/mediation-setup/verve',
        name: MediatedNetworks.VERVE,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Verve / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Verve/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Verve/CHANGELOG.md',
        displayName: 'Verve',
        guideUrl: '/documentation/mediation/unity/mediation-setup/verve',
        headerCode: `    maven { url "https://verve.jfrog.io/artifactory/verve-gradle-release" }`,
        name: MediatedNetworks.VERVE,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Verve / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Verve/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Verve/CHANGELOG.md',
        manifestCode: `            maven { url "https://verve.jfrog.io/artifactory/verve-gradle-release" }`,
        displayName: 'Verve',
        guideUrl: '/documentation/mediation/unreal/mediation-setup/verve',
        headerCode: `    <insertValue value="com.applovin.mediation,verve-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.VERVE,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Liftoff Monetize **/
    { // Liftoff Monetize / Android
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Vungle/CHANGELOG.md',
        displayName: 'Liftoff Monetize *',
        extras: {
            androidMigrateToAndroidX: true,
        },
        guideUrl: '/documentation/mediation/android/mediation-setup/liftoff',
        name: MediatedNetworks.VUNGLE,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Liftoff Monetize / Defold
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Vungle/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Vungle/CHANGELOG.md',
        displayName: 'Liftoff Monetize',
        guideUrl: '/documentation/mediation/defold/mediation-setup/liftoff',
        headerCode: `    <insertValue value="com.applovin.mediation,vungle-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.VUNGLE,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Liftoff Monetize / iOS
        bidding: true,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Vungle/CHANGELOG.md',
        displayName: 'Liftoff Monetize',
        extras: {
            iOSRequireSKAdnetwork: true,
        },
        guideUrl: '/documentation/mediation/ios/mediation-setup/liftoff',
        name: MediatedNetworks.VUNGLE,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Liftoff Monetize / Unity
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Vungle/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Vungle/CHANGELOG.md',
        displayName: 'Liftoff Monetize',
        guideUrl: '/documentation/mediation/unity/mediation-setup/liftoff',
        name: MediatedNetworks.VUNGLE,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.APPOPEN, AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Liftoff Monetize / Unreal
        bidding: true,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Vungle/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Vungle/CHANGELOG.md',
        displayName: 'Liftoff Monetize',
        guideUrl: '/documentation/mediation/unreal/mediation-setup/liftoff',
        headerCode: `    <insertValue value="com.applovin.mediation,vungle-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.VUNGLE,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
/** Yandex **/
    { // Yandex / Android
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Yandex/CHANGELOG.md',
        displayName: 'Yandex',
        guideUrl: '/documentation/mediation/android/mediation-setup/yandex',
        name: MediatedNetworks.YANDEX,
        platform: PlatformTypes.ANDROID,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.NATIVE, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Yandex / Defold
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Yandex/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Yandex/CHANGELOG.md',
        displayName: 'Yandex',
        guideUrl: '/documentation/mediation/defold/mediation-setup/yandex',
        headerCode: `    <insertValue value="com.applovin.mediation,yandex-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.YANDEX,
        platform: PlatformTypes.DEFOLD,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Yandex / iOS
        bidding: false,
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Yandex/CHANGELOG.md',
        displayName: 'Yandex',
        guideUrl: '/documentation/mediation/ios/mediation-setup/yandex',
        name: MediatedNetworks.YANDEX,
        platform: PlatformTypes.IOS,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Yandex / Unity
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Yandex/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Yandex/CHANGELOG.md',
        displayName: 'Yandex',
        guideUrl: '/documentation/mediation/unity/mediation-setup/yandex',
        name: MediatedNetworks.YANDEX,
        platform: PlatformTypes.UNITY,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
    { // Yandex / Unreal
        bidding: false,
        changelogAndroid: 'https://github.com/AppLovin/AppLovin-MAX-SDK-Android/blob/master/Yandex/CHANGELOG.md',
        changelogIOS: 'https://github.com/AppLovin/AppLovin-MAX-SDK-iOS/blob/master/Yandex/CHANGELOG.md',
        displayName: 'Yandex',
        guideUrl: '/documentation/mediation/unreal/mediation-setup/yandex',
        headerCode: `    <insertValue value="com.applovin.mediation,yandex-adapter,+" /> <insertNewline/>`,
        name: MediatedNetworks.YANDEX,
        platform: PlatformTypes.UNREAL,
        size: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        type: DownloadType.ADAPTER,
    },
].sort( ( defOne, defTwo ): number =>
{
    const stringOne: string = defOne.displayName.toLowerCase();
    const stringTwo: string = defTwo.displayName.toLowerCase();
    if ( stringOne > stringTwo )
    {
        return 1;
    }
    else if ( stringOne < stringTwo )
    {
        return -1;
    }
    else
    {
        return 0;
    }
} );

export const PRIVACY_IMAGES = [
    {
        imageSrc: require( '../images/Privacy/privacy00.png' ),
        alt: 'MAX Mediation Debugger. Privacy: Age Restricted User: false. Has User Consent: true. “Do Not Sell”: false.'
    },
    {
        imageSrc: require( '../images/Privacy/privacy01.png' ),
        alt: 'MAX Mediation Debugger. Privacy: Tracking Authorization Status: Authorized (3). Age Restricted User: false. Has User Consent: true. “Do Not Sell”: false.'
    },
    {
        imageSrc: require( '../images/Privacy/privacy02.png' ),
        alt: 'Country Targeting'
    },
    {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-3.png' ),
        alt: 'Set Has User Consent. Has User Consent ☑.'
    },
    {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-4.png' ),
        alt: 'Set Has User Consent. Has User Consent ☐.'
    },
    {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-5.png' ),
        alt: 'Set Is Age Restricted User. Is Age Restricted User ☑.'
    },
    {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-6.png' ),
        alt: 'Set Is Age Restricted User. Is Age Restricted User ☐.'
    },
    {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-7.png' ),
        alt: 'Set Do Not Sell. Do Not Sell ☐.'
    },
    {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-8.png' ),
        alt: 'Set Do Not Sell. Do Not Sell ☑.'
    },
    {
        imageSrc: require( '../images/Privacy/privacymanifests01.png' ),
        alt: 'Incomplete SDK Integrations. One or more of the following SDKs uses an Apple Required Reason API that is not declared in its privacy manifest. Please work directly with the network to ensure Apple’s requirements are met. More information here.'
    },
    {
        imageSrc: require( '../images/Privacy/privacymanifests02.png' ),
        alt: 'Privacy: Undeclared Required Reason APIs.'
    }
]

export const DOCS_IOS_GETTING_STARTED_IMAGES = [
    {
        imageSrc: require( '../images/IOSGettingStartedDetails/image-1.png' ),
        alt: 'Privacy - Tracking Usage Description (String): Pressing ‘OK’ gives you more relevant content. AppLovinConsentFlowInfo (Dictionary): 3 items. AppLovinConsentFlowEnabled (Boolean): 1. AppLovinConsentFlowPrivacyPolicy (String): https://www.company_name.com/privacy_policy. AppLovinConsentFlowTermsOfService (String): https://www.company_name.com/terms_of_service'
    },
    {
        imageSrc: require( '../images/IOSGettingStartedDetails/image-2.png' ),
        alt: 'MAX Mediation Debugger. MAX. SDK Version: 6.13.4. Plugin Version: None. Ad Review Version: 🅧. Privacy. Age Restricted User: No value set. Has User Content: No value set. ‘Do Not Sell’: No value set. Completed Integrations. AdColony: SDK Version 4.3.1.0, Adapter 4.3.1.0. Amazon: SDK amznAdSDK-ios-3.1.0, Adapter 3.1.0.0.2. AppLovin: SDK 6.3.14, Adapter 6.3.14. Chartboost: SDK 8.2.1, Adapter 8.2.1.2.'
    },
    {
        imageSrc: require( '../images/IOSGettingStartedDetails/image-3.png' ),
        alt: 'Small: Test Ad: Flood-It! Flood-It App for free! Free Popular… Install. Medium: Test Ad: Flood-It! Flood-It App for free! Free Popular Casual Game. Install.'
    },
    {
        imageSrc: require( '../images/IOSGettingStartedDetails/image-4.png' ),
        alt: 'Custom Class. Class: MANativeAdView. Module: None. ☐  Inherit Module From Target.'
    },
    {
        imageSrc: require( '../images/IOSGettingStartedDetails/image-5.png' ),
        alt: 'NativeCustomAdView. View. Tag: 1234'
    },
    {
        imageSrc: require( '../images/IOSGettingStartedDetails/image-6.png' ),
        alt: 'Template: ☐ Small, ☐ Medium, ☒ Manual'
    },
    {
        imageSrc: require( '../images/IOSGettingStartedDetails/image-7.png' ),
        alt: 'NativeCustomAdView. Native Ad View. GAD Native Ad View. Custom Class: Class: GADNativeAdView. Module: None.'
    },
    {
        imageSrc: require( '../images/IOSGettingStartedDetails/image-8.png' ),
        alt: 'NativeCustomAdView. Native Ad View. GAD Native Ad View. View: Content Mode: Scale To Fill. Semantic: Unspecified. Tag: 1008. Interaction: ✅ User Interaction Enabled.'
    },
];

export const DOCS_ANDROID_GETTING_STARTED_IMAGES = [
    {
        imageSrc: require( '../images/AndroidGettingStartedDetails/image-1.png' ),
        alt: 'MAX Mediation Debugger. MAX. SDK Version: 9.13.5. Plugin Version: None. Ad Review Version: 🅧. Privacy. Age Restricted User: No value set. Has User Content: No value set. ‘Do Not Sell’: No value set. Completed Integrations. AdColony: Retrieving SDK Version…, Adapter 4.2.3.0. AppLovin: SDK 9.13.5, Adapter 9.13.5.'
    },
];

export const DOCS_REWARDED_S2S_IMAGES = [
    {
        imageSrc: require( '../images/Rewarded/rewarded00.png' ),
        alt: 'Ad Type: ☐App Open, ☐Banner, ☐Interstitial, ☐MREC, ☐Native, ☑Rewarded. Add S2S Reward Callback.'
    },
    {
        imageSrc: require( '../images/Rewarded/rewarded01.png' ),
        alt: 'Ad Type: ☐App Open, ☐Banner, ☐Interstitial, ☐MREC, ☐Native, ☑Rewarded. Hide Callback Settings. Server Side Callback URL form field. Reward Amount form field. Rewarded Currency Name form field. AppLovin Event Key form field.'
    }
];

export const DOCS_IOS_ADVANCED_SETTINGS_IMAGES = [
    {
        imageSrc: require( '../images/IOSAdvancedSettings/image-1.png' ),
        alt: 'Key: Information Property List. Type: Dictionary. Value: (1 item). Key: AppLovinVerboseLoggingOn. Type: Boolean. Value: YES.'
    },
];

export const DOCS_MEDIATED_NETWORKS_IMAGES = {
    [ MediatedNetworks.ADMOB ]: [
        {
            imageSrc: require( '../images/MediationNetworks/AdMob/admob-integration-1.png' ),
            alt: 'Google AdMob. Apps: Add App / View All Apps.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/AdMob/admob-integration-2.png' ),
            alt: 'Create ad unit. ① Select ad format. Test (iOS). Banner: Rectangular ads that occupy a portion of an app’s layout, can be refreshed automatically after a period of time. Interstitial: Full-page ad format that appears at natural breaks and transitions, such as level completion. Rewarded: Ad format that rewards users for watching ads. Great for monetizing free-to-play users. Native advanced: Customizable ad format that matches the look and feel of your app, appears inline with app content.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/AdMob/admob-integration-3.png' ),
            alt: 'Create ad unit. ② Configure ad unit settings. MAX Test App (iOS). Ad format: Banner. Ad unit name: TestApp_Banner_iOS_1.0. Ad type: ☑ Text, image, and rich media; ☑ Video. Automatic refresh: ☐ Google optimized, ☐ Custom, ☑ Disabled. eCPM floor: Enabled. Enter global eCPM floor: $1.00. Add country-specific floors. Create Ad Unit.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/AdMob/admob-integration-4.png' ),
            alt: 'Create ad unit. Ad unit successfully created. Note that new ad units may take up to an hour to start showing ads. Why not test your ad units while you wait? Next, place the ad unit inside your app. Follow these instructions: 1: Complete the instructions in the Google Mobile Ads SDK guide using this app ID. 2: Follow the banner implementation guide to integrate the SDK. You’ll specify ad type, size, and placement when you integrate the code using this ad unit ID. 3: Review the Google AdMob policies to ensure your implementation complies. Email instructions. Done. Create another ad unit.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/AdMob/admob-integration-4-2.png' ),
            alt: 'Create ad unit. ② Configure ad unit settings. MAX Test App (iOS). Ad format: Native advanced. Ad unit name: TestApp_NativeBanner_100. Media type: ☑ Image; ☑ Video. eCPM floor: Enabled. Enter global eCPM floor: $1.00. Add country-specific floors. Create Ad Unit.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/AdMob/admob-integration-5.png' ),
            alt: 'Create ad unit. ② Configure ad unit settings. MAX Test App (iOS). Ad format: Interstitial. Ad unit name: TestApp_Inter_iOS_1.5. Ad type: ☑ Text, image, and rich media; ☑ Video. Frequency capping: Disabled. eCPM floor: Enabled. Enter global eCPM floor: $1.50. Add country-specific floors. Create Ad Unit.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/AdMob/admob-integration-6.png' ),
            alt: 'Create ad unit. ② Configure ad unit settings. MAX Test App (iOS). Ad format: Rewarded. Ad unit name: TestApp_Rew_iOS_2.0. Reward settings. Enter reward amount: 1. Enter reward item: Reward. ☑ Apply to all networks in Mediation groups. Ad type: ☑ Video. ☑ Include interactive. Frequency capping: Disabled. eCPM floor: Enabled. Enter global eCPM floor: $2.00. Add country-specific floors. Create Ad Unit.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/AdMob/admob-integration-7.png' ),
            alt: 'Google AdMob. Apps: Ad units. Add ad unit. Search for ad units by ad unit name, ad unit ID, and ad format.'
        }
    ],
    [ MediatedNetworks.AMAZON ]: [
        {
            imageSrc: require( '../images/MediationNetworks/Amazon/amazon-integration-1.png' ),
            alt: 'Mobile Ads for Android. App Title input field. Platform input field. Is your app directed primarily at kids under 13 (Yes/No radio buttons)? Apps directed primarily at kids under 13 are not eligible to join the Amazon Mobile Ad Network. Learn more. Failure to provide accurate information about whether your app is child-directed may result in termination of your developer account and non-payment of fees for ads we have shown on your apps. Cancel button. Submit button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Amazon/amazon-integration-11.png' ),
            alt: 'New App Submission. App title input field. App SKU input field. App category drop-down. Category Refinements. This will improve your app’s searchability. Game App Features (checkboxes): Casual, Indie, Live Wallpaper, Multiplayer, Widget. App will be listed in Category, Category Refinements. Customer support contact. Use my default support information checkbox. Your default customer support information can not be shown as it was not provided at the time of registration. Update customer support information in settings. Customer support email address input field. Customer support phone input field. Customer support website input field. Cancel button. Save buton.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Amazon/amazon-integration-2.png' ),
            alt: 'Mobile Ads for iOS. To register with Mobile Ads for iOS, you need to create an application key. App Title input field. Is your app directed primarily at kids under 13 (Yes/No radio buttons)? Apps directed primarily at kids under 13 are not eligible to join the Amazon Mobile Ad Network. Learn more. Failure to provide accurate information about whether your app is child-directed may result in termination of your developer account and non-payment of fees for ads we have shown on your apps. Cancel button. Create identifier button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Amazon/amazon-integration-3.png' ),
            alt: 'Create New Ad Unit. Name input field. Platform (iOS/Android radio buttons). Enter your application name, package name, bundle ID, or numerical iTunes ID. Ad Type (Interstitial/Rewarded/Banner radio buttons). 30 sec banner refresh interval. Participating Networks. Status. SDK Key. Bid Floor. Frequency Capping (Off/On radio buttons)'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Amazon/amazon-integration-4.png' ),
            alt: 'Amazon Publisher Services. Status. Include All. Drag and Drop your Amazon Price Point CSV here or Browse Local Files. Export.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Amazon/amazon-integration-5.png' ),
            alt: 'Add an App. Google Play Store or Apple Store or Amazon Store URL. Find App. Enter a store URL to find an app.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Amazon/amazon-integration-6.png' ),
            alt: 'Slot Format: Media Type drop-down. Ad Size drop-down. Slot Name input field. Price Points: Price points are the CPM values that are targeted when an impression is available. Sufficient price point coverage will help maximize revenue. Be sure to update your ad server/mediator to reflect any changes made to your price points within the APS portal. See Resources for more information. ✓ Recommended button. Custom button. Table: Range, Increment, Range Start, Range End, number of Price Points. Total.'
        },
    ],
    [ MediatedNetworks.CHARTBOOST ]: [
        {
            imageSrc: require( '../images/MediationNetworks/Chartboost/chartboost-integration-1.png' ),
            alt: 'Chartboost. Dashboard. Add App. Platform: iOS. App Nickname (Will be referenced in the dashboard): MAX Test App. App Bundle ID. Import App. iTunes URL. App Orientation: ☑ Portrait, ☐ Landscape. Test Mode: ☑ Disabled, ☐ Enabled. Advanced Settings. Block Creative Types.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Chartboost/chartboost-integration-2.png' ),
            alt: 'Chartboost. Dashboard. App Settings: Basic Settings. Platform: iOS. App Nickname (Will be referenced in the dashboard): MAX Test App. App Bundle ID. Import App. iTunes URL. App Orientation: ☑ Portrait, ☐ Landscape. Test Mode: ☑ Disabled, ☐ Enabled. Advanced Settings. Block Creative Types.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Chartboost/chartboost-integration-3.png' ),
            alt: 'Chartboost. Campaigns: Publishing. Network Publishing Campaign. Basic Settings. Enabled. Campaign Name: MAX_INTER_Campaign. Placement Type: Interstitial. Platform: iOS. 1 Apps Publishing this Campaign: MAX Test App. Select app(s). Advanced Settings. Campaign Targeting: Enabled. Target Name. Default.'
        },
    ],
    [ MediatedNetworks.CSJ ]: [
        {
            imageSrc: require( '../images/MediationNetworks/CSJ/csj00.png' ),
            alt: 'Ad Realization > Application > Apps > + Add App button'
        },
        {
            imageSrc: require( '../images/MediationNetworks/CSJ/csj01.png' ),
            alt: 'Add App. App Status (Live / Test). Test ad placements will not be billed. App URL (Please enter the App store url of the app detail page). supported platforms. Bundle ID (For example: com.XXX.XXXXX). Application Icon (Upload button). Some apps allow automatically importing icons from app store; otherwise, please manually upload a 1:1 JPG or PNG file less than 1MB, maximum dimensions of 1024*1024. Validity verification. Start verification after filling out the information. Category (Please ensure your category selection is as consistent with the store listing. The category cannot be modified). Blacklists (Select a blocking rule). App Name (Please enter). Child Protection (Please select).'
        },
        {
            imageSrc: require( '../images/MediationNetworks/CSJ/csj02.png' ),
            alt: 'App name/ID, OS, Category'
        },
        {
            imageSrc: require( '../images/MediationNetworks/CSJ/csj03.png' ),
            alt: 'Add Ad Placement. Native Ads. Banner Ads. New Interstitial Ads. Splash Ads. Rewarded Video Ads. Vertical Draw Video Ads.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/CSJ/csj04.png' ),
            alt: 'Create New Interstitial Ads. Basic Settings. Ad Size (Full Screen Interstitial / Half screen interstitial). App (All Apps). Ad Placement Name. Renderint type (Template). For “Traditional” placements, CSJ will return the creatives of the selected sizes. Publishers will need to show the ad according to relevant guidelines in the Help Center. (Video And Image / Image Only / Video Only). Video Voice Control: Normal sound. Orientation (Vertical / Horizontal). Display “Close” Button After N Seconds (5s): Used To Control Skip Button Display, Set Between 0s–15s. Advanced Settings. Set Expected CPM (No expected CPM / Set expected CPM): No base price for the ad slot; CSJ intelligently returns ads. Blacklist Management (Please select).'
        },
        {
            imageSrc: require( '../images/MediationNetworks/CSJ/csj05.png' ),
            alt: 'Ad Placement Name/ID, App Name/ID'
        },
    ],
    [ MediatedNetworks.FACEBOOK ]: [
        {
            imageSrc: require( '../images/MediationNetworks/Facebook/facebook-integration-1.jpg' ),
            alt: 'Choose a Business Manager Account for Audience Network. You’ll get your Audience Network performance reporting from Meta’s Monetization Manager, which is part of Business Manager. Example Business (Select). Create a new Business Manager account (Create +). Can’t see your business?'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Facebook/facebook-integration-2.png' ),
            alt: 'Monetization Manager. Create a new Property to organize your products. If your product has multiple versions based on operating systems or devices, you can group these versions together into a Property for combined reporting and management. Each Property can contain one iOS app, one Android app, one website domain, one Instant Articles Page, and one Instant Game. What’s the name of your new Property? It can be the same name as the app you’re adding. Create Property. By proceeding, you agree to the Meta Audience Network Policy, Audience Network Terms, and Meta Platform Policy. All apps and websites are subject to our review.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Facebook/facebook-integration-3.png' ),
            alt: 'Monetization Manager. Welcome. Now that you’ve set up your business MAX for Audience Network, it’s just a few more steps until you can start seeing ads in your MAX Test App property. Your next step is to add a platform for MAX Test App. Add Platform.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Facebook/facebook-integration-4.png' ),
            alt: 'Monetization Manager. Platforms. Platforms are the various types of products and surfaces [sic.] you can monetize with Audience Network. Add the platform you want to monetize. iOS app / Android app / Website / Instant Articles.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Facebook/facebook-integration-5.png' ),
            alt: 'Monetization Manager. Add iOS app. ① Select a format for your first ad placement. ② Integrate the SDK and send an ad request from your app. Read the integration guide and download the SDK here. Once you have integrated the SDK, you can send an ad request by opening your app and navigating to the ad placement. You’ll get an email when we receive the first ad request. ③ Enter your business payment account information. We need your payment information before live ads can be served to your iOS app. Add payment account. ④ Send your iOS app for review. Add another platform: Build this Property by adding more platforms for different devices or operating systems. Add people to your property: Collaborate with your colleagues by adding them to your property.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Facebook/facebook-integration-6.png' ),
            alt: 'Monetization Manager. Property Settings: MAX Test App. Edit Property, View Property Performance, Add Platforms. Find out more about Ad Spaces. iOS app. + Create Ad Space. Awaiting Integration. First iOS app Ad Space. 1 Placement. Create a new placement: Add another placement to put ads in a different part of your app. Add another platform: Build this Property by adding more platforms for different devices or operating systems. Add people to your property: Collaborate with your colleagues by adding them to your property.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Facebook/facebook-integration-7.png' ),
            alt: 'Monetization Manager. Ad Space, iOS app: TextApp_Banner_iOS. Edit Ad Space, Price Settings, View Performance. Placements. + Create Placement. Find out more about placements. Placement name, Display format, Status, Price settings, Placement ID. No results found.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Facebook/facebook-integration-8.png' ),
            alt: 'Monetization Manager. Add iOS app. ① Select a format for your first ad placement. What format do you want for your first ad placement? ☐ Native: A customizable placement that you can adapt to match the look and feel of your product. Can contain large and small images, video, text and a link button. ☐ Native Banner: A small customizable placement that displays a single small image from the advertiser’s Facebook Page (often a logo), as well as text and a link. ☐ Interstitial: A full screen ad that covers the whole interface of the product it features in. ☑ Banner: A small ad that usually displays at the bottom of the screen.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Facebook/facebook-integration-9.png' ),
            alt: 'Monetization Manager. ☑ Banner: A small ad that usually displays at the bottom of the screen. ☐ Medium Rectangle: A 300×250px banner ad best suited for scrollable feeds or end-of-level screens. Description (optional). Price settings: Control the price you’ll accept for impressions. Accept any price: This will give you maximum revenue and fill rate if Audience Network is your only advertising source. Don’t accept low prices: We won’t deliver an ad if the price is too low compared with the price you usually get for this placement. This will increase your averate CPM but lower your fill rate and revenue for this single placement. ☑ High threshold: This will give you higher average CPM and lower fill rate. ☐ Low threshold: This will give you a balance: medium average CPM and medium fill rate. Set a CPM Target at the price you want: Set the price you want to get on average for this placement. We’ll deliver a range of prices, higher and lower than the target, to give you the price you set on average within 2 days. Recommended for finely tuning your CPMs if you use a mediation product. Learn more. Create placement.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Facebook/facebook-integration-10.png' ),
            alt: 'Monetization Manager. Placement, Banner. Banner_iOS_MAXplacement. Ready to publish. Edit placement / View Performance. Get code. Copy ID. Platform: iOS app. Display Format: Banner. Price Settings: High price threshold.'
        },
    ],
    [ MediatedNetworks.FYBER ]: [
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-1.png' ),
            alt: 'Adding New App or Site. Step 1: Add your App or Site. App information and assets are automatically added when adding app store URL. Platform: iOS, Android, Mobile Web. App Name: MAX Test App. App Icon: Upload. iTunes URL. Bundle ID: com.testapp.id. Select Category: Business. Secondary Category. COPPA. ☑ By checking this bos, I hereby confirm that my app / mobile site is not directed to children under the age of 13 or to the general audience which may include children under the age of 13, and does comply with the Children’s Online Privacy Protection Act.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-2.png' ),
            alt: 'Adding New App or Site. Step 2: Create New Ad Spot: Ad Spot is a single place in your app or mobile site where an ad of a specific size can appear. Your app can have any number of Ad Spots. App Spot Name: Banner320x50x1. Select Ad Units: You can select up to 5 ad units. Hover over the ad unit for details. Interstitial / Landscape / MREC / Square / Rewarded / Native / Vertical / Banner. Ad Unit Name: Banner1.50. Floor Price: Select the ad unit’s floor price, per country. If not specified the spot floor price will be applied on the ad unit level. Select countries. Country / Floor price. Ad Unit Settings, Banner: A 320x50 unit on mobile devices or 468x60/728x90 on tablets. Request intervals: Set how much time should pass until a secondary ad request will be executed. Available only for non-mediated service. COPPA. ☑ By checking this bos, I hereby confirm that my app / mobile site is not directed to children under the age of 13 or to the general audience which may include children under the age of 13, and does comply with the Children’s Online Privacy Protection Act. Save. + New Ad Spot.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-3.png' ),
            alt: 'Adding New App or Site. Step 2: Create Ad Spot: Ad Spot is a single place in your app or mobile site where an ad of a specific size can appear. Your app can have any number of Ad Spots. Banner1.00. Select Ad Units: You can select up to 5 ad units. Hover over the ad unit for details. Interstitial / Landscape / MREC / Square / Rewarded / Native / Vertical / Banner. Ad Unit Name: Banner1.50. Floor Price: Select the ad unit’s floor price, per country. If not specified the spot floor price will be applied on the ad unit level. Select countries. Country / Floor price. Ad Unit Settings, Banner: A 320x50 unit on mobile devices or 468x60/728x90 on tablets. Request intervals: Set how much time should pass until a secondary ad request will be executed. Available only for non-mediated service. COPPA. ☑ By checking this bos, I hereby confirm that my app / mobile site is not directed to children under the age of 13 or to the general audience which may include children under the age of 13, and does comply with the Children’s Online Privacy Protection Act. Save. + New Ad Unit. + New Ad Spot.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-4.png' ),
            alt: 'Adding New App or Site. Step 3: Integrate with Your App. App Created Successfully. Download SDK and Instructions. Finish.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-5.png' ),
            alt: 'Sign Up. First Name. Last Name. Password. Retype Password. Email. Company Legal Name. Domain. Phone Number. I agree to DT Exchange’s Service Order. Sign In. Confirm.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-6.png' ),
            alt: 'Select Publisher drop-down. Add App button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-7.png' ),
            alt: 'App Management: Add App. Find my app in Google Play / Apple App Store. Search by app name, developer name, or bundle ID (search input field). My app is not available in the Google Play / Apple App Store (checkbox).'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-8.png' ),
            alt: 'Add App. Find my app in Google Play / Apple App Store. “Test” (query text). List of apps that match that query. My app is not available in the Google Play / Apple App Store (checkbox).'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-9.png' ),
            alt: 'Selected App: Test (Google Play). Checkbox: By checking this box, I hereby confirm that my app is not directed to children under the age of 13 or to the general audience which may include children under the age of 13. Add Another App button. Add Placements button. Add Mediated Networks button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-10.png' ),
            alt: 'App Management: Add App. Find my app in Google Play / Apple App Store. ✅ My app is not available in the Google Play / Apple App Store. App name (input field). Platform (radio buttons): iOS, Android. Category (drop-down). App icon: Drag and Drop your file… Bundle ID. Checkbox: By checking this box, I hereby confirm that my app is not directed to children under the age of 13 or to the general audience which may include children under the age of 13. Add Another App button. Add Placements butt. Add Mediated Networks button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-11.png' ),
            alt: 'DT Exchange: Apps, Dynamic Reports, Blocking Lists, Users, Finance.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-12.png' ),
            alt: 'Total Revenues Graph. Add App button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Fyber/fyber-integration-13.png' ),
            alt: 'Placements (tab). Mediated Networks (tab). App Settings (tab). Test Devices (tab). Search or a placement/instance (input field). Filter by (button). Download CSV (button). Upload CSV (button). Table column headings: Placement Name (input field), Type (drop-down), Floor Price, Revenue, Impressions, Fill Rate, eCPM, Frequency.'
        },
    ],
    [ MediatedNetworks.GOOGLE ]: [
        {
            imageSrc: require( '../images/MediationNetworks/GoogleBidding/google-bidding-01.png' ),
            alt: 'Google AdMob. Apps. All apps are hidden. Add app. View all apps.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/GoogleBidding/google-bidding-02.png' ),
            alt: 'Create ad unit.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/GoogleBidding/google-bidding-03.png' ),
            alt: 'MAX Test App iOS. Ad format: Banner. Ad unit name: TestApp_Banner_Bidding. Partner bidding [beta] ✅ I’m using this ad unit for real-time bidding on another mediation platform (not AdMob). When this checkbox is selected, you cannot use the ad unit for AdMob mediation or campaigns, or for accessing Google demand through a third-party waterfall. Google may be required to pay a fee to the third-party mediation platform. You won’t be able to change this setting after you create the ad unit. Create ad unit. Back.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/GoogleBidding/google-bidding-04.png' ),
            alt: 'MAX Test App iOS. Ad format: Native advanced. Ad unit name: TestApp_NativeBanner_Bidding. Partner bidding [beta] ✅ I’m using this ad unit for real-time bidding on another mediation platform (not AdMob). When this checkbox is selected, you cannot use the ad unit for AdMob mediation or campaigns, or for accessing Google demand through a third-party waterfall. Google may be required to pay a fee to the third-party mediation platform. You won’t be able to change this setting after you create the ad unit. Create ad unit. Back.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/GoogleBidding/google-bidding-05.png' ),
            alt: 'MAX Test App iOS. Ad format: Interstitial. Ad unit name: TestApp_Inter_Bidding. Partner bidding [beta] ✅ I’m using this ad unit for real-time bidding on another mediation platform (not AdMob). When this checkbox is selected, you cannot use the ad unit for AdMob mediation or campaigns, or for accessing Google demand through a third-party waterfall. Google may be required to pay a fee to the third-party mediation platform. You won’t be able to change this setting after you create the ad unit. Create ad unit. Back.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/GoogleBidding/google-bidding-06.png' ),
            alt: 'MAX Test App iOS. Ad format: Rewarded. Ad unit name: TestApp_RV_Bidding. Partner bidding [beta] ✅ I’m using this ad unit for real-time bidding on another mediation platform (not AdMob). When this checkbox is selected, you cannot use the ad unit for AdMob mediation or campaigns, or for accessing Google demand through a third-party waterfall. Google may be required to pay a fee to the third-party mediation platform. You won’t be able to change this setting after you create the ad unit. Create ad unit. Back.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/GoogleBidding/google-bidding-07.png' ),
            alt: 'Apps > Ad Units'
        },
    ],
    [ MediatedNetworks.INMOBI ]: [
        {
            imageSrc: require( '../images/MediationNetworks/InMobi/inmobi-integration-1.png' ),
            alt: 'Inventory Settings. Add Inventory: Mobile App, CTV App, Mobile Website.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/InMobi/inmobi-integration-2.png' ),
            alt: 'Start Monetizing your Inventory with InMobi. Get started by adding an app/website and creating placements. Setup Inventory and Placements: Setup ad units and placements that best suits your app/website’s user experience. Enter App details: Get your app details by adding the Google Play or App Store URL. Link app URL input field. App not published yet? Link manually.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/InMobi/inmobi-integration-3.png' ),
            alt: 'Select Ad Unit: Select the type of ad unit that best suits your content and monetization goals. Interstitial: Full screen and high engagement ads placed at natural break points in the app. Banner (Selected): Simple, rectangular static or animated ads that can be placed across screens and content. Rewarded: Short ads, that rewards users with Mobile App gifts, in exchange for ad views. In-Stream: Linerar or non-linear video ad formats served into a video player, before, during, and after the content.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/InMobi/inmobi-integration-4.png' ),
            alt: 'Interstitial: Full screen and high engagement ads placed at natural break points in the app. Total placements (0). Table: #, Placement Name, Audience Bidding, Test Mode. Create New Placement. Enter Placement Name (input field). Test Mode (selector): Off, Global, Device. Select Ad Experience Template (drop-down). Cancel (button). Create Placements (button)'
        },
        {
            imageSrc: require( '../images/MediationNetworks/InMobi/inmobi-integration-5.png' ),
            alt: 'Finance/Payment Settings. Payment Information tab. Account Name. Account ID. Edit Payment Information. Name, Country, Website.'
        },
    ],
    [ MediatedNetworks.IRONSOURCE ]: [
        {
            imageSrc: require( '../images/MediationNetworks/IronSource/ironsource-integration-1.png' ),
            alt: 'Welcome to the ironSource Dashboard: Mobile Monetization and Promotion Platform. New App. Monetize Your App: Developers across the globe use our cloud-based SDK to serve beautiful video and native ads to generate significant revenue: Set up ad units. Integrate Our SDK: Every app is built differently. Experts at ironSource will guide you in customizing and localizing your content to reach the right audience: Download SDK.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/IronSource/ironsource-integration-2.png' ),
            alt: 'Add New App. Enter App Details. ☐ Moble App, ☑ App Not Live in the Application Store. That’s ok, we will ask you to verify the application store info before you start monetizing with live ads. Temporary Name: MAX_Test_App. Platform: ☑ iOS, ☐ Android. Add App.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/IronSource/ironsource-integration-3.png' ),
            alt: 'The Rewarded Video is a user-initiated video that rewards users with in-app content in exchange for ad views. ironSource provides a buffer-free, HD video experience in a skippable format. This ad unit supports ad placements as well as capping and pacing. Rewarded video status. In order to switch to live, you must first provide more details. ironSource Network: Off / Test / Live. Additional Networks: 1 Active Network. Mediation Setup. Configure Test Devices. Placements. New Placement. Placement Name / Reward / Capping and Pacing. Callbacks: Define Server to Server Callbacks. Client Side Callbacks: On. Learn about Callbacks in our Knowledge Center.'
        }
    ],
    [ MediatedNetworks.LINE ]: [
        {
            imageSrc: require( '../images/MediationNetworks/LINE/line-integration-1.png' ),
            alt: 'FIVE Dashboard. 広告枠管理. メディア. 新規作成.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/LINE/line-integration-2.png' ),
            alt: 'メディア. 名前. アプリの概要. ストアURL. プラットフォーム. パッケージ名. OS. カテゴリー. 登録.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/LINE/line-integration-3.png' ),
            alt: 'ID. 名前. MAX Test App iOS.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/LINE/line-integration-4.png' ),
            alt: 'MAX Test App iOS. スロット追加.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/LINE/line-integration-5.png' ),
            alt: 'フォーマット. 名前: Test App iOS Banner. フォーマット: バナー320x50 (640×100). 登録'
        },
        {
            imageSrc: require( '../images/MediationNetworks/LINE/line-integration-6.png' ),
            alt: 'MAX Test App iOS. 審査申請'
        },
        {
            imageSrc: require( '../images/MediationNetworks/LINE/line-integration-7.png' ),
            alt: 'ID. 名前. MAX Test App iOS.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/LINE/line-integration-8.png' ),
            alt: 'ID. 名前. Test App iOS Banner.'
        }
    ],
    [ MediatedNetworks.MAIO ]: [
        {
            imageSrc: require( '../images/MediationNetworks/Maio/maio-integration-1.png' ),
            alt: 'maio. Home: アプリ管理. 新規アプリ.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Maio/maio-integration-2.png' ),
            alt: '新規アプリ. Home: アプリ管理. 新規アプリ. 名称: MAX Test App. プラットフォーム: iOS. アプリURL: https://apps.apple.com/us/app/id1223456789. URLスキーム. 広告タイプ(既定ゾーン): ☑ 動画リワード, ☐ 動画インタースティシャル. 更新.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Maio/maio-integration-3.png' ),
            alt: 'アプリ名: MAX Test App. プラットフォーム: iOS. メディアID.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Maio/maio-integration-4.png' ),
            alt: 'maio. Home: ゾーン管理. 新規ゾーン.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Maio/maio-integration-5.png' ),
            alt: 'Home: 新規ゾーン. 名称: MAX Test App INTER. アプリ: MAX Test App. タイプ: ☐ 動画リワード, ☑ 動画インタースティシャル. 更新.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Maio/maio-integration-6.png' ),
            alt: 'ゾーン名: MAX Test App INTER. アプリ名: MAX Test App. ゾーンID.'
        }
    ],
    [ MediatedNetworks.MINTEGRAL ]: [
        {
            imageSrc: require( '../images/MediationNetworks/Mintegral/mintegral-integration-1.png' ),
            alt: 'Mintegral: APP Setting. APP Key.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Mintegral/mintegral-integration-2.png' ),
            alt: 'Add APP: Platform. Live in Google Play? Google Play URL. App Name. Package Name. COPPA. Allow Mature Ads. CCPA Setting. Direction of Fullscreen Video. Server Side Callback. Ad Template Options. Save.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Mintegral/mintegral-integration-3.png' ),
            alt: 'Search APP: App ID. App Name. Platform.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Mintegral/mintegral-integration-4.png' ),
            alt: 'Mintegral: Placements and Units. iOS Test. Add Placement.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Mintegral/mintegral-integration-5.png' ),
            alt: 'Mintegral: Add Placement and Unit. Add Ad Unit. Bidding Type: Header Bidding.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Mintegral/mintegral-integration-6.png' ),
            alt: 'Placement and Unit Management / iOS Test. AD Unit: 1 AD Units. AD Unit ID. Unit Name. Daily Cap. Ecpm Floor. Operation.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Mintegral/mintegral-integration-7.png' ),
            alt: 'Mintegral, Placements & Units, Add Placement & Unit. Placement Name input box. Ad Format dropdown: Rewarded Video, New Interstitial, Banner, Native (Auto Rendering), Native (Custom Rendering), Splash AD.'
        },
    ],
    [ MediatedNetworks.MOPUB ]: [
        {
            imageSrc: require( '../images/MediationNetworks/MoPub/mopub-integration-1.png' ),
            alt: 'mopub: Apps. New app. Where is your app published? Google Play / App Store. Platform: App Store, Google Play. Search. Save and Create ad unit.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/MoPub/mopub-integration-2.png' ),
            alt: 'mopub: Apps. MAX Test App. Edit ad unit. All geos, all types, running, all priorities. Requests, Impressions, CTR, Fill rate.'
        },
    ],
    [ MediatedNetworks.MYTARGET ]: [
        {
            imageSrc: require( '../images/MediationNetworks/MyTarget/mytarget-integration-1.png' ),
            alt: 'VK Ad Network: Apps > Add App. It won’t take long, try it! Add App button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/MyTarget/mytarget-integration-2.png' ),
            alt: 'Add an app. (How to add an app.) App is published in the store (toggle). App link input field: Enter link. Add app button. Cancel button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/MyTarget/mytarget-integration-3.png' ),
            alt: 'VK Ad Network. Apps > Placements. No placements yet. Add the first one right now. Add placement button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/MyTarget/mytarget-integration-4.png' ),
            alt: 'Placement creation. Choose a placement format. Banner: Text-graphic and video ads that fit into the size of the placement. Interstitial: Text-graphic and video ads that are displayed in full screen. Native: Text-graphic ads that adapt to the app design. Rewarded video: video ads, for viewing which user gets in-game currency, bonuses, or other rewards. In-stream video: Ads inside video content embedded in the player. Integration type: Direct integration radio button; In-App Bidding radio button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/MyTarget/mytarget-integration-5.png' ),
            alt: 'VK Ad Network. Apps > Placements. Add placement button. Filters button. Actions button. Search input box. Table: Name, Status, Format, Placement I.D., C.P.M. floor'
        },
    ],
    [ MediatedNetworks.OGURY_PRESAGE ]: [
        {
            imageSrc: require( '../images/MediationNetworks/OguryPresage/ogury-presage-integration-1.png' ),
            alt: 'Add Android Asset. 1: Register your digital Asset. App Selection: com.max.testapp. App Name: MAX Test App. Bundle (make sure to use the correct bundle to complete your integration): com.max.testapp. Your Asset MAX Test App has not been found in the Store. You can register your Asset and we will automatically update the information when it is published in the Store. Register Asset.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/OguryPresage/ogury-presage-integration-2.png' ),
            alt: 'ogury: Home, Assets: Overview, Consent settings, Monetization settings.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/OguryPresage/ogury-presage-integration-3.png' ),
            alt: 'New Ad Unit. Ad Unit name (Write your Ad Unit name). Device type ☒ Mobile. Ad Unit integration type: ☒ Standard, ☐ Header Bidding. Ad Unit type: ☒ Interstitial, ☐ Rewarded, ☐ Thumbnail Ad, ☐ 300×250, ☐ Small Banner. Orientation: ☒ Automatic, ☐ Landscape, ☐ Portrait.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/OguryPresage/ogury-presage-integration-4.png' ),
            alt: 'Assets: Overview. MAX Test App. Details. Android app. Bundle: com.testappgames.debug. Key: redacted.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/OguryPresage/ogury-presage-integration-5.png' ),
            alt: 'Assets: Monetization settings. Ad Units. List of Ad Units. Name: Default. Type: interstitial. Orientation: automatic. Name: INTER_OGURY_1. Type: interstitial. Orientation: automatic. Ad Unit ID. CPM. New Ad Unit.'
        },
    ],
    [ MediatedNetworks.SMAATO ]: [
        {
            imageSrc: require( '../images/MediationNetworks/Smaato/smaato-integration-1.png' ),
            alt: 'smaato: Inventory: New App. Create New App. App Details. App Type: ☒ iOS, ☐ android, ☐ Mobile site. App Name: MAX Test App. Description. Download URL. Category. COPPA. Define Adspaces. Save.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Smaato/smaato-integration-2.png' ),
            alt: 'smaato: Inventory: MAX Test App. Revenue, Impressions, eCPM, Clicks.'
        },
    ],
    [ MediatedNetworks.TENCENT ]: [
        {
            imageSrc: require( '../images/MediationNetworks/Tencent/tencent-integration-1.png' ),
            alt: '流量合作. 我的广告位. 新建广告位.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Tencent/tencent-integration-2.png' ),
            alt: 'Solitare Classic: Banner 2.0, 插屏2.0, 激励视频.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Tencent/tencent-integration-3.png' ),
            alt: '我的广告位, 流量合作'
        },
    ],
    [ MediatedNetworks.TIKTOK ]: [
        {
            imageSrc: require( '../images/MediationNetworks/TikTok/tiktok-integration-1.png' ),
            alt: 'Pangle, Applications: Add the apps that you would like to monetize here. + Add App.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/TikTok/tiktok-integration-2.png' ),
            alt: 'Add. Ad Formats: Interstitial, Rewarded, Banner, Native, App Open Ad. Ad Placement Name. Orientation: Vertical, Horizontal. Pricing Type: In-App Bidding, Global CPM. Advanced Settings. Cancel, Submit.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/TikTok/tiktok-integration-2-2.png' ),
            alt: 'Banner Ads. App (All Apps), Layout Management (Native), Native Type (Express), Ad placement size (640 by 100), Whether to play carousel ads (Yes). The size of ad placement refers to pixel, not actual width and height in an ad placement request. Please set the request ad size according to the actual ad placement width and height. The ad placement will load the content of the banner carousel frame at a time, and the carousel will display it. Please ensure that the display time per frame is at least 2.5s.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/TikTok/tiktok-integration-3.png' ),
            alt: 'Interstitial Ads. App (All Apps), Use Template (No), Orientation (Vertical), Blacklist Management (No limitation), Ad Placement Name, Bidding-Type (Server-side SDK bidding). For “Traditional” placements, Pangle will return the creatives of the selected sizes. Publishers will need to show the ad according to relevant guidelines in the Help Center.'
        },
    ],
    [ MediatedNetworks.UNITY ]: [
        {
            imageSrc: require( '../images/MediationNetworks/Unity/unity-integration-1.png' ),
            alt: 'New project. (1) Mediation partner. Mediation solution. Please select your Mediation Partner so we can provide relevant information to help you improve project performance. I plan to use Mediation. Mediation is a monetization strategy tool that gives you control over pricing strategies. It allows multiple ad sources to compete for impressions in order to optimize fill rate and revenue. Choose your Mediation Partner. AppLovin MAX. Next button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Unity/unity-integration-2.png' ),
            alt: 'Ad Units. (i) What are Ad Units? Show Help. All / Rewarded / Interstitial / Banner. Platform drop-down. Ad Unit column. Platform column. Ad Format column. Placements column.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Unity/unity-integration-3.png' ),
            alt: 'Add Placement. Choose placement type: Bidding, Waterfall. Placement Name input field. Cancel button. Add Placement button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Unity/unity-integration-4.png' ),
            alt: 'Placement Management. Add Ad Unit button. (i) What are Placements? Upload button. Download CSV button. All / Rewarded / Interstitial / Banner. Platform drop-down. Country drop-down. Ad Units drop-down. Placements drop-down. Placement, Geo Targeting, Target, Reported eCPM, Est revenue, Impression. Add Placement button.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Unity/unity-integration-5.png' ),
            alt: 'Interstitial Android. Settings. Here you can make changes to your Ad Unit settings. Consult the FAQ and Best Practices in Intercom to maximize your earnings with ads. To filter ad content in your game, visit the Ad Controls page. Ad Unit Name: Interstitial Android. Ad Format: Interstitial. Status: Active. Muting: Audio not muted. Allow skip: After 5 seconds.'
        }
    ],
    [ MediatedNetworks.VUNGLE ]: [
        {
            imageSrc: require( '../images/MediationNetworks/Vungle/vungle-integration-1.png' ),
            alt: 'Liftoff Monetize: Applications. Add Application.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Vungle/vungle-integration-2.png' ),
            alt: 'Add Your Application. Choose your app store, then locate your application to get started. App Store: Select what App Store your Application belongs to. Custom App Name: Enter a custom name for your application. This is only for identification purposes. App Store: Select the correct option for your app. ☑ My app is live in the Apple App Store, ☐ My app is not live yet. App Category: Select the best category for your app. Connect Your Live App: Please Search by App name / Store ID / Store URL. Apps Directed Toward Children Under Age 13. In accordance with the Children’s Online Privacy Protection Act (COPPA) in the United States, we require all partners using Vungle services to identify whether or not their apps are primarily directed toward children under the age of thirteen (13). Read more about COPPA here. By clicking “Agree” below, partner: (i) represents that this app is not primarily directed at children under age thirteen (13), and (ii) agrees that this app will not be tagged as primarily child-directed. ☐ Agree - COPPA settings will NOT apply. ☐ Disagree - COPPA settings will apply.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Vungle/vungle-integration-3.png' ),
            alt: 'Liftoff Monetize: Applications > Add Placement.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Vungle/vungle-integration-4.png' ),
            alt: 'Placements > Interstitial: Full screen video ad that monetizes best at natural break points in the app flow. Customization: Edit your Placement below, we’ve set defaults based on your Application criteria but feel free to customize further. Placement Name: Add a unique name for your placement. Skippable: This setting will override the Application level Ad Force View. ☐ Yes, ☐ No.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Vungle/vungle-integration-5.png' ),
            alt: 'Based on your Platform we took the liberty of configuring your SDK for you. Follow these instructions. SDK Integration: Complete the integration instructions using the corresponding placement reference ID (CocoaPods, Download SDK, Integration). I’ve already integrated the most recent SDK. Placement Integration: We’ve added the recent placement below for you to integrate. Interstitial Placement(s): Complete the Interstitial integration instructions using the corresponding placement reference ID. Add Another. Sounds Good.'
        }
    ],
    [ MediatedNetworks.YANDEX ]: [
        {
            imageSrc: require( '../images/MediationNetworks/Yandex/yandex-integration-1.png' ),
            alt: 'Yandex Advertising network: Products: Mobile platforms. Add mobile platform.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Yandex/yandex-integration-2.png' ),
            alt: 'Create mobile platform. Application, Platform, Bundle ID, Link to app in store, Name.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Yandex/yandex-integration-3.png' ),
            alt: 'Bundle ID/Type, Mobile RTB blocks, Statistics, Status, Settings. MAX Test App. Edit. Actions.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Yandex/yandex-integration-4.png' ),
            alt: 'Mobile RTB blocks. Archive. Add mobile RTB block. Search.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Yandex/yandex-integration-5.png' ),
            alt: 'Create mobile RTB block. 3: Formats. Allowed ad space sizes, preferred media banner format, preferred Yandex.Direct block format, icons, quick links. Please specify the formats that can be displayed on your ad platform. Increasing the number of selected formats leads to a greater number of advertisers taking part in an auction and, as a result, to increased revenue from ad placement.'
        },
        {
            imageSrc: require( '../images/MediationNetworks/Yandex/yandex-integration-6.png' ),
            alt: 'Formats, Strategy, Status, Settings. MAX Test App Banner. Statistics, Edit, Send to archive, Duplicate.'
        }
    ],
};

export const DOCS_MEDIATED_TESTING_NETWORKS_IMAGES = {
    TEST_MODE: [
        {
            imageSrc: require( '../images/TestingNetworks/TestMode/test-mode-1.png' ),
            alt: 'MAX Test Devices: + Add Test Device. Create your first Test Device. Test devices are used to verify successful integration of specific ad networks. By defining a test device and selecting a network, all valid MAX ad unit requests for that test device will initiate an ad request to the selected network with their test mode enabled.'
        },
        {
            imageSrc: require( '../images/TestingNetworks/TestMode/test-mode-2.png' ),
            alt: 'Test Mode: Add Test Device. Add New Test Device. Name, IDFA (iOS) or GAID (Android), Test Network. Save.'
        },
        {
            imageSrc: require( '../images/TestingNetworks/TestMode/test-mode-3.png' ),
            alt: 'Max Mediation Test Devices. Test Device, IDFA, Ad Network, Status. Test devices are used to verify successful integration of specific ad networks. By defining a test device and selecting a network, all valid MAX ad unit requests for that test device will initiate an ad request to the selected network with their test mode enabled.'
        },
    ],
    MEDIATION_DEBUGGER: {
        [ PlatformTypes.UNITY ] : [
           {
              imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-unity-blueprint.png' ),
              alt: 'Show Mediation Debugger'
           }
        ],
        [ PlatformTypes.IOS ]: [
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-home-screen-ios-1.png' ),
                alt: 'App Info, MAX, MAX Terms & ATT Flow, Privacy, Ads'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-home-screen-ios-2.jpg' ),
                alt: 'Incomplete Integrations, Completed Integrations'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-test-ads-ios.png' ),
                alt: 'Test Ads'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-ad-units-ios.png' ),
                alt: 'Ad Units'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-show-waterfall-ios.png' ),
                alt: 'INTER: Info, Bidding Networks. Tap to load an ad.'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-single-ad-source-ios.png' ),
                alt: 'INTER: Info, Bidding networks. AppLovin ad loaded. Show.'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-share-ios.png' ),
                alt: 'MAX Mediation Debugger. App Info, MAX.'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-app-ads-txt.png' ),
                alt: 'MAX: SDK Version: 11.6.0. Plugin Version: None. Ad Review Version: ❌. app-ads.txt: ✅.'
            },
        ],
        [ PlatformTypes.ANDROID ]: [
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-home-screen-android-1.jpg' ),
                alt: 'App Info, MAX, Privacy, Ads'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-home-screen-android-2.jpg' ),
                alt: 'Incomplete Integrations, Completed Integrations'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-test-ads-android.jpg' ),
                alt: 'Test Ads'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-ad-units-android.png' ),
                alt: 'Ad Units'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-show-waterfall-android.png' ),
                alt: 'INTER: Info, Bidders, Waterfall. Tap to load an ad.'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-single-ad-source-android.png' ),
                alt: 'INTER: Info, Bidders. AppLovin ad loaded.'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-share-android.png' ),
                alt: 'MAX Mediation Debugger. App Info, MAX.'
            },
            {
                imageSrc: require( '../images/TestingNetworks/MediationDebugger/mediation-debugger-app-ads-txt.png' ),
                alt: 'MAX: SDK Version: 11.6.0. Plugin Version: None. Ad Review Version: ❌. app-ads.txt: ✅.'
            },
        ],
    },
    DEMO_APP: {
        [ PlatformTypes.IOS ]: [
            {
                imageSrc: require( '../images/TestingNetworks/DemoApp/ios-demo-app-1.png' ),
                alt: 'MAX Demo App: Ad Examples'
            },
            {
                imageSrc: require( '../images/TestingNetworks/DemoApp/ios-demo-app-2.png' ),
                alt: 'Auto Layout Banner Ads'
            },
        ],
        [ PlatformTypes.ANDROID ]: [
            {
                imageSrc: require( '../images/TestingNetworks/DemoApp/android-demo-app-1.png' ),
                alt: 'MAX Demo App: Ad Examples'
            },
            {
                imageSrc: require( '../images/TestingNetworks/DemoApp/android-demo-app-2.png' ),
                alt: 'Programmatic Banner Ads'
            },
        ],
    }
};

export const DOCS_SWIFT_BUILD_SETTINGS = [
    {
        imageSrc: require( '../images/PreparingMediatedNetworks/swift_build_settings.png' ),
        alt: 'Setting: Always Embed Swift Standard Libraries. AppLovin MAX Demo App: Yes.'
    },
];

export const DOCS_CROSS_PROMO_IMAGES = [
    {
        imageSrc: require( '../images/CrossPromo/cross-promo-1.png' ),
        alt: 'Participating Networks: ☒ AppLovin Bidding, ☐ Google bidding and Google AdMob, ☐ Chartboost, ☒ Cross Promo. Cross Promo allows you to serve ads for your own titles through dedicated zones at fixed CPM pricing.'
    },
];

export const DOCS_CONSENT_FLOW_IMAGES = {
    "INFO_PLIST": {
        imageSrc: require( '../images/ConsentFlow/info_plist.png' ),
        alt: 'Privacy - Tracking Usage Description (String): This only uses device info for more interesting and relevant ads. AppLovinConsentFlowInfo (Dictionary): (3 items). AppLovinConsentFlowInfo (Boolean): 1. AppLovinConsentFlowPrivacyPolicy (String): https://your_company_name.com/privacy_policy. AppLovinConsentFlowTermsOfService (String): https://your_company_name.com/terms_of_service.'
    },
    "INTEGRATION_MANAGER": {
        imageSrc: require( '../images/ConsentFlow/integration_manager.png' ),
        alt: 'Privacy Settings. ☑ Enable Consent Flow: Privacy Policy URL, Terms of Service URL (optional), User Tracking Usage Description. ☑ Localize User Tracking Usage Description: MAX may add more localized strings to this list in the future, which will set the default value of the User Tracking Usage Description string for more locales. If you are overriding these with your own custom translations, you may want to review this list whenever you upgrade the plugin to see if there are new entries you may want to customize. If you have your own implementation of InfoPlist.strings localization implementation, please use that instead. Using both at the same time may cause conflicts.'
    },
    "FLOWCHART": {
        imageSrc: require( '../images/ConsentFlow/flowchart.png' ),
        alt: 'Initialize MAX SDK. Age-restricted User? In GDPR region? Google UMP Flow. MAX Terms / Privacy Policy Flow. MAX ATT Prompt (iOS only). SDK Initialization Completion callback'
    },
    "EDIT_ICON": {
        imageSrc: require( '../images/ConsentFlow/edit-icon.png' ),
        alt: '✎'
    },
    "CONSENTFLOWINFO": {
        imageSrc: require( '../images/ConsentFlow/consentflowinfo1.png' ),
        alt: 'Root > ConsentFlowInfo > ConsentFlowEnabled (Boolean) = YES, ConsentFlowPrivacyPolicy (String) = https://lionstudios.cc/privacy/, ConsentFlowTermsOfService (String) = https://lionstudios.cc/terms/'
    },
    "CONSENTFLOWDEBUGUSERGEOGRAPHY": {
        imageSrc: require( '../images/ConsentFlow/consentflowgdpr.png' ),
        alt: 'ConsentFlowInfo > ConsentFlowDebugUserGeography (String) = gdpr'
    },
    "PRIVACY_SETTINGS": {
        imageSrc: require( '../images/ConsentFlow/PrivacySettings.png' ),
        alt: 'Privacy Settings. Enable MAX Terms and Privacy Policy Flow. Privacy Policy URL. Terms of Service URL (optional). Override Default User Tracking Usage Description. User Tracking Usage Description. Localize User Tracking Usage Description.'
    },
    "UNITY_TESTING": {
        imageSrc: require( '../images/ConsentFlow/unityTesting.png' ),
        alt: 'Testing: Debug User Geography: GDPR. Debug User Geography is only enabled in debug mode'
    },
    "VERIFYING_INSTALLATION": {
        imageSrc: require( '../images/ConsentFlow/verifyingInstallation.jpg' ),
        alt: 'MAX Mediation Debugger > Privacy: CMP (Consent Management Platform) = Google consent management solutions'
    },
    "VERIFYING_IAB_TCF_PARAMETERS": {
        imageSrc: require( '../images/ConsentFlow/verifyingIABTCFparameters.jpg' ),
        alt: 'IAB TCF Parameters: IABTCF_gdprApplies, IABTCF_TCString, IABTCF_AddtlConsent'
    },
    "VERIFYING_MISSING_NETWORKS_1": {
        imageSrc: require( '../images/ConsentFlow/verifyingMissingNetworks1.jpg' ),
        alt: 'CMP Configuration: IABTCF_CmpSdkID = 300, IABTCF_CmpSdkVersion = 2. To check which of your integrated networks are missing from your CMP, first make sure that you have granted consent to all networks through your CMP flow. Then add the following networks to your CMP network list. Configured CMP Networks: Missing 3 network(s).'
    },
    "VERIFYING_MISSING_NETWORKS_2": {
        imageSrc: require( '../images/ConsentFlow/verifyingMissingNetworks2.jpg' ),
        alt: 'Configured CMP Networks: Missing TCF Vendors (TC String), Missing ATP Networks (AC String), Listed TCF Vendors (TC String)'
    },
    "VERIFYING_MEDIATED_NETWORK_CONSENT_STATUSES": {
        imageSrc: require( '../images/ConsentFlow/verifyingMediatedNetworkConsentStatuses.jpg' ),
        alt: 'Network Consent Statuses: TCF Vendors (TC String), ATP Networks (AC String)'
    }
};

export const UNITY_INTEGRATION_IMAGES = {
    "NSADVERTISINGATTRIBUTIONREPORTENDPOINT": {
        imageSrc: require( '../images/IntegrationManager/nsaare.png' ),
        alt: 'Other Settings: ☑ Set Advertising Attribution Report Endpoint in Info.plist (iOS only), ☑ Enable Auto Update, ☐ Enable Verbose Logging'
    },
    "BLUEPRINT1": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-2.png' ),
        alt: 'Set User Id. User Id. USER_ID. Initialize. Sdk Key. YOUR_SDK_KEY_HERE. AppLovin SDK is initialized, start loading ads. On Sdk Initialized Dynamic Delegate (AppLovinMAXDelegate). Sdk Configuration.'
    },
    "BLUEPRINT2": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-9.png' ),
        alt: 'Ad Unit Identifier. Create Banner: Ad Unit Identifier. Banner Position: Bottom Center. Set Banner Placement: Ad Unit Identifier, Placement: YOUR_BANNER_PLACEMENT.'
    },
    "BLUEPRINT3": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-10.png' ),
        alt: 'Ad Unit Identifier. Create MRec: Ad Unit Identifier. MRec Position: Top Left. Set MRec Placement: Ad Unit Identifier, Placement: YOUR_BANNER_PLACEMENT.'
    },
    "BLUEPRINT4": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-11.png' ),
        alt: 'Ad Unit Identifier. Show Interstitial: Ad Unit Identifier. Placement: YOUR_INTERSTITIAL_PLACEMENT.'
    },
    "BLUEPRINT5": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-12.png' ),
        alt: 'Ad Unit Identifier. Show Rewarded Ad: Ad Unit Identifier. Placement: YOUR_REWARDED_AD_PLACEMENT.'
    },
    "BLUEPRINT6": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-13.png' ),
        alt: 'To mute. Set Muted. Muted ☑. To unmute. Set Muted. Muted ☐.'
    },
    "BLUEPRINT7": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-14.png' ),
        alt: 'Set Verbose Logging Enabled. Enabled ☑.'
    },
    "BLUEPRINT8": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-15.png' ),
        alt: 'Banners are automatically sized to 320×50 on phones and 728×90 on tablets. You may call the utility method “Is Tablet” to help with view sizing adjustments: Ad Unit Identifier. Create Banner: Ad Unit Identifier. Banner Position: Bottom Center. Set background or background color for banners to be fully functional. Set Banner Background Color: Ad Unit Identifier, Color. Make Color. B:0, G:0, R:0, A:0; Color.'
    },
    "BLUEPRINT9": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-16.png' ),
        alt: 'Ad Unit Identifier. Show Banner: Ad Unit Identifier.'
    },
    "BLUEPRINT10": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-17.png' ),
        alt: 'Ad Unit Identifier. Hide Banner: Ad Unit Identifier.'
    },
    "BLUEPRINT11": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-18.png' ),
        alt: 'Initialize Interstitial Ads. Custom Event. Interstitial ad is ready to be shown. “Is Interstitial Ready” will return true. On Interstitial Ad Loaded Dynamic Delegate (AppLovinMAXDelegate): Ad Info. Reset retry attempts. SET. Retry Attempt: 0.0. On Interstitial Ad Load Failed Dynamic Delegate (AppLovinMAXDelegate): Ad Info, Ad Error. Retry Attempt. ++. MIN: 6.0, Add pin +. Power: Base 2.0, Exp, Return Value. Delay: Duration, Completed. If interstitial ad fails to load, retry with exponentially higher delays up to a maximum delay (in this case 64 seconds). Interstitial ad failed to display. AppLovin recommends loading the next ad. On Interstitial Ad Display Failed Dynamic Delegate (AppLovinMAXDelegate): Ad Info, Ad Error. Interstitial ad is hidden. Pre-load the next ad. On Interstitial Ad Hidden Dynamic Delegate (AppLovinMAXDelegate): Ad Info. Ad Unit Identifier. Load Interstitial: Ad Unit Identifier.'
    },
    "BLUEPRINT12": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-19.png' ),
        alt: 'Ad Unit Identifier. Is Interstitial Ready: Ad Unit Identifier, Return Value. Branch: Condition, True/False. Show Interstitial: Ad Unit Identifier, Placement.'
    },
    "BLUEPRINT13": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-20.png' ),
        alt: 'Ad Unit Identifier. Create MRec: Ad Unit Identifier, MRec Position (Centered).'
    },
    "BLUEPRINT14": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-21.png' ),
        alt: 'Ad Unit Identifier. Show MRec: Ad Unit Identifier.'
    },
    "BLUEPRINT15": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-22.png' ),
        alt: 'Ad Unit Identifier. Hide MRec: Ad Unit Identifier.'
    },
    "BLUEPRINT16": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-23.png' ),
        alt: 'Initialize Rewarded Ads (Custom Event). Rewarded ad is ready to be shown. “Is Rewarded Ad Ready” will return True. On Rewarded Ad Loaded Dynamic Delegate (AppLovinMAXDelegate: Ad Info. Reset retry attempts. SET: Retry Attempt 0.0. If rewarded ad fails to load, retry with exponentially higher delays up to a maximum delay (in this case 64 seconds). On Rewarded Ad Load Failed Dynamic Delegate (AppLovinMAXDelegate): Ad Info, Ad Error. Retry Attempt. ++. MIN (6.0), Add pin+. Power: Exp, Return Value. Delay: Duration, Completed. Rewarded ad failed to display. AppLovin recommends loading the next ad. On Rewarded Ad Display Failed Dynamic Delegate (AppLovinMAXDelegate): Ad Info, Ad Error. Rewarded ad is hidden. Pre-load the next ad. On Rewarded Ad Hidden Dynamic Delegate (AppLovinMAXDelegate): Ad Info. Rewarded ad was displayed and user should receive the reward. On Rewarded Ad Received Reward Dynamic Delegate (AppLovinMAXDelegate): Ad Info, Reward. Ad Unit Identifier. Load Rewarded Ad: Ad Unit Identifier.'
    },
    "BLUEPRINT17": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-24.png' ),
        alt: 'Ad Unit Identifier. Is Rewarded Ad Ready: Ad Unit Identifier, Return Value. Branch: Condition (True). Show Rewarded Ad: Ad Unit Identifier, Placement.'
    },
    "BLUEPRINT18": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-25.png' ),
        alt: 'On Interstitial Ad Displayed Dynamic Delegate (AppLovinMAXDelegate): Ad Info. Break AdInfo: Ad Info, Ad Unit Identifier, Network Name, Creative Identifier, Placement, Revenue.'
    },
    "BLUEPRINT19": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-26.png' ),
        alt: 'On Interstitial Ad Displayed Dynamic Delegate (AppLovinMAXDelegate): Ad Info. Break AdInfo: Ad Info, Ad Unit Identifier, Network Name, Creative Identifier, Placement, Revenue.'
    },
    "LINKEDIN": {
        imageSrc: require( '../images/UnityGettingStartedDetails/image-28.png' ),
        alt: 'AppLovin Integration Manager. AppLovin Micro S.D.K. Partners. Network: LinkedIn. Current Version: ios_1.1.1.1. Latest Version: ios_1.1.1.1. Actions: Install.'
    },
    "GODOTPLUGINSEARCH": {
        imageSrc: require( '../images/UnityGettingStartedDetails/GodotPluginSearch.png' ),
        alt: 'AppLovinMAX: Tools: AppLovin Mobile Engineering: M.I.T.'
    },
    "GODOTPLUGINENABLE": {
        imageSrc: require( '../images/UnityGettingStartedDetails/GodotPluginEnable.png' ),
        alt: 'Plugins: Installed Plugins: AppLovinMAX: 1.0.0, AppLovin, ☑Enable'
    }
};

export const DOCS_MANIFEST_EXTRAS_IMAGES = {
    [ PlatformTypes.IOS ]: {
        'ATS': {
            imageSrc: require( '../images/ManifestExtras/ios-ats-manifest-extra.png' ),
            alt: 'App Transport Security Settings (Dictionary): 1 item. Allow Arbitrary Loads (Boolean): YES.'
        }
    },
    [ PlatformTypes.UNITY ]: {
        [ MediatedNetworks.ADMOB ]: {
            imageSrc: require( '../images/ManifestExtras/unity-admob-manifest-extra-1.png' ),
            alt: 'Google bidding and Google AdMob. App ID (Android). App ID (iOS).'
        },
        [ MediatedNetworks.AMAZON]: {
            imageSrc: require( '../images/ManifestExtras/unity-amazon-manifest-extra-1.png' ),
            alt: 'Amazon SDK Manager: Mediated Networks. AppLovin MAX.'
        },
        [ 'CBGT' ]: {
            imageSrc: require( '../images/ManifestExtras/Custom Base Gradle Template.png' ),
            alt: 'Build: Custom Base Gradle Template (Assets/Plugins/Android/baseProjectTemplate.gradle)'
        },
        [ 'GP' ]: {
            imageSrc: require( '../images/ManifestExtras/Gradle Path.png' ),
            alt: '☐ Gradle installed with Unity (recommended). Gradle: /path/to/gradle-6.7.1. Browse button. Warning: You are not using the recommended Gradle, other versions are not officially supported.'
        },
    },
    [ MediatedNetworks.ADMOB ]: {
        [ PlatformTypes.IOS ]: [
            {
                imageSrc: require( '../images/ManifestExtras/admob-ios-manifest-extra-1.png' ),
                alt: 'GADApplicationIdentifier (String): <YOUR_ADMOB_APP_ID>'
            },
        ],
    },
    [ MediatedNetworks.GOOGLE_AD_MANAGER ]: {
        [ PlatformTypes.IOS ]: [
            {
                imageSrc: require( '../images/ManifestExtras/google-ad-manager-ios-manifest-extra-1.png' ),
                alt: 'GADIsAdManagerApp (Boolean): YES'
            },
        ],
    },
};

export const DOCS_AD_REVIEW_IMAGES = [
    {
        imageSrc: require( '../images/AdReview/ad-review-0.png' ),
        alt: 'creatives gallery'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-1.png' ),
        alt: 'Creative Details'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-2.png' ),
        alt: 'Campaigns'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-3.png' ),
        alt: 'Campaign Details'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-4.png' ),
        alt: 'risky content'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-5.png' ),
        alt: 'Risky Content Settings: Risky Content Preferences. Please select the categories of ad content that you want to detect and flag across all your apps.'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-6.png' ),
        alt: 'Risky Content Settings: Risky Content Rules'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-7.png' ),
        alt: 'Competitor Rules'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-8.png' ),
        alt: 'ad reporting'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-9.png' ),
        alt: 'Report Ads'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-10.png' ),
        alt: 'Auto Redirects'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-11.png' ),
        alt: 'Auto Redirects Search'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-12.png' ),
        alt: 'User Journey Reports'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-13.png' ),
        alt: 'Create New Report. Fill in the user id, the app, and the time range. The time range is limited to 24 hours per report but it’s recommended to narrow down the hours as much as you can to get more precise results. All events are stored in UTC.'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-14.png' ),
        alt: 'User Journey.'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-15.png' ),
        alt: 'Table: Creative / Redirects Rate / Redirects'
    },
    {
        imageSrc: require( '../images/AdReview/ad-review-16.png' ),
        alt: 'Auto Redirects. Run Report. Network, Ad Format'
    },
];

export const DOCS_AB_TEST_IMAGES = [
    {
        imageSrc: require( '../images/ABTest/screenshot1.png' ),
        alt: 'Edit Ad Unit. Name, Platform, Ad Type, Default Waterfall. Preview Waterfall, Create AB Test.'
    },
    {
        imageSrc: require( '../images/ABTest/screenshot2.png' ),
        alt: 'Create AB Test: AB Test allows you to test a different ad unit configuration on a specific % of your users. Once you have analyzed the results of your test, you can either “Promote” these settings to all users or “Deprecate” the test. Test Group Allocation: 50%. ☑ Copy existing ad unit configuration for Test Ad Unit (can be edited later). Create AB Test.'
    },
    {
        imageSrc: require( '../images/ABTest/screenshot3.png' ),
        alt: 'Ad Type. Default Waterfall. AB Test Name. Participating Networks.'
    },
    {
        imageSrc: require( '../images/ABTest/screenshot4.png' ),
        alt: 'Preview Waterfall, End AB Test'
    },
    {
        imageSrc: require( '../images/ABTest/screenshot5.png' ),
        alt: 'Advanced Reporting'
    },
    {
        imageSrc: require( '../images/ABTest/screenshot6.png' ),
        alt: 'End AB Test. If the result of this test exceeded the “Control” in performance, select “Promote Test”, if not, you can select “Deprecate Test” to end the test and revert to the “Control” group. Make sure to Save your changes at the end to ensure that the AB Test changes are correctly applied.'
    },
    {
        imageSrc: require( '../images/ABTest/screenshot7.png' ),
        alt: 'A/B Tests. Application, Test Name, Test Start Date, Ad Unit, Ad Type, Waterfall, Result'
    },
    {
        imageSrc: require( '../images/ABTest/screenshot8.png' ),
        alt: 'A/B Test Results'
    },
];

export const DOCS_DIRECT_SOLD_IMAGES = [
    {
        imageSrc: require( '../images/DirectSold/direct-sold-0.png' ),
        alt: 'Direct Sold: Campaigns. Campaign Management.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-1.png' ),
        alt: 'Direct Sold: Campaigns: New Campaign. Basic Info. To get started please give your campaign a name and select the application you would like to target. Campaign Name. Select Ad Units.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-2.png' ),
        alt: 'Select OS Versions: Specific Versions. Continue.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-3.png' ),
        alt: 'Carriers, Genders, Device ID Targeting, GDPR Targeting, Age Targeting.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-4.png' ),
        alt: 'Keyword Targeting. ☐ Do Not Enable, ☑ Enable. “+fruit:apple, +fruit:banana [LINE FEED] -section:homepage”. Continue.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-5.png' ),
        alt: 'Bids, Day Parting, Daily Budgets, and Dates. Define your bids, day parting, dates, and daily budgets. For bidding best practices click here. Bid amoung: Default CPM bid by Country…'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-6.png' ),
        alt: 'Daily Budgets, Day Parting, Frequency Capping.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-7.png' ),
        alt: 'Tracking Method. For accurate reporting, please make sure to refer to our Supported Macros.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-8.png' ),
        alt: 'Direct Sold: Campaigns: Direct Sold - April Full Sponsorship - Jan01_Apr… Edit Campaign Targeting. This campaign is currently paused. Once you add creatives, the campaign can be activated from the Campaign Management section. Ads. + Clone Ads, + Create Ads.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-9.png' ),
        alt: 'Edit Creative Set: Name, Assets, Text Assets, Ad Outpus, Countries, Languages.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-10.png' ),
        alt: 'Direct Sold Campaigns, Frequency Capping'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-11.png' ),
        alt: 'Waterfall Preview: Please select a country to preview the waterfall based on the manually entered CPM values in the MAX ad unit page. Note that the changes made on the ad unit page will be reflected in the waterfall preview immediately.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-12.png' ),
        alt: 'Direct Sold: Campaigns. Customize Columns.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-13.png' ),
        alt: 'Budget: ☐ Daily, ☑ Total: ☑ Impression target: ☑ Single total budget for all countries selected, ☐ Total budget by Country; ☐ Spend target; Budget Pacing: ☑ Spread Evenly, ☐ As Soon As Possible.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-14.png' ),
        alt: 'Create Creative. Name input field. Creative Tag: Ad Type drop-down. Drag & Drop your files or Browse. Portrait Interstitial Image. Countries radio buttons: ☑ All Countries, ☐ Specific Countries. Languages checkboxes. Tracking URLs: Impression Tracking URL input field. Click Tracking URL input field. Save button. Cancel button. This may take several minutes depending on how many ads you are creating and the file sizes.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-15.png' ),
        alt: 'Tracking URLs. Impression Tracking URL. Enter Impression Tracking URL (input field). Remove. + Add New Impression Tracking URL.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-16.png' ),
        alt: 'Ad Control Settings. By default, fullscreen creative types will use account default ad control settings (skip, close). You can override those settings for this specific creative in this section. These settings are only eligible for fullscreen creative types. Non-Rewarded Video Skip Button. Radio Buttons: Use Defaults, Custom Delay. Drop-down: 3 Seconds. Non-Rewarded Video Endcard Close Button. Radio Buttons: Use Defaults, Custom Delay. Drop-down: 15 Seconds. Save button. Cancel button.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-17.png' ),
        alt: 'Direct Sold > Campaigns. Campaign Management. Search field. Dates. Run Report button. Columns button. Clone Campaign button. Create Campaign button. Table of campaigns: Order, Campaign, Created, Start Date, End Date, Budget Type, Budget, Imp, Clicks, CTR, Spend, Status.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-18.png' ),
        alt: 'Clone Campaign. Copying a campaign will copy targeting, default bids/CPM values, tracking URLs, and frequency capping. It will not copy over the ads saved or budget settings. Once the new campaign is created, you can select the “Clone Ads” option in the Ads tab if you wish to use ads from the original campaign, and update the budget settings in the edit targeting page. Select a Campaign to Copy. Order. Save button. Cancel button.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-19.png' ),
        alt: 'Ads tab. Country: All Countries. Device: All Devices. Search field. Dates. Run Report button. Export button. Clone Ads button. Create Ads button. Table of ads: Ad, Created, Impression, Clicks, CTR, Spend, eCPM, Status.'
    },
    {
        imageSrc: require( '../images/DirectSold/direct-sold-20.png' ),
        alt: 'Clone Ads. First select from the campaign(s), then choose the creative concepts you wish to clone. If you want to clone ads that are currently paused or if you don’t want to clone all live ads, make sure to expend the tree further to select the exact ads to clone. Set cloned ads live checkbox. Save button. Cancel button.'
    },
];

export const DOCS_WATERFALL_SEGMENTATION_IMAGES = [
    {
        imageSrc: require( '../images/WaterfallSegmentation/image1.png' ),
        alt: 'Edit Ad Unit: Name text field, Platform radio buttons (Android, Fire OS, iOS), Ad Type radio buttons (Banner, Interstitial, MREC, Native, Rewarded). Import Existing Ad Unit button. Create New Waterfall button'
    },
    {
        imageSrc: require( '../images/WaterfallSegmentation/image2.png' ),
        alt: 'Create New Waterfall: Create a New Waterfall feature allows filtering traffic based on the user segmentation targeting rule selected below. Once enabled, traffic that is filtered out due to ineligibility will continue to use Default Waterfall configuration. Waterfall Name text field. Waterfall Targeting: Device Targeting radio buttons (All Devices, Only Devices with IDFA present, Only Devices without IDFA present). Copy default waterfall when creating (can be edited later). Cancel button. Create New Waterfall button.'
    },
    {
        imageSrc: require( '../images/WaterfallSegmentation/image3.png' ),
        alt: 'Edit Ad Unit: Name text field. Platform radio buttons (Android, iOS). Ad Type radio buttons (Banner, Interstitial, MREC, Rewarded). Limited Ad Tracking Enabled Users. Create New Waterfall. Participating Networks. Preview Waterfall. Create AB Test. Delete Waterfall.'
    },
    {
        imageSrc: require( '../images/WaterfallSegmentation/image4.png' ),
        alt: 'Advanced Reporting. Select a Saved Report. yesterday, Run Report, Hide Controls, Compare. Checkboxes: Day, Hour, Application, Network, Network Placement, Ad Unit Name, Placement, Platform, Country, Ad Type, Has IDFA. Table: Ad Unit Name, Waterfall, Ad Type, Requests, Impressions, Estimated Revenue, eCPM.'
    },
    {
        imageSrc: require( '../images/WaterfallSegmentation/image5.png' ),
        alt: 'Edit Ad Unit: Name text field, Platform radio buttons (Android, Fire OS, iOS), Ad Type radio buttons (Banner, Interstitial, MREC, Native, Rewarded). Clone Existing Waterfalls button. Create New Waterfall button'
    },
    {
        imageSrc: require( '../images/WaterfallSegmentation/image6.png' ),
        alt: 'Clone Existing Waterfalls. Select Waterfalls. Selected waterfalls from selected ad unit will be copied over. By default, network geo targeting and CPM settings will be copied over. In order to include network placement I.D.s, please select the option at the bottom. Direct sold campaigns will not be copied over. Nested checkboxes representing waterfalls. Copy all network placement IDs as well (checkbox). Cancel button. Clone Waterfalls button.'
    },
]

export const GET_STARTED_WITH_MAX_IMAGES = [
    {
        imageSrc: require( '../images/GetStartedWithMax/image1a.png' ),
        alt: 'Add Your App. To get started, please choose the platform and enter the application name. ○ Android, ○ iOS'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image1b.png' ),
        alt: 'Add Your App. To get started, please choose the platform and enter the application name. ● Android, ○ iOS. “demoapp”'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image2a.png' ),
        alt: 'Manually Create Application: If your application has already initialized the AppLovin SDK with your unique SDK key or is live in the app store, you do not need to manually create an application. For manually entered apps, packaga name casing must match exactly what is integrated in your app to start serving ads. Application Package Name: “com.myorg.mynewapp”. Cancel. Create.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image3.png' ),
        alt: 'Manage Network. Network Credentials: Please enter your account settings. ⓘ To access your settings, login to your dashboard and navigate to any of your apps and go to the app Settings page. Then navigate to the API Keys tab to access your Publisher Reporting API Key.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image4.png' ),
        alt: 'Manage Networks. Please connect all networks to use the Network Comparison and Auto-CPM features in your MAX account. ⓘ. Network: AdColony. Supported Ad Units. Status. Settings. Click here to add another instance of a network.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image5.png' ),
        alt: 'Performance Reporting. Select a Saved Report. Network, 7 Days, SUB. View by: County. Filter. Compare. Estimated Revenue. Impressions. eCPM'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image6.png' ),
        alt: 'User Activity. Select a Saved Report. Chart / Table. View by: Device Type. Filter. Compare. Yesterday / 7 days / 30 days / Custom. All Ad Types / Rewarded / Interstitial / Banner / MREC. DAU, DAV, Estimated Revenue, ARPDAU, Ad Viewer Rate, Impressions per DAU.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image7.png' ),
        alt: 'Advanced Reporting. Select a Saved Report: Chart/Table. Run Report. View By. X-axis. Y-axis. Hide Controls. Export as CSV. Hour / Master Publishing Account (MPA) / Account / Application / Network / Network Placement / Ad Unit Name / Waterfall / Ad Unit Test / Ad Placement / Platform / Country / Ad Type / Has IDFA'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image8.png' ),
        alt: 'Advanced Reporting. 2020-07-20 2020-07-27. Run Report. Hide Controls. Compare: ON. Compare Mode: Individual date selected as the ‘End Date’ will be compared to the ‘Start Date’ in your report. Result will be expressed as an absolute difference and a percentage change. Enable Compare Mode. Remove.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image9.png' ),
        alt: 'Cohorts. Save Report. Yesterday / 7 days / 30 days / Custom. All Ad Types / Rewarded / Interstitial / Banner / MREC. View by: None. Filter. Daily RPI, Retention (Day 1), Daily Impressions/User. Application / Country / Platform'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image10.png' ),
        alt: 'Advanced Reporting. Run Report button. ☑ Day, ☐ Hour, ☐ Master Publishing Account (MPA) checkboxes. Select a Saved Report drop-down menu: Edit/Update Report option, Save as New Report option, Delete Report option.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image11.png' ),
        alt: 'Save/Schedule Report. Report Name input field. Scheduled Report on/off toggle. Frequency drop-down: Daily. Report will be sent in the window between 3:00 AM UTC to 16:00 PM UTC each day. Recipients input field (email addresses). Cancel button. Save button.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image12.png' ),
        alt: 'Drop-down menu: Edit/Update Report option, Save as New Report option, Delete Report option.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/enable5.png' ),
        alt: 'Bidder Networks: AdColony. Status toggle. App ID text field. Zone ID text field.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/enable6.png' ),
        alt: 'Other Networks: Google Ad Manager. Status toggle. Placement ID text field. CPM Price text field. Country Targeting drop-down.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/enable7.png' ),
        alt: 'Ogury cannot be enabled with different Asset Key'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image13.png' ),
        alt: 'Manage Networks. Please connect networks to get accurate network reporting in your MAX account. Search for networks. Table of networks: Network, Supported Ad Units, Status.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image14.png' ),
        alt: 'Manage Network. Network Credentials. Please enter your AdColony account settings. To access your AdColony settings, log into your dashboard and navigate to your Account Settings section to access your API key.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image15.png' ),
        alt: 'Manage Network. Custom Network Name input field. Banner tab. Custom Network Tag input field.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image16.png' ),
        alt: 'Default Waterfall. Bidder Networks list. Other Networks list.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image17.png' ),
        alt: 'Waterfall Preview. Please select a country to preview the waterfall based on the manually entered CPM values in the MAX ad unit page. Note that the changes made on the ad unit page will be reflected in the waterfall preview immediately. Country input. Bidder Networks. Other Networks.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image18.png' ),
        alt: 'Ad Units > New Ad Unit. Create New Ad Unit. Name input field. Platform radio buttons: Android, Fire OS, iOS. Ad Type radio buttons: Banner, Interstitial, MREC, Native, Rewarded.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/image19.png' ),
        alt: 'No results found. You can search for apps that are live in the play store to select an app or manually add your package name for apps that are not live in the store. Note that package names used are case sensitive.'
    },
    {
        imageSrc: require( '../images/GetStartedWithMax/alx1.png' ),
        alt: 'AppLovin Exchange Reporting. Save/Schedule Report button. Run Report button. Checkboxes: Day, Hour, DSP, Application, Ad Unit Name, Waterfall, Ad Unit Test, Ad Placement, Platform, Country, Ad Type, Has IDFA.'
    },
];

export const DSP_IMAGES = [
    {
        imageSrc: require( '../images/DSP/testing0.png' ),
        alt: 'DSP Integrations. Interstitials: Full screen ads; Graphic or video. Rewarded Videos: Full screen rewarded ads. Native: Medium template ads. Banners: 320 by 50 Banner ads. MRECs: 300 by 250 Rectangular ads. Advanced. Ad Debugging: Debug custom bid responses and ad markup. Settings: Account and Request Settings. AppLovin DSP Demo. SDK Version: 11.0.0. iOS Version: 15.3.1.'
    },
];

export const CUSTOM_SDK_IMAGES = [
    {
        imageSrc: require( '../images/CustomSDKImages/image0.png' ),
        alt: 'Manage Networks > Create Custom Network. Manage Network. Custom Network Name input field. iOS AdapterClassName input field. Android Adapter Class Name input field.'
    },
    {
        imageSrc: require( '../images/CustomSDKImages/image1.png' ),
        alt: 'Custom Network (SDK) > Test SDK Network. Status (On). App ID input field. Placement ID input field. Custom Parameters input field. CPM Price input field. Country Targeting drop-down. + Add New Placement ID.'
    },
];

export const SDK_BIDDER_IMAGES = [
    {
        imageSrc: require( '../images/SDKBidderImages/image.png' ),
        alt: 'Device: Publisher App makes Ad Request to MAX SDK; Token abc goes to Demand Source 1 Adapter and then to Demand Source 1 SDK; Token def goes to Demand Source 2 Adapter and then to Demand Source 2 SDK; Ad Request with both tokens goes to MAX Ad Server. MAX Server: Waterfall goes to Max Ad Server which communicates with AppLovin Exchange. Third Party Server: Demand Source Bidders send bid responses to MAX Ad Server and get bid requests with tokens in return. AppLovin Exchange communicates with DSPs one through three.'
    },
];

export const MAX_UI_IMAGES = [
    {
        imageSrc: require( '../images/MAXUI/BulkCSVAdUnitManager.png' ),
        alt: 'Bulk CSV Ad Unit Manager. Export and adjust your current ad units by clicking "Export Current Ad Unit Settings". If you would like to manage changes for a specific ad unit, we recommend using the MAX ad unit page. Direct sold changes are not supported. Export Ad Unit Settings button. Import your Ad Unit Settings CSV here by Drag and Drop or Browse Local Files.'
    },
    {
        imageSrc: require( '../images/MAXUI/ManageNetworkAutoCPM.png' ),
        alt: 'Manage Networks > Google bidding and Google AdMob. Manage Network. Google bidding and Google AdMob. Auto-CPM toggle. Network Credentials: You have successfully connected this account. To reconnect it with new credentials click here. Save button. Cancel button.'
    },
    {
        imageSrc: require( '../images/MAXUI/AutoCPM.png' ),
        alt: 'Ad Unit 1: $7, Include All. Ad Unit 2: $2, Exclude 5. + Add New Ad Unit button.'
    },
    {
        imageSrc: require( '../images/MAXUI/NetworkComparisonReport.png' ),
        alt: 'Network. Ad Type. MAX Imps. Network Imps. Imp Delta. MAX Rev. Network Rev. Rev Delta. Max CPM. Network CPM. CPM Delta.'
    },
    {
        imageSrc: require( '../images/MAXUI/CreateUser.png' ),
        alt: 'Create User. Name input field. Email input field. Password input field. Repeat Password input field. Permissions: AppDiscovery, MAX.'
    },
    {
        imageSrc: require( '../images/MAXUI/EnterYourInformation.png' ),
        alt: 'Enter Your Information. Please enter your details as they appear on your bank records. P.O. Box is not allowed. Type radio buttons: Individual / Company. Contact Email input field. Phone Number input field. First Name input field. Middle Name input field. Last Name input field. Company input field. Address input field.'
    },
    {
        imageSrc: require( '../images/MAXUI/PaymentEarningsHistory.png' ),
        alt: 'Payment & Earnings History. Payments tab. Payments History. Table: Approval date, Amount Submitted, Payment Method, Status, Download confirmation button. Export to Excel button.'
    },
    {
        imageSrc: require( '../images/MAXUI/DirectSoldReporting.png' ),
        alt: 'Direct Sold Reporting. Select a Saved Report drop-down. Dates. Run Report button. Hide Controls button. Compare Mode toggle. Checkboxes: Day, Hour, Master Publishing Account, Account, Application, Platform, Country (Enter filter value and/or use checkbox to add column), Campaign Order, Campaign, Ad, Ad Format. Table: Platform, Impressions, Clicks, CTR, Estimated Revenue.'
    },
    {
        imageSrc: require( '../images/MAXUI/appadstxt.png' ),
        alt: 'applovin.com, 9eaf9ad6dc92d5fcn6f47c30168fb8fq, DIRECT; mintegral.com, 19435, DIRECT, 0aeed123c80d6423; google.com, pub-3940498599942544, DIRECT, f08c47fec0986fa0; adcolony.com, 197af3936679d34e, RESELLER, 1ad675c9de6b5176'
    },
    {
        imageSrc: require( '../images/MAXUI/ReportingTimeframe.png' ),
        alt: 'Advanced Reporting. Run Report. Previous Month. Start Date. End Date.'
    },
    {
        imageSrc: require( '../images/MAXUI/AdvancedReportingNetwork.png' ),
        alt: 'Advanced Reporting. Network: AppLovin Bidding, AppLovin Exchange.'
    },
    {
        imageSrc: require( '../images/MAXUI/PaymentsInfo.png' ),
        alt: 'Accounts > Payments Info. Phone Number. First Name. Middle Name. Last Name. Address. Address 2. City. Zip. Country. State.'
    },
    {
        imageSrc: require( '../images/MAXUI/MediationDebugger.png' ),
        alt: 'MAX. SDK Version: 11.6.0. Plugin Version: None. Ad Review Version: ❌. app-ads.txt: ✅.'
    }
];

export const API_MANIFEST: ApiManifest = {
    [ ApiType.AD_UNIT_MANAGEMENT_API ]: {
        ad_unit: [
            {
                name: 'ad_format',
                description: 'The format of the Ad Unit.',
                example: 'INTER{SPACE}BANNER{SPACE}REWARD',
                extras: {
                    requiredOnCreate: 'TRUE',
                }
            },
            {
                name: 'disabled',
                description: 'Whether or not this Ad Unit is Disabled (read-only).',
                example: 'false',
                extras: {
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'has_active_experiment',
                description: 'Whether or not this Ad Unit has an active experiment (read-only).',
                example: 'false',
                extras: {
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'id',
                description: 'The Ad Unit ID. Do not include this when you create an Ad Unit. This is returned in the response to a creation request.',
                example: '1234567890abcdef',
                extras: {
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'name',
                description: 'The name of the Ad Unit.',
                example: '"Mr. Bullet Rewarded"',
                extras: {
                    requiredOnCreate: 'TRUE',
                }
            },
            {
                name: 'package_name',
                description: 'The package name / bundle ID of the app associated with this Ad Unit.',
                example: 'com.my.test.app',
                extras: {
                    requiredOnCreate: 'TRUE',
                }
            },
            {
                name: 'platform',
                description: 'The platform of the Ad Unit.',
                example: 'ios{SPACE}android',
                extras: {
                    requiredOnCreate: 'TRUE',
                }
            },
            {
                name: 'template_size',
                description: 'The native ad template. Native ad units only.',
                example: 'small_template_1{SPACE}medium_template_1{SPACE}custom_template_1',
                extras: {
                    requiredOnCreate: 'TRUE',
                }
            },
        ],
        ad_units: [
            {
                name: 'name',
                description: 'The name of the Ad Unit.',
                example: '"Mr. Bullet Rewarded"',
            },
            {
                name: 'platform',
                description: 'The platform of the Ad Unit.',
                example: 'ios{SPACE}android',
            },
            {
                name: 'package_name',
                description: 'The package name / bundle ID of the app associated with this Ad Unit.',
                example: 'com.my.test.app',
            },
            {
                name: 'ad_format',
                description: 'The format of the Ad Unit.',
                example: 'INTER{SPACE}BANNER{SPACE}REWARD',
            },
            {
                name: 'ad_unit_id',
                description: 'The Ad Unit ID.',
                example: '1234567890abcdef',
            },
            {
                name: 'has_active_experiment',
                description: 'Whether or not this Ad Unit has an active experiment (read-only).',
                example: 'false',
            },
            {
                name: 'disabled',
                description: 'Whether or not this Ad Unit is Disabled (read-only).',
                example: 'false',
            },
        ],
        ad_units_test: [
            {
                name: 'id',
                description: 'The Ad Unit ID (Same as Parent Ad Unit ID).',
                example: '"e74c3b7797b0ce7a"',
                extras: {
                    required: 'TRUE on Edit, Promote, or Deprecate; FALSE on Create (must be missing or empty).',
                }

            },
            {
                name: 'experiment_name',
                description: 'The name of the Ad Unit Experiment.',
                example: '"aggressive_freq_caps"',
                extras: {
                    required: 'TRUE on Create and Edit, FALSE on Promote and Deprecate.',
                }
            },
            {
                name: 'disabled',
                description: 'Whether the Ad Unit is disabled.',
                example: 'false',
                extras: {
                    required: 'FALSE (read-only)',
                }
            },
            {
                name: 'promote',
                description: 'Whether you want to promote this Experiment.',
                example: 'true',
                extras: {
                    required: 'Set this to true when you are Promoting, FALSE otherwise',
                }
            },
            {
                name: 'deprecate',
                description: 'Whether you want to deprecate this Experiment.',
                example: 'true',
                extras: {
                    required: 'Set this to true when you are Deprecating, FALSE otherwise',
                }
            },
            {
                name: 'test_group_allocation',
                description: 'Percentage of users that are part of this test. Possible values are: 50, 25, 10, and 5.',
                example: '25',
                extras: {
                    required: 'FALSE',
                }
            },
            {
                name: 'ad_network_settings',
                description: 'Ad Network Configuration.',
                example: 'See the /ad_unit/AD_UNIT_ID section.',
                extras: {
                    required: 'FALSE',
                }
            },
            {
                name: 'frequency_capping_settings',
                description: 'Frequency Cap Settings.',
                example: 'See the /ad_unit/AD_UNIT_ID section.',
                extras: {
                    required: 'FALSE',
                }
            },
            {
                name: 'bid_floors',
                description: 'Bid Floors.',
                example: 'See the /ad_unit/AD_UNIT_ID section.',
                extras: {
                    required: 'FALSE',
                }
            },
        ],
        ad_network: [
            {
                name: 'disabled',
                description: 'Indicates whether this network is enabled or disabled in this Ad Unit.',
                example: 'false',
                extras: {
                    required: 'FALSE',
                }
            },
            {
                name: 'ad_network_app_id',
                description: 'The Network App ID. Some networks will not have a value for this. See the Ad Networks table below.',
                example: 'ca-app-pub-3555987499620362~3024971981',
                extras: {
                    required: 'Depends on the Ad Network',
                }
            },
            {
                name: 'ad_network_app_key',
                description: 'The Network App Key. Some networks will not have a value for this. See the Ad Networks table below.',
                example: '123456789',
                extras: {
                    required: 'Depends on the Ad Network',
                }
            },
            {
                name: 'ad_network_ad_units',
                description: 'A list of objects that describe specific ad network Ad Units.',
                example: 'See Below',
                extras: {
                    required: 'Depends on the Ad Network',
                }
            },
            {
                name: 'frequency_cap_settings',
                description: 'Deprecated, see frequency_capping_settings',
                example: '',
                extras: {
                    required: 'FALSE',
                }
            },
            {
                name: 'frequency_capping_settings',
                description: 'A list of objects that describe how to frequency cap this ad unit.',
                example: 'See "The frequency_capping_settings Object" below',
                extras: {
                    required: 'FALSE',
                }
            },
            {
                name: 'bid_floors',
                description: 'An Object that describes the CPM floors for this Ad Unit. See details below.',
                example: 'See Below',
                extras: {
                    required: 'FALSE',
                }
            },
        ],
        ad_network_ad_unit: [
            {
                name: 'ad_network_ad_unit_id',
                description: 'The ID of this Ad Network Ad Unit. Some networks do not have a value for this and may return “N/A”. See the Ad Networks table below.',
                example: 'ca-app-pub-3555987499620362/4382996128',
                extras: {
                    required: 'TRUE',
                }
            },
            {
                name: 'disabled',
                description: 'Indicates if this Ad Network Ad Unit is active.',
                example: 'false',
                extras: {
                    required: 'FALSE',
                }
            },
            {
                name: 'cpm',
                description: 'The CPM that will be paid for each impression of this Ad Unit.',
                example: '20.00',
                extras: {
                    required: 'TRUE, except for Bidding networks',
                }
            },
            {
                name: 'countries',
                description: `An object that describes any country whitelisting/blacklisting for this particular Ad Network Ad Unit.`,
                example: 'See Below',
                extras: {
                    required: 'TRUE',
                }
            },
        ],
        ad_network_ad_unit_countries: [
            {
                name: 'type',
                description: 'Indicates whether these countries should be whitelisted or blacklisted.',
                example: 'INCLUDE{SPACE}EXCLUDE',
                extras: {
                    required: 'TRUE',
                }
            },
            {
                name: 'values',
                description: `A list of two-letter ISO country codes. An empty list means all countries, regardless of whether \`type\` is \`INCLUDE\` or \`EXCLUDE\` .`,
                example: `["us", "ca", "jp"]`,
                extras: {
                    required: 'TRUE',
                }
            },
        ],
        ad_unit_frequency_cap: [
            {
                name: 'type',
                description: 'The type of frequency cap to use.',
                example: 'time{SPACE}session',
                extras: {
                    required: 'TRUE',
                }
            },
            {
                name: 'time_capping_settings',
                description: 'An object that describes how many ads per day ( \`day_limit\` ) along with how many minutes between ads ( \`minute_frequency\` ). Set \`day_limit\` and \`minute_frequency\` to 0 if \`type=session\` .',
                example: `{"day_limit": 10, "minute_frequency": 10}`,
                extras: {
                    required: 'TRUE, if type=time',
                }
            },
            {
                name: 'session_capping_settings',
                description: 'An object that descibes the maximum ads per session ( \`session_limit\` ) a user should see. Set \`session_limit=0\` if \`type=time\` .',
                example: '{"session_limit": 10}',
                extras: {
                    required: 'TRUE, if type=session',
                }
            },
            {
                name: 'countries',
                description: 'Countries that this cap should apply to. See The countries Object for a description of the fields. Frequency capping currently only supports type=INCLUDE. Countries in frequency_capping_objects must be disjoint',
                example: `{
    "type": "INCLUDE",
    "values": ["at", "pt", "ro", "se", "si", "sk"]
}`,
                extras: {
                    required: 'TRUE',
                }
            },
        ],
        ad_unit_bid_floors: [
            {
                name: 'country_group_name',
                description: 'A name that describes the country group.',
                example: '"T1 EN Speaking"',
                extras: {
                    required: 'TRUE',
                }
            },
            {
                name: 'cpm',
                description: `The minimum CPM that will be paid for each impression of this Ad Unit. If no ads can hit this limit for a country in this group, the ad request will not be filled.`,
                // [PLP] who will pay? who will not fill?
                example: '2.00',
                extras: {
                    required: 'TRUE',
                }
            },
            {
                name: 'countries',
                description: `A list of countries to associate with this bid floor. See “The countries Object” above for the description of this object. Only \`type=INCLUDE\` is supported here.`,
                example: `{
    "type": "INCLUDE",
    "values": ["at", "pt", "ro", "se", "si", "sk"]
}`,
                extras: {
                    required: 'TRUE',
                }
            },
        ],
        banner_refresh_settings: [
            {
                name: 'interval',
                description: 'The number of seconds to wait before refreshing a banner placement. Possible values are 0, 10, 15, 20, 30, 45, 60, and 300.',
                example: '10',
            },
        ],
        mrec_refresh_settings: [
            {
                name: 'interval',
                description: 'The number of seconds to wait before refreshing an MREC placement. Possible values are 0, 5, 10, 15, 20, 30, 45, 60, and 300.',
                example: '10',
            },
        ],
        // TODO: IMPORTANT: whenever a new MAX ad network is supported, please add it to the following list:
        ad_networks: [
            {
                name: 'Google bidding and Google AdMob',
                description: 'ADMOB_NETWORK',
                extras: {
                    adNetworkAppId: 'Google App ID',
                    adNetworkAdUnitId: 'Ad Unit ID',
                }
            },
            {
                name: 'Amazon',
                description: 'AMAZON_MARKETPLACE_NETWORK',
                extras: {
                    adNetworkAppId: 'SDK Key',
                    adNetworkAdUnitId: 'Slot ID',
                }
            },
            {
                name: 'BidMachine',
                description: 'BIDMACHINE_BIDDING',
                extras: {
                    adNetworkAppId: 'Source ID',
                    adNetworkAdUnitId: 'N/A',
                }
            },
            {
                name: 'Chartboost',
                description: 'CHARTBOOST_NETWORK',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAppKey: 'App Signature',
                    adNetworkAdUnitId: 'Ad Location',
                }
            },
            {
                name: 'CSJ',
                description: 'CSJ_NETWORK',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAdUnitId: 'Ad Placement ID',
                }
            },
            {
                name: 'Direct Sold',
                description: 'Direct_Sold',
                extras: { }
            },
            {
                name: 'DT Exchange',
                description: 'FYBER_NETWORK',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAdUnitId: 'Spot ID',
                }
            },
            {
                name: 'Google Ad Manager',
                description: 'GOOGLE_AD_MANAGER_NETWORK',
                extras: {
                    adNetworkAdUnitId: 'Placement ID',
                }
            },
            {
                name: 'HyprMX',
                description: 'HYPRMX_NETWORK',
                extras: {
                    adNetworkAppId: 'Distributor ID',
                    adNetworkAdUnitId: 'Placement Name',
                }
            },
            {
                name: 'InMobi',
                description: 'INMOBI_NETWORK',
                extras: {
                    adNetworkAppId: 'Account ID',
                    adNetworkAdUnitId: 'Placement ID',
                }
            },
            {
                name: 'InMobi Bidding',
                description: 'INMOBI_BIDDING',
                extras: {
                    adNetworkAppId: 'Account ID',
                    adNetworkAdUnitId: 'Placement ID',
                }
            },
            {
                name: 'IronSource',
                description: 'IRONSOURCE_NETWORK',
                extras: {
                    adNetworkAppId: 'App Key',
                    adNetworkAdUnitId: 'Instance ID',
                }
            },
            {
                name: 'LINE',
                description: 'LINE_NETWORK',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAdUnitId: 'Slot ID',
                }
            },
            {
                name: 'LINE Native',
                description: 'LINE_NATIVE_NETWORK',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAdUnitId: 'Slot ID',
                }
            },
            {
                name: 'Maio',
                description: 'MAIO_NETWORK',
                extras: {
                    adNetworkAppId: 'Media ID',
                    adNetworkAdUnitId: 'Zone ID',
                }
            },
            {
                name: 'Meta Audience Network Bidding',
                description: 'FACEBOOK_NETWORK',
                extras: {
                    adNetworkAdUnitId: 'Placement ID',
                }
            },
            {
                name: 'Meta Audience Network Native Bidding',
                description: 'FACEBOOK_NATIVE_BIDDING',
                extras: {
                    adNetworkAdUnitId: 'Placement ID',
                }
            },
            {
                name: 'Meta Audience Network',
                description: 'FACEBOOK_MEDIATE',
                extras: {
                    adNetworkAdUnitId: 'Placement ID',
                }
            },
            {
                name: 'Mintegral*',
                description: 'MINTEGRAL_NETWORK',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAppKey: 'App Key',
                    adNetworkAdUnitId: 'Ad Unit ID',
                }
            },
            {
                name: 'Mintegral Bidding*',
                description: 'MINTEGRAL_BIDDING',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAppKey: 'App Key',
                    adNetworkAdUnitId: 'Ad Unit ID',
                }
            },
            {
                name: 'MobileFuse',
                description: 'MOBILEFUSE_NETWORK',
                extras: {
                    adNetworkAppId: 'Publisher ID',
                    adNetworkAdUnitId: 'Placement ID',
                }
            },
            {
                name: 'VK Ad Network',
                description: 'MYTARGET_NETWORK',
                extras: {
                    adNetworkAdUnitId: 'Placement ID',
                }
            },
            {
                name: 'VK Ad Network Bidding',
                description: 'MYTARGET_BIDDING',
                extras: {
                    adNetworkAdUnitId: 'Placement ID',
                }
            },
            {
                name: 'Ogury',
                description: 'OGURY_PRESAGE_NETWORK',
                extras: {
                    adNetworkAppId: 'Asset Key',
                    adNetworkAdUnitId: 'Ad Unit ID',
                }
            },
            {
                name: 'Pangle',
                description: 'TIKTOK_NETWORK',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAdUnitId: 'Slot ID',
                }
            },
            {
                name: 'Pangle Bidding',
                description: 'TIKTOK_BIDDING',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAdUnitId: 'Slot ID',
                }
            },
            {
                name: 'Pangle Native',
                description: 'TIKTOK_NATIVE_NETWORK',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAdUnitId: 'Slot ID',
                }
            },
            {
                name: 'Smaato',
                description: 'SMAATO_NETWORK',
                extras: {
                    adNetworkAppId: 'Publisher ID',
                    adNetworkAdUnitId: 'Ad Space ID',
                }
            },
            {
                name: 'Smaato Bidding',
                description: 'SMAATO_BIDDING',
                extras: {
                    adNetworkAppId: 'Publisher ID',
                    adNetworkAdUnitId: 'Ad Space ID',
                }
            },
            {
                name: 'Tencent',
                description: 'TENCENT_NETWORK',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAdUnitId: 'Ad Slot ID',
                }
            },
            {
                name: 'Unity',
                description: 'UNITY_NETWORK',
                extras: {
                    adNetworkAppId: 'Game ID',
                    adNetworkAdUnitId: 'Placement ID',
                }
            },
            {
                name: 'Unity Bidding',
                description: 'UNITY_BIDDING',
                extras: {
                    adNetworkAppId: 'Game ID',
                    adNetworkAdUnitId: 'Placement ID',
                }
            },
            {
                name: 'Liftoff Monetize',
                description: 'VUNGLE_NETWORK',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAdUnitId: 'Placement Reference ID',
                }
            },
            {
                name: 'Liftoff Monetize Bidding',
                description: 'VUNGLE_BIDDING',
                extras: {
                    adNetworkAppId: 'App ID',
                    adNetworkAdUnitId: 'Placement Reference ID',
                }
            },
            {
                name: 'Yandex',
                description: 'YANDEX_NETWORK',
                extras: {
                    adNetworkAdUnitId: 'Block ID',
                }
            },
        ],
        errors: [
            {
                name: 'Bad Request',
                description: 'HTTP Response Code.',
                example: '400',
            },
            {
                name: 'Unauthorized',
                description: 'HTTP Response Code.',
                example: '401',
            },
            {
                name: 'Forbidden',
                description: 'HTTP Response Code.',
                example: '403',
            },
        ],
        segment: [
            {
                name: 'id',
                description: 'The waterfall ID associated with this segment. Don’t include this value when you create a new waterfall.',
                example: '81234',
            },
            {
                name: 'name',
                description: 'The name of this waterfall.',
                example: '"No-ID iPhones"',
            },
            {
                name: 'id_type',
                description: 'Device ID targeting. Options are \`"all"\` (default), \`"id_only"\` , \`"no_id"\` .',
                example: '"no_id"',
            },
            {
                name: 'device_type',
                description: 'Device type targeting. Options are \`"all"\` (default), \`"phones"\` , \`"tablets"\` .',
                example: '"tablets"',
            }
        ],
        test_device: [
            {
                name: 'name',
                description: 'The name of the test device.',
                example: '"My Test Device"',
                extras: { requiredOnCreate: 'TRUE', }
            },
            {
                name: 'device_id',
                description: 'The IDFA of the test device.',
                example: '"2fc1d626-22d4-4ba4-82e3-10ca1ad1abe1"',
                extras: { requiredOnCreate: 'TRUE', }
            },
            {
                name: 'disabled',
                description: 'Status of device ID (disabled or enabled).',
                example: 'false',
                extras: { requiredOnCreate: 'TRUE', }
            },
            {
                name: 'network',
                description: 'Network for which the device ID is enabled for test mode',
                example: 'APPLOVIN_NETWORK',
                extras: { requiredOnCreate: 'TRUE', }
            },
        ],
    },
    [ ApiType.MAX_REPORTING_API ]: {
        parameters: [
            {
                name: 'start',
                description: 'The first day you want in the report, in YYYY-MM-DD format.*',
                example: '2019-03-25'
            },
            {
                name: 'end',
                description: 'The last day you want in the report.*',
                example: '2019-03-29'
            },
            {
                name: 'api_key',
                description: 'Your API Report Key.',
                example: 'Hyfi8Mkct…WiWP466a1VBL7eUfUlD9JBh'
            },
            {
                name: 'columns',
                description: 'Which columns you want reported (see below). Comma-separated.',
                example: 'day,application,ecpm'
            },
            {
                name: 'filter_x', // [PLP] better to use <var>x</var> when possible
                description: 'Filter column x by a value (see table of columns below).',
                example: 'filter_max_ad_unit_id=deb878533ea4e76a'
            },
            {
                name: 'format',
                description: `Response format: \`csv\` or \`json\` .`,
                example: 'csv'
            },
            {
                name: 'limit',
                description: `Number of results to return. Use this together with \`offset\` to paginate API requests that have a large number of results.`,
                example: '1000'
            },
            {
                name: 'not_zero',
                description: 'Set to \`1\` to filter results in which all numerical metrics have a value of 0.',
                example: '1'
            },
            {
                name: 'offset',
                description: `How many entries to skip before returning results. If the value is larger than the total number of entries, an empty set will be returned.`,
                example: '0'
            },
            {
                name: 'sort_x', // [PLP] better to use <var>x</var> when possible
                description: `Sort the response by column x (see table of columns below). You can add multiple sorts with multiple \`sort_x\` parameters, and these will execute in the order in which the parameters appear in the query string. \`ASC\` (ascending) or \`DESC\` (descending) .`,
                example: 'sort_impressions=DESC'
            },
        ],
        columns: [
            {
                name: 'ad_format',
                description: `Ad unit ad type: \`INTER\` , \`BANNER\` , \`REWARD\` .`,
                example: 'INTER'
            },
            {
                name: 'ad_unit_waterfall_name',
                description: 'The name of the Ad Unit Waterfall.',
                example: 'LAT',
            },
            {
                name: 'application',
                description: 'Name of the application.',
                example: 'My App'
            },
            {
                name: 'attempts',
                description: `Number of attempts made to an ad network (can ONLY be shown if you include column \`network\` and/or \`network_placement\` ; CANNOT be shown if you include column \`max_placement\` ).`,
                example: '41734'
            },
            {
                name: 'country',
                description: 'Two-letter ISO Country Code.',
                example: 'gb'
            },
            {
                name: 'custom_network_name',
                description: 'Custom network name or Direct Sold campaign name.',
                example: 'Custom Network'
            },
            {
                name: 'day',
                description: 'Day of the data in YYYY-MM-DD format.',
                example: '2019-03-25'
            },
            {
                name: 'device_type',
                description: `The user’s device type: \`phone\` , \`tablet\` , \`other\` .`,
                example: 'phone'
            },
            {
                name: 'ecpm',
                description: 'Estimated eCPM generated in USD.',
                example: '8.47'
            },
            {
                name: 'estimated_revenue',
                description: 'Estimated revenue generated in USD.',
                example: '245.12'
            },
            {
                name: 'fill_rate',
                description: `responses / attempts (can ONLY be shown if you include column \`network\` and/or \`network_placement\` ; CANNOT be shown if you include column \`max_placement\` ).`,
                example: '.8512'
            },
            {
                name: 'has_idfa',
                description: `Does the user have an ad ID available. \`0\` if the user enabled LAT (Limit Ad Traffic) or opted out of data usage in GDPR geos, otherwise \`1\` .`,
                example: '0'
            },
            {
                name: 'hour',
                description: 'Hour of the data (only for dates within the last 30 days).',
                example: '20:00'
            },
            {
                name: 'impressions',
                description: 'Number of impressions shown.',
                example: '28942'
            },
            {
                name: 'max_ad_unit',
                description: 'MAX Ad Unit name.',
                example: 'Solitaire Rewarded'
            },
            {
                name: 'max_ad_unit_id',
                description: 'MAX Ad Unit id.',
                example: 'deb878533ea4e76a'
            },
            {
                name: 'max_ad_unit_test',
                description: 'MAX Ad Unit test group name (if applicable).',
                example: 'Control'
            },
            {
                name: 'max_placement',
                description: 'MAX mediation placement name (if applicable).',
                example: 'launch_screen'
            },
            {
                name: 'network',
                description: 'Ad Network name.',
                example: 'AppLovin'
            },
            {
                name: 'network_placement',
                description: 'Placement of the external Ad Network.',
                example: 'ca-app-pub-12345678/0987654321'
            },
            {
                name: 'package_name',
                description: 'Package Name/Bundle ID of the application.',
                example: 'com.my.test.app'
            },
            {
                name: 'platform',
                description: `Platform of the application: \`android\`, \`fireos\`, or \`ios\` .`,
                example: 'android'
            },
            {
                name: 'requests',
                description: `Number of ad requests (CANNOT be shown if you include column \`network\` , \`network_placement\` , or \`max_placement\` ).`,
                example: '45651'
            },
            {
                name: 'responses',
                description: `Number of responses from an ad network (can ONLY be shown if you include column \`network\` and/or \`network_placement\` ; CANNOT be shown if you include column \`max_placement\` ).`,
                example: '39841'
            },
            {
                name: 'store_id',
                description: 'The numeric portion of the iTunes ID on iOS, or the app’s package name on Android. If the iTunes ID is not known to AppLovin, the Bundle ID will be returned instead.',
                example: '1207472156'
            },
        ],
    },
    [ ApiType.USER_REVENUE_API ]: {
        request: [
            {
                name: 'aggregated',
                description: 'Whether the data should be aggregated (per user) or not (per impression). Defaults to \`true\` .',
                example: 'false'
            },
            {
                name: 'api_key',
                description: 'Reporting key, for authentication.',
                example: 'tgCe3d7SFRU0S…304ZKs6ba'
            },
            {
                name: 'application',
                description: 'Application package name (for Android) or bundle ID (for iOS). (You CANNOT use this parameter if you define \`store_id\` )',
                example: 'com.mycompany.application'
            },
            {
                name: 'date',
                description: 'Day to return data for, in YYYY-MM-DD format.*',
                example: '2019-02-06'
            },
            {
                name: 'platform',
                description: `Application platform: \`android\`, \`fireos\`, or \`ios\` .`,
                example: 'android'
            },
            {
                name: 'store_id',
                description: 'The numeric portion of the iTunes ID on iOS, or the app’s package name on Android. If you do not know the iTunes ID, use the bundle ID instead. You CANNOT use this parameter if you define \`application\` .',
                example: '1207472156'
            },
        ],
        response: [
            {
                name: 'ad_revenue_report_url',
                description: 'Location of the CSV file with all revenue including estimated Meta Audience Network Bidding data.'
            },
            {
                name: 'fb_estimated_revenue_url',
                description: 'Location of the CSV file with ONLY estimated Meta Audience Network Bidding data. '
                    + 'Please note that these numbers may differ from actuals since Meta Audience Network Bidding data is calculated using estimated revenue data. '
                    + 'This option is only available on aggregated requests.'
            },
            {
                name: 'status',
                description: 'Status of the request: 200 if a user report can be accessed.',
            },
            {
                name: 'url',
                description: 'Location of the CSV file that excludes estimated Meta Bidding data.',
            }
        ],
        csv: [
            {
                name: 'Ad Format',
                description: `\`INTER\` , \`BANNER\` , \`REWARD\` (Non-Aggregated only).`,
            },
            {
                name: 'Ad Placement',
                description: `The placement ID of the external ad network that showed the ad (Non-Aggregated only).`,
            },
            {
                name: 'Ad Unit ID',
                description: 'ID of the MAX Ad Unit from which the revenue was generated.',
            },
            {
                name: 'Ad Unit Name',
                description: 'Name of the MAX Ad Unit from which the revenue was generated (Non-Aggregated Only).',
            },
            {
                name: 'Country',
                description: 'The two-letter country code of the impression (Non-Aggregated only).',
            },
            {
                name: 'Custom Data',
                description: `Custom data passed in from the integration.`,
            },
            {
                name: 'Date',
                description: 'Time of the impression (Non-Aggregated only).',
            },
            {
                name: 'Device Type',
                description: '`PHONE` , `TABLET` (Non-Aggregated only).',
            },
            {
                name: 'IDFA',
                description: 'Advertising identifier: IDFA for iOS devices, GAID for Android devices.',
            },
            {
                name: 'IDFV',
                description: 'Identifier for vendor.',
            },
            {
                name: 'Impressions',
                description: 'The number of ads displayed to the user (Aggregated only).',
            },
            {
                name: 'Network',
                description: 'The Ad Network that generated the impression. '
                    + 'You can find Ad Network values in the Network API Name column of this page (Non-Aggregated `ad_revenue_report_url` only).',
                hasLink: true,
            },
            {
                name: 'Placement',
                description: 'The Ad Placement Name where the user generated Impressions and Revenue.',
            },
            {
                name: 'Revenue',
                description: 'The revenue generated by the user, in USD, expressed with six-decimal precision.',
            },
            {
                name: 'User ID',
                description: 'Optional ID of the user set via AppLovin SDK. (See the “Set Internal User ID” section below.)',
            },
            {
                name: 'Waterfall',
                description: 'MAX Ad Unit Waterfall name (Non-Aggregated only).',
            },
        ],
    },
    [ ApiType.MAX_COHORT_API ]: {
        request: [
            {
                name: 'start',
                description: 'First day you want included in the report, in YYYY-MM-DD format.†',
                example: '2019-03-25'
            },
            {
                name: 'end',
                description: 'Last day you want included in the report.†',
                example: '2019-03-29'
            },
            {
                name: 'api_key',
                description: `Your reporting API Key.`,
                example: 'Hyfi8Mkct…WiWP466a1VBL7eUfUlD9JBh'
            },
            {
                name: 'columns',
                description: 'Columns to be reported (see below). Comma-separated.',
                example: 'day,application,country'
            },
            {
                name: 'format',
                description: 'Response format: \`csv\` or \`json\` .',
                example: 'csv'
            },
            {
                name: 'filter_x', // [PLP] make this something like <var>x</var> when you can
                description: 'Filter column x by a value.',
                example: 'filter_platform=ios'
            },
            {
                name: 'limit',
                description: 'Limit the results set to some fixed number of items.',
                example: '100'
            },
            {
                name: 'not_zero',
                description: 'Set to \`1\` to filter results in which all numerical metrics have a value of 0.',
                example: '1'
            },
            {
                name: 'offset',
                description: 'Skips the first X items. You can use this (along with \`limit\` ) for pagination. If paginating, set \`offset=0\` on the first request to preserve result order.',
                example: '500'
            },
            {
                name: 'sort_x', // [PLP] make this something like <var>x</var> when you can
                description: `Sort the response by column x (see table of columns below). You can add multiple sorts with multiple \`sort_x\` parameters, and these will execute in the order in which the parameters appear in the query string. \`ASC\` (ascending) or \`DESC\` (descending) .`,
                example: 'sort_installs=DESC'
            },
        ],
        columns: [
            {
                name: 'day',
                description: 'Day of the data, in YYYY-MM-DD format.',
                example: '2019-03-25'
            },
            {
                name: 'application',
                description: 'Name of the application.',
                example: 'My App'
            },
            {
                name: 'package_name',
                description: `Package Name/Bundle ID of the application.`,
                example: 'com.my.test.app'
            },
            {
                name: 'platform',
                description: `Platform of the application: \`android\`, \`fireos\`, or \`ios\` .`,
                example: 'android'
            },
            {
                name: 'country',
                description: 'Two-letter ISO Country Code.',
                example: 'gb'
            },
            {
                name: 'installs',
                description: 'Number of new installers.',
                example: '2842'
            },
            {
                name: 'pub_revenue_X', // [PLP] in this and below, use something like <var>X</var> when you can
                description: 'Revenue generated within X* days of the install.',
                example: '39.35'
            },
            {
                name: 'iap_pub_revenue_X',
                description: 'Revenue generated from IAP within X* days of the install.',
                example: '21.23'
            },
            {
                name: 'ads_pub_revenue_X',
                description: 'Revenue generated from ads within X* days of the install.',
                example: '18.12'
            },
            {
                name: 'reward_pub_revenue_X',
                description: 'Revenue generated from Rewarded ads within X* days of the install.',
                example: '9.12'
            },
            {
                name: 'inter_pub_revenue_X',
                description: 'Revenue generated from (non-Rewarded) Interstitial ads within X* days of the install.',
                example: '6.10'
            },
            {
                name: 'banner_pub_revenue_X',
                description: 'Revenue generated from Banner ads within X* days of the install.',
                example: '2.54'
            },
            {
                name: 'mrec_pub_revenue_X',
                description: 'Revenue generated from MREC ads within X* days of the install.',
                example: '.48'
            },
            {
                name: 'rpi_X',
                description: 'Revenue per install generated within X* days of the install.',
                example: '.15'
            },
            {
                name: 'iap_rpi_X',
                description: 'Revenue per install generated from IAP within X* days of the install.',
                example: '.08'
            },
            {
                name: 'ads_rpi_X',
                description: 'Revenue per install generated from ads within X* days of the install.',
                example: '.07'
            },
            {
                name: 'reward_rpi_X',
                description: 'Revenue per install generated from Rewarded ads within X* days of the install.',
                example: '.05'
            },
            {
                name: 'inter_rpi_X',
                description: 'Revenue per install generated from (non-Rewarded) Interstitial ads within X* days of the install.',
                example: '.04'
            },
            {
                name: 'banner_rpi_X',
                description: 'Revenue per install generated from Banner ads within X* days of the install.',
                example: '.03'
            },
            {
                name: 'mrec_rpi_X',
                description: 'Revenue per install generated from MREC ads within X* days of the install.',
                example: '.02'
            },
        ],
        impColumns: [
            {
                name: 'day',
                description: 'Day of the data, in YYYY-MM-DD format.',
                example: '2019-03-25'
            },
            {
                name: 'application',
                description: 'Name of the application.',
                example: 'My App'
            },
            {
                name: 'package_name',
                description: `Package Name/Bundle ID of the application.`,
                example: 'com.my.test.app'
            },
            {
                name: 'platform',
                description: `Platform of the application: \`android\`, \`fireos\`, or \`ios\` .`,
                example: 'android'
            },
            {
                name: 'country',
                description: 'Two-letter ISO Country Code.',
                example: 'gb'
            },
            {
                name: 'installs',
                description: 'Number of new installers.',
                example: '2842'
            },
            {
                name: 'user_count_X', // [PLP] Here, and below, use something like <var>X</var> when you can
                description: 'Number of users active X* days after the install.',
                example: '612'
            },
            {
                name: 'imp_X',
                description: 'Number of impression from users X* days after the install.',
                example: '6120'
            },
            {
                name: 'imp_per_user_X',
                description: `Numer of impressions per user X days after the install \`imp_X\` / \`user_count_X\` .`,
                example: '10.0'
            },
            {
                name: 'inter_imp_X',
                description: 'Number of (non-Rewarded) Interstitial impressions from users X* days after the install.',
                example: '1224'
            },
            {
                name: 'inter_imp_per_user_X',
                description: '\`inter_imp_X\` / \`user_count_X\` .',
                example: '2.0'
            },
            {
                name: 'reward_imp_X',
                description: 'Number of Rewarded impressions from users X* days after the install.',
                example: '1836'
            },
            {
                name: 'reward_imp_per_user_X',
                description: '\`reward_imp_X\` / \`user_count_X\`',
                example: '3.0'
            },
            {
                name: 'banner_imp_X',
                description: 'Number of Banner impressions from users X* days after the install.',
                example: '2448'
            },
            {
                name: 'banner_imp_per_user_X',
                description: '\`banner_imp_X\` / \`user_count_X\`',
                example: '4.0'
            },
            {
                name: 'mrec_imp_X',
                description: 'Number of MREC impressions from users X* days after the install.',
                example: '612'
            },
            {
                name: 'mrec_imp_per_user_X',
                description: '\`mrec_imp_X\` / \`user_count_X\`',
                example: '1.0'
            },
        ],
        sessionColumns: [
            {
                name: 'day',
                description: 'Day of the data, in YYYY-MM-DD format.',
                example: '2019-03-25'
            },
            {
                name: 'application',
                description: 'Name of the application.',
                example: 'My App'
            },
            {
                name: 'package_name',
                description: `Package Name/Bundle ID of the application.`,
                example: 'com.my.test.app'
            },
            {
                name: 'platform',
                description: `Platform of the application: \`android\`, \`fireos\`, or \`ios\` .`,
                example: 'android'
            },
            {
                name: 'country',
                description: 'Two-letter ISO Country Code.',
                example: 'gb'
            },
            {
                name: 'installs',
                description: 'Number of new installers.',
                example: '2842'
            },
            {
                name: 'daily_usage_X', // [PLP] Here, and below, use something like <var>X</var> when you can
                description: 'Average amount of time spent by users X* days after the install. (seconds)',
                example: '501'
            },
            {
                name: 'session_count_X',
                description: 'Total number of user sessions  X* days after the install.',
                example: '1240'
            },
            {
                name: 'user_count_X',
                description: 'Number of users active X* days after the install.',
                example: '401'
            },
            {
                name: 'session_length_X',
                description: '\`daily_usage_X\` / \`session_count_X\`',
                example: '0.404'
            },
            {
                name: 'retention_X',
                description: '\`user_count_X\` / \`installs\`',
                example: '0.141'
            },
        ],
    },
    [ ApiType.DIRECT_SOLD_API ]: {
        request: [
            {
                name: 'start',
                description: 'The first day you want in the report, in YYYY-MM-DD HH:MM:SS or YYYY-MM-DD format.*',
                example: '2022-05-01 00:00:00, 2022-05-01'
            },
            {
                name: 'end',
                description: 'The last day you want in the report, in YYYY-MM-DD HH:MM:SS or YYYY-MM-DD format.*',
                example: '2022-05-03 00:00:00, 2022-05-03'
            },
            {
                name: 'api_key',
                description: 'Your API Report Key.',
                example: 'Hyfi8Mkct…WiWP466a1VBL7eUfUlD9JBh'
            },
            {
                name: 'format',
                description: 'Response format: \`csv\` or \`json\` .',
                example: 'csv'
            },
            {
                name: 'columns',
                description: 'Which columns you want reported (see below). Comma-separated.',
                example: 'day,application,impressions'
            },
            {
                name: 'filter_x', // [PLP] make this something like <var>x</var> when you can
                description: 'Filter column x to those with a specified value (see table of columns below).',
                example: 'filter_max_ad_unit_id=deb878533ea4e76a'
            },
            {
                name: 'filter_not_x', // [PLP] make this something like <var>x</var> when you can
                description: 'Filter column x to exclude those with a specified value (see table of columns below).',
                example: 'filter_not_max_ad_unit_id=deb878533ea4e76a'
            },
            {
                name: 'sort_x', // [PLP] make this something like <var>x</var> when you can
                description: `Sort the response by column x (see table of columns below). You can add multiple sorts with multiple \`sort_x\` parameters, and these will execute in the order in which the parameters appear in the query string. \`ASC\` (ascending) or \`DESC\` (descending) .`,
                example: 'sort_impressions=DESC'
            },
            {
                name: 'limit',
                description: 'Maximum number of results to return. Use this together with \`offset\` to paginate API requests that have a large number of results.',
                example: '1000'
            },
            {
                name: 'offset',
                description: 'How many entries to skip before returning results. If the value is larger than the total number of entries, an empty set will be returned.',
                example: '0'
            },
        ],
        columns: [
            {
                name: 'ad_format',
                description: `Ad unit ad type: \`INTER\` , \`BANNER\` , \`REWARD\` .`,
                example: 'INTER'
            },
            {
                name: 'ad_unit_waterfall_name',
                description: 'The name of the Ad Unit Waterfall.',
                example: 'LAT',
            },
            {
                name: 'application',
                description: 'Name of the application.',
                example: 'My App'
            },
            {
                name: 'campaign',
                description: 'Name of the campaign',
                example: 'My Campaign'
            },
            {
                name: 'campaign_id',
                description: 'Unique ID for the campaign',
                example: '524267'
            },
            {
                name: 'clicks',
                description: 'Number of clicks',
                example: '523'
            },
            {
                name: 'cost',
                description: 'Revenue generated in USD. Based on the value set in the campaign.',
                example: ''
            },
            {
                name: 'country',
                description: 'Two-letter ISO Country Code.',
                example: 'gb'
            },
            {
                name: 'creative',
                description: 'Creative set name',
                example: 'My creative set'
            },
            {
                name: 'creative_id',
                description: 'Unique ID for an ad creative',
                example: '524267'
            },
            {
                name: 'ctr',
                description: 'Click through rate. The percentage of impressions that resulted in a click.',
                example: '.23%'
            },
            {
                name: 'day',
                description: 'Day of the data in YYYY-MM-DD format.',
                example: '2019-03-25'
            },
            {
                name: 'device_type',
                description: `The user’s device type: \`phone\` , \`tablet\` , \`other\` .`,
                example: 'phone'
            },
            {
                name: 'has_idfa',
                description: `Does the user have an ad ID available. \`0\` if the user enabled LAT (Limit Ad Traffic) or opted out of data usage in GDPR geos, otherwise \`1\` .`,
                example: '0'
            },
            {
                name: 'impressions',
                description: 'Number of impressions shown.',
                example: '28942'
            },
            {
                name: 'max_ad_unit',
                description: 'MAX Ad Unit name.',
                example: 'Solitaire Rewarded'
            },
            {
                name: 'max_ad_unit_id',
                description: 'MAX Ad Unit id.',
                example: 'deb878533ea4e76a'
            },
            {
                name: 'max_ad_unit_test',
                description: 'MAX Ad Unit test group name (if applicable).',
                example: 'Control'
            },
            {
                name: 'order',
                description: 'Name of the order',
                example: 'My Order'
            },
            {
                name: 'order_id',
                description: 'Unique ID for an Order',
                example: '524267'
            },
            {
                name: 'package_name',
                description: 'Package Name/Bundle ID of the application.',
                example: 'com.my.test.app'
            },
            {
                name: 'platform',
                description: `Platform of the application: \`android\`, \`fireos\`, or \`ios\` .`,
                example: 'android'
            },
            {
                name: 'store_id',
                description: 'The numeric portion of the iTunes ID on iOS, or the app’s package name on Android. If the iTunes ID is not known to AppLovin, the Bundle ID will be returned instead.',
                example: '1207472156'
            },
        ]
    },
    [ ApiType.S2S_REWARDED_CALLBACK_API ]: {
        macros: [
            {
                name: '{AD_UNIT_ID}',
                description: 'MAX Ad Unit ID (16 hex characters)',
                example: '9ad0816ac071552a'
            },
            {
                name: '{AD_UNIT_NAME}',
                description: 'Ad Unit name (URL-encoded)',
                example: 'My%20App%20Banners'
            },
            {
                name: '{AMOUNT}',
                description: 'The amount of currency you choose to award the user. You set this in the Ad Unit edit page for each Ad Unit.',
                example: '100'
            },
            {
                name: '{CC}',
                description: 'Two-letter country code of the user',
                example: 'gb'
            },
            {
                name: '{CURRENCY}',
                description: 'The type of currency you choose to award the user (URL-encoded). You set this in the Ad Unit edit page for each Ad Unit.',
                example: 'coins'
            },
            {
                name: '{CUSTOM_DATA}',
                description: 'Custom data passed in from the integration (URL-encoded). AppLovin recommends that you keep the size of the string under 8192 characters.',
                example: 'my%20custom%20data'
            },
            {
                name: '{EVENT_ID}',
                description: 'Unique event ID, 40 hex characters',
                example: '8dc948013d71f04264b8e5c1c61933154b226e08'
            },
            {
                name: '{EVENT_TOKEN}',
                description: 'sha1( EVENT_ID + Your_Event_Key )',
                example: 'e000949f6d851c1f34adae08e6ef1076ba43cf31'
            },
            {
                name: '{EVENT_TOKEN_ALL}',
                description: 'sha256( All* macros alphabetically, URL-decoded + Your_Event_Key ) {NEWLINE}{NEWLINE} * Note: if \`EVENT_TOKEN\` is one of your macros, it is omitted from the “All macros alphabetically” string.',
                example: 'eba615583ed59bc679a495ec58439f4b82b5460d822348eff6be5f218702a97a'
            },
            {
                name: '{IDFA}',
                description: 'iOS IDFA or Google Advertising ID',
                example: '860635ea-65bc-eaed-d355-1b5283b30b94'
            },
            {
                name: '{IDFV}',
                description: 'IDFV',
                example: '4CD1C3C4-3FD7-00F5-1635-7BC6D9387E60'
            },
            {
                name: '{IP}',
                description: 'User’s IP (IPv6 values are URL-encoded)',
                example: '162.1.1.1{SPACE}fe80%3A%3A1ff%3Afe23%3A4567%3A890a%0A'
            },
            {
                name: '{NETWORK_NAME}',
                description: 'MAX Ad Network Name',
                example: 'APPLOVIN_BIDDING'
            },
            {
                name: '{PACKAGE_NAME}',
                description: 'App Package Name (Android) or Bundle ID (iOS). URL-encoded.',
                example: 'com.test.app'
            },
            {
                name: '{PLACEMENT}',
                description: 'Publisher-defined MAX ad placement name (URL-encoded)',
                example: 'Launch%20Screen'
            },
            {
                name: '{PLATFORM}',
                description: 'Platform',
                example: 'android{SPACE}ios'
            },
            {
                name: '{TS}',
                description: 'Timestamp of impression (integer, seconds since epoch)',
                example: '1546300800'
            },
            {
                name: '{USER_ID}',
                description: 'Publisher-defined user ID (URL-encoded); maximum length is 8192 characters',
                example: '7634657898'
            },
        ],
    },
    [ ApiType.S2S_IMPRESSION_REVENUE_API ]: {
        macros: [
            {
                name: '{AD_UNIT_ID}',
                description: 'MAX Ad Unit ID (16 hex characters)',
                example: '9ad0816ac071552a'
            },
            {
                name: '{AD_UNIT_NAME}',
                description: 'Ad Unit name (URL-encoded)',
                example: 'My%20App%20Banners'
            },
            {
                name: '{AD_UNIT_TEST_NAME}',
                description: 'Name of the ad unit test, URL encoded',
                example: 'Control'
            },
            {
                name: '{ALL_REVENUE}',
                description: 'Estimated revenue, including FB Bidding estimates',
                example: '0.0121{SPACE}5.74466e-05'
            },
            {
                name: '{CC}',
                description: 'Two-letter country code of the user',
                example: 'gb'
            },
            {
                name: '{CUSTOM_DATA}',
                description: 'Custom data passed in from the integration. AppLovin recommends that you keep the size of the string under 8192 characters. You must not include ampersand (&) characters in the custom data if you include this macro.',
                example: 'gb'
            },
            {
                name: '{DEVICE_TYPE}',
                description: 'User’s device type.',
                example: 'Tablet'
            },
            {
                name: '{EVENT_ID}',
                description: 'Unique event ID, 40 hex characters',
                example: '8dc948013d71f04264b8e5c1c61933154b226e08'
            },
            {
                name: '{EVENT_TOKEN}',
                description: 'sha1( EVENT_ID + Your_Event_Key )',
                example: 'e000949f6d851c1f34adae08e6ef1076ba43cf31'
            },
            {
                name: '{EVENT_TOKEN_ALL}',
                description: 'sha256( All macros alphabetically + Your_Event_Key ) {NEWLINE}{NEWLINE} Note: if you also include \`EVENT_TOKEN\` it will be omitted from the “All macros alphabetically” string.',
                example: 'eba615583ed59bc679a495ec58439f4b82b5460d822348eff6be5f218702a97a'
            },
            {
                name: '{FORMAT}',
                description: 'Ad Unit format',
                example: 'reward{SPACE}banner{SPACE}inter'
            },
            {
                name: '{IDFA}',
                description: 'iOS IDFA or Google Advertising ID',
                example: '860635ea-65bc-eaed-d355-1b5283b30b94'
            },
            {
                name: '{IDFV}',
                description: 'IDFV',
                example: '4CD1C3C4-3FD7-00F5-1635-7BC6D9387E60'
            },
            {
                name: '{IP}',
                description: 'User’s IP',
                example: '162.1.1.1{SPACE}fe80%3A%3A1ff%3Afe23%3A4567%3A890a%0A'
            },
            {
                name: '{NETWORK}',
                description: 'Name of the Ad Network that served the impression. Names should match the names used in the [Management](/documentation/mediation/features/ad-unit-automation-api#ad-networks) [API](/documentation/mediation/features/ad-unit-automation-api#ad-networks)',
                example: 'APPLOVIN_NETWORK'
            },
            {
                name: '{NETWORK_PLACEMENT}',
                description: 'Placement name of the external Ad Network',
                example: 'ca-app-pub-12345678%2F0987654321'
            },
            {
                name: '{PACKAGE_NAME}',
                description: 'App Package Name (Android) / Bundle ID (iOS)',
                example: 'com.test.app'
            },
            {
                name: '{PLACEMENT}',
                description: 'Publisher-defined MAX ad placement name (URL-encoded)',
                example: 'Launch%20Screen'
            },
            {
                name: '{PLATFORM}',
                description: 'Platform',
                example: 'android{SPACE}ios'
            },
            {
                name: '{PRECISION}',
                description: 'Information on how precise the revenue value is. Options are: ① `publisher_defined` if revenue is the price assigned to the line item by the publisher, ② `exact` if revenue is the resulting price of a real-time auction, ③ `estimated` if the revenue amount is based on Auto CPM or FB Bidding estimates, or ④ `undefined` if no line item amount is defined and there is not enough data to estimate.',
                example: 'exact'
            },
            {
                name: '{REVENUE}',
                description: 'Estimated revenue. Set to 0 when FB Bidding',
                example: '0.0121{SPACE}5.74466e-05'
            },
            {
                name: '{TS}',
                description: 'Timestamp of impression (integer, seconds since epoch)',
                example: '1546300800'
            },
            {
                name: '{USER_ID}',
                description: 'URL-encoded, publisher-defined, user ID; maximum length is 8192 characters',
                example: '7634657898'
            },
            {
                name: '{WATERFALL_NAME}',
                description: 'The name of the Ad Unit Waterfall',
                example: 'LAT'
            },
        ],
    },
    [ ApiType.MAX_REVENUE_API ]: {
        parameters: [
            {
                name: 'ad_format',
                description: 'The ad format of the ad.',
                example: 'BANNER, MREC, INTER, REWARDED'
            },
            {
                name: 'country_code',
                description: 'The revenue’s country code.',
                example: 'US (for the United States)'
            },
            {
                name: 'id',
                description: 'Unique internal ID for the serve.',
                example: '19017d954ffcded6c42772b09ec36699efe0bfc2'
            },
            {
                name: 'max_ad_unit_id',
                description: 'The MAX Ad Unit ID.',
                example: '65d8d0195e50bda6'
            },
            {
                name: 'network_name',
                description: 'Display name of the network which showed the ad.',
                example: 'AppLovin'
            },
            {
                name: 'revenue',
                description: 'A double representing the revenue amount.',
                example: '0.002067201'
            },
            {
                name: 'third_party_ad_placement_id',
                description: `The ad’s placement id, if any (bidding may not have one).`,
                example: 'inter_regular'
            },
            {
                name: 'user_segment',
                description: `The user segment of the user to whom the ad was shown.`,
                example: 'experiment5'
            }
        ]
    },
    [ ApiType.CAMPAIGN_MANAGEMENT_API ]: {
        third_party_app_auth_flow: [
            {
                name: 'response_type',
                description: 'Set to "code"',
                example: 'code',
            },
            {
                name: 'client_id',
                description: 'Client ID of your OAuth App',
                example: '34af7c430e24bbccbc647ca3dd5ac858',
            },
            {
                name: 'redirect_uri',
                description: 'Where to redirect the user after flow completion. This must be URL-encoded and match the \`redirect_uri\` defined in the OAuth creation process',
                example: 'https%3A%2F%2Fmydomain.com%2Foauth_code',
            },
            {
                name: 'scope',
                description: 'The scope(s) this app should use. Must be a subset of the scopes defined in the app. Make sure to URL-encode the value. Currently supporting: {NEWLINE} {NEWLINE}' +
                    'campaigns:read{NEWLINE}' +
                    'campaigns:write{NEWLINE}' +
                    'creatives:read{NEWLINE}' +
                    'creatives:write{NEWLINE}' +
                    'source_bids:read{NEWLINE}' +
                    'source_bids:write{NEWLINE}',
                example: 'campaigns%3Awrite%20creatives%3Awrite',
            },
            {
                name: 'state',
                description: 'An opaque value used by the client to maintain state between the request and callback',
                example: 'ab13221308fe6abad1d1',
            },
        ],
        third_party_app_auth_flow_response: [
            {
                name: 'code',
                description: 'The code value used to generate access and refresh tokens on behalf of the user. See section {API}(#api-request-authentication)  {Request}(#api-request-authentication)  {Authentication}(#api-request-authentication)',
                example: '9aa19842db327e4e43cc426e6ad6c2d1eacd2e3d464',
            },
            {
                name: 'state',
                description: 'The state that was passed to AppLovin’s initialization request echoed back',
                example: 'ab13221308fe6abad1d1',
            },
        ],
        authentication: [
            {
                name: 'client_id',
                description: 'Client ID of your OAuth App',
                example: '34af7c430e24bbccbc647ca3dd5ac858',
            },
            {
                name: 'client_secret',
                description: 'Client Secret of your OAuth App',
                example: '9538e854765525d0b34af7c430e24bbcdfd58b83f3836fd0e83cbfd1b',
            },
            {
                name: 'code',
                description: 'The \`code\` value from the Authorization callback to an external company’s \`redirect_url\`. '
                    + 'Required for \`grant_type=authorization_code\`, otherwise invalid',
                example: '9aa19842db327e4e43cc426e6ad6c2d1eacd2e3d464',
            },
            {
                name: 'grant_type',
                description: 'Type of grant. For first party apps, set to \`client_credentials\` . '
                    + 'For third-party apps authenticating with the authentication code, set to \`authorization_code\` . '
                    + 'For third-party apps authenticating with a refresh token, set to \`refresh_token\` .',
                example: 'client_credentials',
            },
            {
                name: 'redirect_uri',
                description: 'The redirect URI for third-party applications. Invalid on first-party applications.',
                example: 'https://mydomain.com/oauth_code',
            },
            {
                name: 'refresh_token',
                description: 'The user’s refresh token to generate a new access token and refresh token. ' +
                    'Each refresh token can only be used one, but will return a new refresh token to use. ' +
                    'Refresh tokens expire in 30 days. Required for \`grant_type=refresh_token\` , otherwise invalid.',
                example: 'c75742c98f382264fca6a0a5759354b6eb95ea1a7c44d0e0b22e36ff26f8',
            },
            {
                name: 'scope',
                description: 'The scope(s) that this session token should use. Must be a subset of the scopes defined in the app. ' +
                    'Write scopes automatically have read permission. Separate multiple scopes with spaces. Currently supporting:{NEWLINE} {NEWLINE}' +
                    '\`campaigns:read\`{NEWLINE}' +
                    '\`campaigns:write\`{NEWLINE}' +
                    '\`creatives:read\`{NEWLINE}' +
                    '\`creatives:write\`{NEWLINE}' +
                    '\`source_bids:read\`{NEWLINE}' +
                    '\`source_bids:write\`{NEWLINE} {NEWLINE}' +
                    'Required for \`grant_type=client_credentials\`{NEWLINE}' +
                    'Optional for \`grant_type=refresh_token\`{NEWLINE}' +
                    'Invalid for \`grant_type=authorization_code\`{NEWLINE}',
                example: 'campaigns:write creatives:write',
            },
        ],
        campaign_id: [
            {
                name: 'name',
                description: 'Campaign Name',
                example: '"Test Campaign - iOS"',
                extras: {
                    requiredOnCreate: 'TRUE',
                    requiredOnUpdate: 'FALSE',
                }
            },
            {
                name: 'campaign_id*',
                description: 'Unique Campaign Identifier',
                example: '"29d66efc22ae53a201e1532265b83f12"',
                extras: {
                    requiredOnUpdate: 'FALSE',
                    requiredOnCreate: 'TRUE',
                }
            },
            {
                name: 'package_name*',
                description: 'The Package Name of the promoted app. On iOS, use the numeric portion of the iTunes ID',
                example: '"123456789"',
                extras: {
                    requiredOnUpdate: 'TRUE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'bundle_id*',
                description: 'The Bundle ID of the promoted app (iOS only)',
                example: '"com.sample.app.ios"',
                extras: {
                    requiredOnUpdate: 'TRUE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'platform*',
                description: 'Platform of the promoted app (ios or android)',
                example: '"ios"',
                extras: {
                    requiredOnUpdate: 'TRUE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'category',
                description: 'Category of the campaign.',
                example: '"105"',
                extras: {
                    requiredOnUpdate: 'TRUE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'bid_type*',
                description: 'Bid Type of the campaign (CPI, CPP_GOAL, RET, CPE, ROAS_AD_BASED, ROAS_IAP)',
                example: '"CPI"',
                extras: {
                    requiredOnUpdate: 'TRUE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'tracking_method',
                description: 'The campaign tracking method. See ' +
                    '{the}(#table-of-tracking-methods)  ' +
                    '{full}(#table-of-tracking-methods)  ' +
                    '{list}(#table-of-tracking-methods)  ' +
                    '{of}(#table-of-tracking-methods)  ' +
                    '{tracking}(#table-of-tracking-methods)  ' +
                    '{methods}(#table-of-tracking-methods)  ' +
                    'in the appendix.',
                example: '"adjust"',
                extras: {
                    requiredOnUpdate: 'TRUE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'status',
                description: 'Whether the campaign is active or not',
                example: 'true',
                extras: {
                    requiredOnUpdate: 'FALSE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'created*',
                description: 'The date that the campaign was created.',
                example: '"2021-06-30 00:00:00"',
                extras: {
                    requiredOnUpdate: 'TRUE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'impressions*',
                description: 'Yesterday\'s impressions.',
                example: '125',
                extras: {
                    requiredOnUpdate: 'TRUE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'clicks*',
                description: 'Yesterday\'s clicks',
                example: '12',
                extras: {
                    requiredOnUpdate: 'TRUE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'installs*',
                description: 'Yesterday\'s installs.',
                example: '2',
                extras: {
                    requiredOnUpdate: 'FALSE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'spend*',
                description: 'Yesterday\'s spend.',
                example: '"2.5000"',
                extras: {
                    requiredOnUpdate: 'TRUE',
                    requiredOnCreate: 'FALSE',
                }
            },
            {
                name: 'goal_period*',
                description: 'Number of Days after install for goal to be measured. Possible values by bid_type are CPI: N/A; CPP: 7; CPE: 7; RET: 1, 3, 7; ROAS_AD_BASED: 0; ROAS_IAP: 0, 7.',
                example: '0',
                extras: {
                    requiredOnUpdate: 'FALSE',
                    requiredOnCreate: 'FALSE',
                }
            },
        ],
        // campaign : {
        //
        // },
        creative_set_id: [
            {
                name: 'ads*',
                description: 'Array of Ad objects associated with this Creative Set. ' +
                    'These objects have the same format ' +
                    'as the response body from the /ad/ad_id endpoint ' +
                    '(see {/ad/ad_id}(#/ad/ad_id)  below).',
                example: '',
            },
            {
                name: 'assets*',
                description: 'Array of Asset objects associated with this Creative Set. See table below.',
                example: '',
            },
            {
                name: 'campaign_id*',
                description: 'Campaign ID',
                example: '"29d66efc22ae53a201e1532265b83f12"',
            },
            {
                name: 'countries',
                description: 'Countries that this creative set should be restricted to (for example, for country-specific promotions). There is no need to duplicate campaign targeting on each creative set. If this list is blank, the campaign-defined countries will be eligible. If this list includes countries outside of what the campaign targets, those countries will not be eligible',
                example: '["za", "gb"]',
            },
            {
                name: 'languages',
                description: 'List of Languages. See ' +
                    '{the}(#language-codes)  ' +
                    '{table}(#language-codes)  ' +
                    '{below}(#language-codes)  ' +
                    'for a full list.',
                example: '',
            },
            {
                name: 'name',
                description: 'Creative Set Name',
                example: '',
            },
            {
                name: 'product_page',
                description: 'iOS Custom Product Page or Android Store Listing associated with the creative set',
                example: '"6f547204-b3b3-3b85-3057-452cfce08c60"',
            },
        ],
        asset_object_fields: [
            {
                name: 'asset',
                description: 'Asset URL, Hash, or text string',
                example: '"https://res1.applovin.com/oab49763/foobidyfoo_v23_phone.mp4"',
            },
            {
                name: 'status',
                description: 'The Campaign Management API processes assets asynchronously. ' +
                    'It begins by setting the status to processing and ' +
                    'finishes by setting it to either error or ready depending ' +
                    'on failure or success respectively.',
                example: '"processing", "error", "ready"',
            },
            {
                name: 'type',
                description: 'Asset Type, see ' +
                    '{the}(#asset-types)  ' +
                    '{table}(#asset-types)  ' +
                    '{below}(#asset-types)  ' +
                    'for possible asset types.',
                example: '"TXT_TITLE"',
            },
        ],
        response_asset_object_fields: [
            {
                name: 'asset',
                description: 'Asset URL, Hash, or text string',
                example: '"https://res1.applovin.com/oab49763/foobidyfoo_v23_phone.mp4"',
            },
            {
                name: 'status',
                description: 'The Campaign Management API processes assets asynchronously. ' +
                    'It begins by setting the status to processing and ' +
                    'finishes by setting it to either error or ready depending ' +
                    'on failure or success respectively.',
                example: '"processing", "error", "ready"',
            },
            {
                name: 'type',
                description: 'Asset Type, see ' +
                    '{the}(#asset-types)  ' +
                    '{table}(#asset-types)  ' +
                    '{below}(#asset-types)  ' +
                    'for possible asset types.',
                example: '"TXT_TITLE"',
            },
        ],
        request_asset_form_fields: [
            {
                name: '*remove',
                description: '(Optional) Pass in ‘true’ to remove asset type',
                example: '‘true’ or ‘false’',
            },
            {
                name: 'update',
                description: '(Optional) Pass in ‘true’ to update asset type',
                example: '‘true’ or ‘false’',
            },
            {
                name: '***type',
                description: 'Asset Type, see ' +
                    '{the}(#asset-types)  ' +
                    '{table}(#asset-types)  ' +
                    '{below}(#asset-types)  ' +
                    'for possible asset types.',
                example: '"TXT_TITLE"',
            },
            {
                name: '**asset',
                description: 'Asset URL, hash, or text string.',
                example: '"https://res1.applovin.com/ob7cb6fc/foobidyfoo_v23_phone.mp4"{SPACE}"3f5a01dc0980f3d04188e73e91c"{SPACE}' +
                    '"Best app you’ll ever play"',
            },
            {
                name: '***file',
                description: 'Image, video, or html file.',
                example: 'See requirements below',
            },
        ],
        ad_id: [
            {
                name: 'name',
                description: 'Ad name',
            },
            {
                name: 'id*',
                description: 'Ad ID',
            },
            {
                name: 'creative_set_name*',
                description: 'Parent creative set name',
            },
            {
                name: 'creative_set_id*',
                description: 'Parent creative set ID.',
            },
            {
                name: 'size*',
                description: 'Ad size: one of BANNER, INTER, LEADER, MREC, NATIVE, or WIDGET.',
            },
            {
                name: 'status',
                description: 'Whether the ad is active (true) or not (false)',
            },
            {
                name: 'template*',
                description: 'Ad template.',
            },
        ],
        campaign_target_campaign_ids: [
            {
                name: 'bid_type*',
                description: 'Type of bid used in this campaign. Same as what is set on the campaign object.',
                example: 'CPI',
            },
            {
                name: 'countries',
                description: 'List of Countries Objects. See below.',
                example: 'See Table Below',
            },
            {
                name: 'device_types',
                description: 'List of eligible device types. Empty list means all device types are eligible. Options are: "phone", "tablet", "other". Only supported on iOS.',
                example: '["phone", "other"]',
            },
            {
                name: 'os_major_version_min',
                description: 'Lowest OS version that the campaign is eligible to serve on. 10 means 10.0 and above.',
                example: '9',
            },
        ],
        country_objects: [
            {
                name: 'country',
                description: '"DEFAULT" or two-letter country code',
                example: '"gb"',
            },
            {
                name: 'budget',
                description: 'Daily budget (USD)',
                example: '1000',
            },
            {
                name: 'bid',
                description: 'The bid value of that country. On CPI campaigns, this is the CPI in USD. For RET, ROAS_AD_BASED, ' +
                    'and ROAS_IAP, this is the percent goal (50=50%). For CPP and CPE, this is the goal event value in USD',
                example: '2.9',
            },
            {
                name: 'impression_url',
                description: 'Impression Tracking URL.',
                example: 'https://app.adjust.com/123abc?campaign=' +
                    '{CAMPAIGN_NAME}%20({CAMPAIGN_ID})&gps_adid={IDFA}',
            },
            {
                name: 'click_url',
                description: 'Click Tracking URL.',
                example: 'https://s2s.adjust.com/impression/123abc?campaign=' +
                    '{CAMPAIGN_NAME}%20({CAMPAIGN_ID})&gps_adid={IDFA}',
            },
            {
                name: 'disabled',
                description: 'The API will only return active countries, but to disable countries, set this value to true on update.',
                example: 'false',
            },
        ],
        categories: [
            {
                name: 'disabled',
                description: 'The API will only return active countries, but to disable countries, set this value to true on update.',
                example: 'false',
                extras: {
                    categoryId: 'dwa',
                    categoryName: 'dwadaw'
                }
            },
        ],
        source_bids_campaign_ids: [
            {
                name: 'app_id*',
                description: 'The app that should receive an overridden bid',
                example: '"da605e6f950f1aec838816df845e95e0c8d5cb7a994d71ae0ef2"',
            },
            {
                name: 'app_id_external**',
                description: 'The External App ID (Read Only)',
                example: '"f950f1aec838816df845e95e0c8da605e6"',
            },
            {
                name: 'bid_override_percentage***',
                description: 'The percent over (or under) the bid that the campaign would use otherwise. \`"100"\` means twice the bid. \`"default"\` uses the campaign default or the \`bid_value\`',
                example: '10'
            },
            {
                name: 'bid_value***',
                description: 'The overridden bid value. \`"default"\` uses the campaign default or the \`bid_override_percentage\`',
                example: '1.2345'
            },
            {
                name: 'country',
                description: 'two-letter country code',
                example: '"gb"'
            }
        ],
        source_bids_campaign_ids_pagination: [
            {
                name: 'total_row_count',
                description: 'Number of source bid overrides associated with this campaign',
                example: '8192'
            },
            {
                name: 'limit',
                description: 'Number of rows to return in this response. Useful for pagination through large responses',
                example: '5000'
            },
            {
                name: 'offset',
                description: 'Number of rows in the data set this response should skip. Useful for pagination through large responses',
                example: '15000'
            },
            {
                name: 'source_bids',
                description: 'list of source bids. See  {Table}(#table-of-/source_bids/campaign_id-request/response-body-fields)  {of}(#table-of-/source_bids/campaign_id-request/response-body-fields)  {/source_bids/campaign_id}(#table-of-/source_bids/campaign_id-request/response-body-fields)  {Request/Response}(#table-of-/source_bids/campaign_id-request/response-body-fields)  {Body}(#table-of-/source_bids/campaign_id-request/response-body-fields)  {Fields}(#table-of-/source_bids/campaign_id-request/response-body-fields)  for field definition',
                example: ''
            }
        ],
        sources: [
            {
                name: 'app_id*',
                description: 'The reference to the app that can be toggled',
                example: 'da605e6f950f1aec838816df845e95e0c8d5cb7a994d71ae0ef2'
            },
            {
                name: 'app_id_external**',
                description: 'The External App ID (Read Only)',
                example: 'f950f1aec838816df845e95e0c8da605e6'
            },
            {
                name: 'status',
                description: 'Whether the app is active or not',
                example: 'true'
            },
        ],
        sources_campaign_ids_pagination: [
            {
                name: 'total_row_count',
                description: 'Number of source bid overrides associated with this campaign',
                example: '8192'
            },
            {
                name: 'limit',
                description: 'Number of rows to return in this response. Useful for pagination through large responses',
                example: '5000'
            },
            {
                name: 'offset',
                description: 'Number of rows in the data set this response should skip. Useful for pagination through large responses',
                example: '15000'
            },
            {
                name: 'sources',
                description: 'list of sources. See  {Table}(#table-of-/sources/campaign_id-request/response-body-fields)  {of}(#table-of-/sources/campaign_id-request/response-body-fields)  {/sources/campaign_id}(#table-of-/sources/campaign_id-request/response-body-fields)  {Request/Response}(#table-of-/sources/campaign_id-request/response-body-fields)  {Body}(#table-of-/sources/campaign_id-request/response-body-fields)  {Fields}(#table-of-/sources/campaign_id-request/response-body-fields)  for field definition',
                example: ''
            }
        ]
    }
};

export const CREATIVE_ID_ITEMS = [
    {
        name: 'AppLovin',
        adFormats: [ AdTypes.INTER, AdTypes.REWARD ],
        adCallback: 'Ad Loaded',
        androidVersion: '9.15.0',
        iosVersion: '6.15.0',
    },
    {
        name: 'Amazon',
        adFormats: [ AdTypes.BANNER, AdTypes.MREC, AdTypes.INTER, AdTypes.REWARD ],
        adCallback: 'Ad Loaded',
        androidVersion: '9.6.2.1',
        iosVersion: '4.5.6.1',
    },
    {
        name: 'BidMachine',
        adFormats: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        adCallback: 'Ad Loaded',
        androidVersion: '1.9.4.2',
        iosVersion: '1.9.4.1.2'
    },
    {
        name: 'Chartboost',
        adFormats: [ AdTypes.INTER, AdTypes.REWARD ],
        adCallback: 'N/A',
        androidVersion: 'N/A',
        iosVersion: '8.4.0.1',
    },
    {
        name: 'DT Exchange',
        adFormats: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        adCallback: 'Ad Displayed',
        androidVersion: '7.7.4.1',
        iosVersion: '7.8.0.1',
    },
    {
        name: 'Google Ad Manager',
        adFormats: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        adCallback: 'Ad Loaded',
        androidVersion: '19.6.0.2',
        iosVersion: '7.69.0.1',
    },
    {
        name: 'Google bidding and Google AdMob',
        adFormats: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        adCallback: 'Ad Loaded',
        androidVersion: '19.6.0.2',
        iosVersion: '7.69.0.1',
    },
    {
        name: 'InMobi',
        adFormats: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        adCallback: 'Ad Loaded',
        androidVersion: '9.1.1.3',
        iosVersion: '9.1.1.1',
    },
    {
        name: 'Liftoff Monetize',
        adFormats: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        adCallback: 'Ad Displayed',
        androidVersion: '6.10.1.0',
        iosVersion: '6.8.1.3',
    },
    {
        name: 'Liftoff Monetize',
        adFormats: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        adCallback: 'Ad Loaded',
        androidVersion: '7.1.0.0',
        iosVersion: '7.2.0.0',
    },
    {
        name: 'Meta Audience Network',
        adFormats: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        adCallback: 'Ad Loaded',
        androidVersion: 'All',
        iosVersion: 'All',
    },
    {
        name: 'Mintegral',
        adFormats: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        adCallback: 'Ad Loaded',
        androidVersion: '15.4.31.1',
        iosVersion: '6.7.5.0.1',
    },
    {
        name: 'Pangle',
        adFormats: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.REWARD ],
        adCallback: 'Ad Loaded',
        androidVersion: 'All',
        iosVersion: 'All',
    },
    {
        name: 'Smaato',
        adFormats: [ AdTypes.BANNER, AdTypes.INTER, AdTypes.MREC, AdTypes.NATIVE, AdTypes.REWARD ],
        adCallback: 'Ad Loaded',
        androidVersion: '21.5.7.1',
        iosVersion: '21.6.10.1',
    }
]
